(function (root) {
  root.FleurySearchFormatCatalog = {
  "schemaVersion": 3,
  "generatedAt": "2026-11-02T18:51:58.562Z",
  "source": "Current active Online Store products; search exclusion tags respected; read-only Shopify export; additive approved stretcher-bar collection gid://shopify/Collection/427187011869",
  "counts": {
    "targetProducts": 511,
    "rectangleFormats": 190,
    "galleryProducts": 190,
    "studioVariants": 30,
    "shadowProducts": 66,
    "accessories": 2,
    "roundVariants": 11,
    "standardProducts": 448,
    "candidateVariants": 487,
    "barsProducts": 190
  },
  "rectangles": {
    "15x15": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-15x15cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x15cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-15-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-15-cm-qualite-galerie",
            "it": "telaio-telato-15-x-15-cm-qualita-gallery"
          },
          "productId": "7999713771805",
          "family": "gallery",
          "variantIds": [
            "43945625714973"
          ],
          "available": true,
          "variantId": "43945625714973"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-15x15-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x15-cm-4cm",
            "en": "canvas-frame-15x15-cm-4cm",
            "fr": "chassis-15x15-cm-4cm",
            "it": "telaio-15x15-cm-4cm"
          },
          "productId": "7999329927453",
          "family": "bars",
          "variantIds": [
            "43728383312157"
          ],
          "available": true,
          "variantId": "43728383312157"
        }
      ]
    },
    "15x20": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-15x20-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x20-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-20-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-20-cm-qualite-galerie",
            "it": "telaio-telato-15-x-20-cm-qualita-gallery"
          },
          "productId": "7999139447069",
          "family": "gallery",
          "variantIds": [
            "43727948185885"
          ],
          "available": true,
          "variantId": "43727948185885"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-15x20-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x20-cm-4cm",
            "en": "canvas-frame-15x20-cm-4cm",
            "fr": "chassis-15x20-cm-4cm",
            "it": "telaio-15x20-cm-4cm"
          },
          "productId": "7999330353437",
          "family": "bars",
          "variantIds": [
            "43728383967517"
          ],
          "available": true,
          "variantId": "43728383967517"
        }
      ]
    },
    "15x30": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-15x30-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x30-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-30-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-30-cm-qualite-galerie",
            "it": "telaio-telato-15-x-30-cm-qualita-gallery"
          },
          "productId": "7999140331805",
          "family": "gallery",
          "variantIds": [
            "43727948906781"
          ],
          "available": true,
          "variantId": "43727948906781"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-15x30-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x30-cm-4cm",
            "en": "canvas-frame-15x30-cm-4cm",
            "fr": "chassis-15x30-cm-4cm",
            "it": "telaio-15x30-cm-4cm"
          },
          "productId": "7999331041565",
          "family": "bars",
          "variantIds": [
            "43728384917789"
          ],
          "available": true,
          "variantId": "43728384917789"
        }
      ]
    },
    "15x40": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-15x40-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x40-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-40-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-40-cm-qualite-galerie",
            "it": "telaio-telato-15-x-40-cm-qualita-gallery"
          },
          "productId": "7999141380381",
          "family": "gallery",
          "variantIds": [
            "43727949529373"
          ],
          "available": true,
          "variantId": "43727949529373"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-15x40-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x40-cm-4cm",
            "en": "canvas-frame-15x40-cm-4cm",
            "fr": "chassis-15x40-cm-4cm",
            "it": "telaio-15x40-cm-4cm"
          },
          "productId": "7999331467549",
          "family": "bars",
          "variantIds": [
            "43728385343773"
          ],
          "available": true,
          "variantId": "43728385343773"
        }
      ]
    },
    "15x50": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-15x50-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x50-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-50-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-50-cm-qualite-galerie",
            "it": "telaio-telato-15-x-50-cm-qualita-gallery"
          },
          "productId": "7999141904669",
          "family": "gallery",
          "variantIds": [
            "43727950184733"
          ],
          "available": true,
          "variantId": "43727950184733"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-15x50-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x50-cm-4cm",
            "en": "canvas-frame-15x50-cm-4cm",
            "fr": "chassis-15x50-cm-4cm",
            "it": "telaio-15x50-cm-4cm"
          },
          "productId": "7999332024605",
          "family": "bars",
          "variantIds": [
            "43728386195741"
          ],
          "available": true,
          "variantId": "43728386195741"
        }
      ]
    },
    "15x60": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-15x60-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x60-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-60-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-60-cm-qualite-galerie",
            "it": "telaio-telato-15-x-60-cm-qualita-gallery"
          },
          "productId": "7999142428957",
          "family": "gallery",
          "variantIds": [
            "43727950905629"
          ],
          "available": true,
          "variantId": "43727950905629"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-15x60-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x60-cm-4cm",
            "en": "canvas-frame-15x60-cm-4cm",
            "fr": "chassis-15x60-cm-4cm",
            "it": "telaio-15x60-cm-4cm"
          },
          "productId": "7999332450589",
          "family": "bars",
          "variantIds": [
            "43728387080477"
          ],
          "available": true,
          "variantId": "43728387080477"
        }
      ]
    },
    "15x70": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-15x70-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x70-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-70-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-70-cm-qualite-galerie",
            "it": "telaio-telato-15-x-70-cm-qualita-gallery"
          },
          "productId": "7999143117085",
          "family": "gallery",
          "variantIds": [
            "43727951692061"
          ],
          "available": true,
          "variantId": "43727951692061"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-15x70-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x70-cm-4cm",
            "en": "canvas-frame-15x70-cm-4cm",
            "fr": "chassis-15x70-cm-4cm",
            "it": "telaio-15x70-cm-4cm"
          },
          "productId": "7999333007645",
          "family": "bars",
          "variantIds": [
            "43728387932445"
          ],
          "available": true,
          "variantId": "43728387932445"
        }
      ]
    },
    "15x80": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-15x80-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x80-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-80-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-80-cm-qualite-galerie",
            "it": "telaio-telato-15-x-80-cm-qualita-gallery"
          },
          "productId": "7999143608605",
          "family": "gallery",
          "variantIds": [
            "43727952183581"
          ],
          "available": true,
          "variantId": "43727952183581"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-15x80-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x80-cm-4cm",
            "en": "canvas-frame-15x80-cm-4cm",
            "fr": "chassis-15x80-cm-4cm",
            "it": "telaio-15x80-cm-4cm"
          },
          "productId": "7999333499165",
          "family": "bars",
          "variantIds": [
            "43728388653341"
          ],
          "available": true,
          "variantId": "43728388653341"
        }
      ]
    },
    "15x90": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-15x90-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x90-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-90-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-90-cm-qualite-galerie",
            "it": "telaio-telato-15-x-90-cm-qualita-gallery"
          },
          "productId": "7999144198429",
          "family": "gallery",
          "variantIds": [
            "43727952838941"
          ],
          "available": true,
          "variantId": "43727952838941"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-15x90-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x90-cm-4cm",
            "en": "canvas-frame-15x90-cm-4cm",
            "fr": "chassis-15x90-cm-4cm",
            "it": "telaio-15x90-cm-4cm"
          },
          "productId": "7999334056221",
          "family": "bars",
          "variantIds": [
            "43728389407005"
          ],
          "available": true,
          "variantId": "43728389407005"
        }
      ]
    },
    "15x100": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-15x100-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x100-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-100-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-100-cm-qualite-galerie",
            "it": "telaio-telato-15-x-100-cm-qualita-gallery"
          },
          "productId": "7999144657181",
          "family": "gallery",
          "variantIds": [
            "43727953363229"
          ],
          "available": true,
          "variantId": "43727953363229"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-15x100-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x100-cm-4cm",
            "en": "canvas-frame-15x100-cm-4cm",
            "fr": "chassis-15x100-cm-4cm",
            "it": "telaio-15x100-cm-4cm"
          },
          "productId": "7999334580509",
          "family": "bars",
          "variantIds": [
            "43728390160669"
          ],
          "available": true,
          "variantId": "43728390160669"
        }
      ]
    },
    "15x110": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-15x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-110-cm-qualite-galerie",
            "it": "telaio-telato-15-x-110-cm-qualita-gallery"
          },
          "productId": "7999145214237",
          "family": "gallery",
          "variantIds": [
            "43727953953053"
          ],
          "available": true,
          "variantId": "43727953953053"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-15x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x110-cm-4cm",
            "en": "canvas-frame-15x110-cm-4cm",
            "fr": "chassis-15x110-cm-4cm",
            "it": "telaio-15x110-cm-4cm"
          },
          "productId": "7999335170333",
          "family": "bars",
          "variantIds": [
            "43728393601309"
          ],
          "available": true,
          "variantId": "43728393601309"
        }
      ]
    },
    "15x120": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-15x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-120-cm-qualite-galerie",
            "it": "telaio-telato-15-x-120-cm-qualita-gallery"
          },
          "productId": "7999145738525",
          "family": "gallery",
          "variantIds": [
            "43727954575645"
          ],
          "available": true,
          "variantId": "43727954575645"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-15x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x120-cm-4cm",
            "en": "canvas-frame-15x120-cm-4cm",
            "fr": "chassis-15x120-cm-4cm",
            "it": "telaio-15x120-cm-4cm"
          },
          "productId": "7999335596317",
          "family": "bars",
          "variantIds": [
            "43728394354973"
          ],
          "available": true,
          "variantId": "43728394354973"
        }
      ]
    },
    "15x130": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-15x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-130-cm-qualite-galerie",
            "it": "telaio-telato-15-x-130-cm-qualita-gallery"
          },
          "productId": "7999146295581",
          "family": "gallery",
          "variantIds": [
            "43727955165469"
          ],
          "available": true,
          "variantId": "43727955165469"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-15x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x130-cm-4cm",
            "en": "canvas-frame-15x130-cm-4cm",
            "fr": "chassis-15x130-cm-4cm",
            "it": "telaio-15x130-cm-4cm"
          },
          "productId": "7999336055069",
          "family": "bars",
          "variantIds": [
            "43728395043101"
          ],
          "available": true,
          "variantId": "43728395043101"
        }
      ]
    },
    "15x140": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-15x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-140-cm-qualite-galerie",
            "it": "telaio-telato-15-x-140-cm-qualita-gallery"
          },
          "productId": "7999146819869",
          "family": "gallery",
          "variantIds": [
            "43727955820829"
          ],
          "available": true,
          "variantId": "43727955820829"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-15x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x140-cm-4cm",
            "en": "canvas-frame-15x140-cm-4cm",
            "fr": "chassis-15x140-cm-4cm",
            "it": "telaio-15x140-cm-4cm"
          },
          "productId": "7999336546589",
          "family": "bars",
          "variantIds": [
            "43728395763997"
          ],
          "available": true,
          "variantId": "43728395763997"
        }
      ]
    },
    "15x150": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-15x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-150-cm-qualite-galerie",
            "it": "telaio-telato-15-x-150-cm-qualita-gallery"
          },
          "productId": "7999147442461",
          "family": "gallery",
          "variantIds": [
            "43727956574493"
          ],
          "available": true,
          "variantId": "43727956574493"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-15x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x150-cm-4cm",
            "en": "canvas-frame-15x150-cm-4cm",
            "fr": "chassis-15x150-cm-4cm",
            "it": "telaio-15x150-cm-4cm"
          },
          "productId": "7999337201949",
          "family": "bars",
          "variantIds": [
            "43728396681501"
          ],
          "available": true,
          "variantId": "43728396681501"
        }
      ]
    },
    "15x160": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-15x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-160-cm-qualite-galerie",
            "it": "telaio-telato-15-x-160-cm-qualita-gallery"
          },
          "productId": "7999147835677",
          "family": "gallery",
          "variantIds": [
            "43727956967709"
          ],
          "available": true,
          "variantId": "43727956967709"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-15x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x160-cm-4cm",
            "en": "canvas-frame-15x160-cm-4cm",
            "fr": "chassis-15x160-cm-4cm",
            "it": "telaio-15x160-cm-4cm"
          },
          "productId": "7999337693469",
          "family": "bars",
          "variantIds": [
            "43728397140253"
          ],
          "available": true,
          "variantId": "43728397140253"
        }
      ]
    },
    "15x170": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-15x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-170-cm-qualite-galerie",
            "it": "telaio-telato-15-x-170-cm-qualita-gallery"
          },
          "productId": "7999148425501",
          "family": "gallery",
          "variantIds": [
            "43727957688605"
          ],
          "available": true,
          "variantId": "43727957688605"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-15x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x170-cm-4cm",
            "en": "canvas-frame-15x170-cm-4cm",
            "fr": "chassis-15x170-cm-4cm",
            "it": "telaio-15x170-cm-4cm"
          },
          "productId": "7999338250525",
          "family": "bars",
          "variantIds": [
            "43728397992221"
          ],
          "available": true,
          "variantId": "43728397992221"
        }
      ]
    },
    "15x180": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-15x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-180-cm-qualite-galerie",
            "it": "telaio-telato-15-x-180-cm-qualita-gallery"
          },
          "productId": "7999149080861",
          "family": "gallery",
          "variantIds": [
            "43727958409501"
          ],
          "available": true,
          "variantId": "43727958409501"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-15x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x180-cm-4cm",
            "en": "canvas-frame-15x180-cm-4cm",
            "fr": "chassis-15x180-cm-4cm",
            "it": "telaio-15x180-cm-4cm"
          },
          "productId": "7999338873117",
          "family": "bars",
          "variantIds": [
            "43728398614813"
          ],
          "available": true,
          "variantId": "43728398614813"
        }
      ]
    },
    "15x195": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-15x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-195-cm-qualite-galerie",
            "it": "telaio-telato-15-x-195-cm-qualita-gallery"
          },
          "productId": "7999149703453",
          "family": "gallery",
          "variantIds": [
            "43727959064861"
          ],
          "available": true,
          "variantId": "43727959064861"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-15x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x195-cm-4cm",
            "en": "canvas-frame-15x195-cm-4cm",
            "fr": "chassis-15x195-cm-4cm",
            "it": "telaio-15x195-cm-4cm"
          },
          "productId": "7999339561245",
          "family": "bars",
          "variantIds": [
            "43728399991069"
          ],
          "available": true,
          "variantId": "43728399991069"
        }
      ]
    },
    "20x20": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-20x20-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x20-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-20-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-20-cm-qualite-galerie",
            "it": "telaio-telato-20-x-20-cm-qualita-gallery"
          },
          "productId": "7999150260509",
          "family": "gallery",
          "variantIds": [
            "43727959654685"
          ],
          "available": true,
          "variantId": "43727959654685"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305074973"
          ],
          "available": true,
          "variantId": "49195305074973"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-20x20-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x20-cm-roh",
            "en": "floating-frame-set-20x20-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x20-cm-brut",
            "it": "set-cornice-a-cassetta-20x20-cm-grezzo"
          },
          "productId": "7999051628829",
          "family": "shadow",
          "variantIds": [
            "43727748170013"
          ],
          "available": true,
          "variantId": "43727748170013"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-20x20-cm-4cm-1",
          "handles": {
            "de": "keilrahmen-20x20-cm-4cm-1",
            "en": "canvas-frame-20x20-cm-4cm",
            "fr": "chassis-20x20-cm-4cm",
            "it": "telaio-20x20-cm-4cm"
          },
          "productId": "7999340019997",
          "family": "bars",
          "variantIds": [
            "43728400875805"
          ],
          "available": true,
          "variantId": "43728400875805"
        }
      ]
    },
    "20x30": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-20x30-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x30-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-30-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-30-cm-qualite-galerie",
            "it": "telaio-telato-20-x-30-cm-qualita-gallery"
          },
          "productId": "7999150719261",
          "family": "gallery",
          "variantIds": [
            "43727960146205"
          ],
          "available": true,
          "variantId": "43727960146205"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305402653"
          ],
          "available": true,
          "variantId": "49195305402653"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-20x30-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x30-cm-roh",
            "en": "floating-frame-set-20x30-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x30-cm-brut",
            "it": "set-cornice-a-cassetta-20x30-cm-grezzo"
          },
          "productId": "7999051727133",
          "family": "shadow",
          "variantIds": [
            "43727748268317"
          ],
          "available": true,
          "variantId": "43727748268317"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-20x30-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x30-cm-4cm",
            "en": "canvas-frame-20x30-cm-4cm",
            "fr": "chassis-20x30-cm-4cm",
            "it": "telaio-20x30-cm-4cm"
          },
          "productId": "7999340478749",
          "family": "bars",
          "variantIds": [
            "43728401334557"
          ],
          "available": true,
          "variantId": "43728401334557"
        }
      ]
    },
    "20x40": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-20x40-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x40-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-40-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-40-cm-qualite-galerie",
            "it": "telaio-telato-20-x-40-cm-qualita-gallery"
          },
          "productId": "7999151407389",
          "family": "gallery",
          "variantIds": [
            "43727961948445"
          ],
          "available": true,
          "variantId": "43727961948445"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-20x40-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x40-cm-roh",
            "en": "floating-frame-set-20x40-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x40-cm-brut",
            "it": "set-cornice-a-cassetta-20x40-cm-grezzo"
          },
          "productId": "7999051858205",
          "family": "shadow",
          "variantIds": [
            "43727748595997"
          ],
          "available": true,
          "variantId": "43727748595997"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-20x40-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x40-cm-4cm",
            "en": "canvas-frame-20x40-cm-4cm",
            "fr": "chassis-20x40-cm-4cm",
            "it": "telaio-20x40-cm-4cm"
          },
          "productId": "7999340904733",
          "family": "bars",
          "variantIds": [
            "43728401760541"
          ],
          "available": true,
          "variantId": "43728401760541"
        }
      ]
    },
    "20x50": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-20x50-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x50-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-50-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-50-cm-qualite-galerie",
            "it": "telaio-telato-20-x-50-cm-qualita-gallery"
          },
          "productId": "7999151997213",
          "family": "gallery",
          "variantIds": [
            "43727964340509"
          ],
          "available": true,
          "variantId": "43727964340509"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-20x50-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x50-cm-roh",
            "en": "floating-frame-set-20x50-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x50-cm-brut",
            "it": "set-cornice-a-cassetta-20x50-cm-grezzo"
          },
          "productId": "7999051989277",
          "family": "shadow",
          "variantIds": [
            "43727748923677"
          ],
          "available": true,
          "variantId": "43727748923677"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-20x50-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x50-cm-4cm",
            "en": "canvas-frame-20x50-cm-4cm",
            "fr": "chassis-20x50-cm-4cm",
            "it": "telaio-20x50-cm-4cm"
          },
          "productId": "7999341625629",
          "family": "bars",
          "variantIds": [
            "43728402776349"
          ],
          "available": true,
          "variantId": "43728402776349"
        }
      ]
    },
    "20x60": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-20x60-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x60-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-60-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-60-cm-qualite-galerie",
            "it": "telaio-telato-20-x-60-cm-qualita-gallery"
          },
          "productId": "7999152619805",
          "family": "gallery",
          "variantIds": [
            "43727965356317"
          ],
          "available": true,
          "variantId": "43727965356317"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-20x60-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x60-cm-roh",
            "en": "floating-frame-set-20x60-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x60-cm-brut",
            "it": "set-cornice-a-cassetta-20x60-cm-grezzo"
          },
          "productId": "7999052120349",
          "family": "shadow",
          "variantIds": [
            "43727749284125"
          ],
          "available": true,
          "variantId": "43727749284125"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-20x60-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x60-cm-4cm",
            "en": "canvas-frame-20x60-cm-4cm",
            "fr": "chassis-20x60-cm-4cm",
            "it": "telaio-20x60-cm-4cm"
          },
          "productId": "7999342215453",
          "family": "bars",
          "variantIds": [
            "43728405823773"
          ],
          "available": true,
          "variantId": "43728405823773"
        }
      ]
    },
    "20x70": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-20x70-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x70-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-70-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-70-cm-qualite-galerie",
            "it": "telaio-telato-20-x-70-cm-qualita-gallery"
          },
          "productId": "7999153275165",
          "family": "gallery",
          "variantIds": [
            "43727966208285"
          ],
          "available": true,
          "variantId": "43727966208285"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-20x70-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x70-cm-roh",
            "en": "floating-frame-set-20x70-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x70-cm-brut",
            "it": "set-cornice-a-cassetta-20x70-cm-grezzo"
          },
          "productId": "7999052284189",
          "family": "shadow",
          "variantIds": [
            "43727749644573"
          ],
          "available": true,
          "variantId": "43727749644573"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-20x70-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x70-cm-4cm",
            "en": "canvas-frame-20x70-cm-4cm",
            "fr": "chassis-20x70-cm-4cm",
            "it": "telaio-20x70-cm-4cm"
          },
          "productId": "7999342772509",
          "family": "bars",
          "variantIds": [
            "43728409461021"
          ],
          "available": true,
          "variantId": "43728409461021"
        }
      ]
    },
    "20x80": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-20x80-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x80-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-80-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-80-cm-qualite-galerie",
            "it": "telaio-telato-20-x-80-cm-qualita-gallery"
          },
          "productId": "7999153930525",
          "family": "gallery",
          "variantIds": [
            "43727966896413"
          ],
          "available": true,
          "variantId": "43727966896413"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-20x80-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x80-cm-roh",
            "en": "floating-frame-set-20x80-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x80-cm-brut",
            "it": "set-cornice-a-cassetta-20x80-cm-grezzo"
          },
          "productId": "7999052382493",
          "family": "shadow",
          "variantIds": [
            "43727749939485"
          ],
          "available": true,
          "variantId": "43727749939485"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-20x80-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x80-cm-4cm",
            "en": "canvas-frame-20x80-cm-4cm",
            "fr": "chassis-20x80-cm-4cm",
            "it": "telaio-20x80-cm-4cm"
          },
          "productId": "7999343427869",
          "family": "bars",
          "variantIds": [
            "43728412279069"
          ],
          "available": true,
          "variantId": "43728412279069"
        }
      ]
    },
    "20x90": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-20x90-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x90-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-90-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-90-cm-qualite-galerie",
            "it": "telaio-telato-20-x-90-cm-qualita-gallery"
          },
          "productId": "7999154520349",
          "family": "gallery",
          "variantIds": [
            "43727967584541"
          ],
          "available": true,
          "variantId": "43727967584541"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-20x90-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x90-cm-roh",
            "en": "floating-frame-set-20x90-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x90-cm-brut",
            "it": "set-cornice-a-cassetta-20x90-cm-grezzo"
          },
          "productId": "7999052513565",
          "family": "shadow",
          "variantIds": [
            "43727751348509"
          ],
          "available": true,
          "variantId": "43727751348509"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-20x90-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x90-cm-4cm",
            "en": "canvas-frame-20x90-cm-4cm",
            "fr": "chassis-20x90-cm-4cm",
            "it": "telaio-20x90-cm-4cm"
          },
          "productId": "7999344050461",
          "family": "bars",
          "variantIds": [
            "43728413131037"
          ],
          "available": true,
          "variantId": "43728413131037"
        }
      ]
    },
    "20x100": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-20x100-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x100-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-100-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-100-cm-qualite-galerie",
            "it": "telaio-telato-20-x-100-cm-qualita-gallery"
          },
          "productId": "7999155142941",
          "family": "gallery",
          "variantIds": [
            "43727968370973"
          ],
          "available": true,
          "variantId": "43727968370973"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-20x100-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x100-cm-roh",
            "en": "floating-frame-set-20x100-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x100-cm-brut",
            "it": "set-cornice-a-cassetta-20x100-cm-grezzo"
          },
          "productId": "7999052579101",
          "family": "shadow",
          "variantIds": [
            "43727751414045"
          ],
          "available": true,
          "variantId": "43727751414045"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-20x100-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x100-cm-4cm",
            "en": "canvas-frame-20x100-cm-4cm",
            "fr": "chassis-20x100-cm-4cm",
            "it": "telaio-20x100-cm-4cm"
          },
          "productId": "7999344640285",
          "family": "bars",
          "variantIds": [
            "43728413851933"
          ],
          "available": true,
          "variantId": "43728413851933"
        }
      ]
    },
    "20x110": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-20x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-110-cm-qualite-galerie",
            "it": "telaio-telato-20-x-110-cm-qualita-gallery"
          },
          "productId": "7999155732765",
          "family": "gallery",
          "variantIds": [
            "43727968960797"
          ],
          "available": true,
          "variantId": "43727968960797"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-20x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x110-cm-4cm",
            "en": "canvas-frame-20x110-cm-4cm",
            "fr": "chassis-20x110-cm-4cm",
            "it": "telaio-20x110-cm-4cm"
          },
          "productId": "7999345262877",
          "family": "bars",
          "variantIds": [
            "43728414998813"
          ],
          "available": true,
          "variantId": "43728414998813"
        }
      ]
    },
    "20x120": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-20x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-120-cm-qualite-galerie",
            "it": "telaio-telato-20-x-120-cm-qualita-gallery"
          },
          "productId": "7999156355357",
          "family": "gallery",
          "variantIds": [
            "43727969747229"
          ],
          "available": true,
          "variantId": "43727969747229"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-20x120-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x120-cm-roh",
            "en": "floating-frame-set-20x120-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x120-cm-brut",
            "it": "set-cornice-a-cassetta-20x120-cm-grezzo"
          },
          "productId": "7999052710173",
          "family": "shadow",
          "variantIds": [
            "43727751741725"
          ],
          "available": true,
          "variantId": "43727751741725"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-20x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x120-cm-4cm",
            "en": "canvas-frame-20x120-cm-4cm",
            "fr": "chassis-20x120-cm-4cm",
            "it": "telaio-20x120-cm-4cm"
          },
          "productId": "7999345623325",
          "family": "bars",
          "variantIds": [
            "43916978290973"
          ],
          "available": true,
          "variantId": "43916978290973"
        }
      ]
    },
    "20x130": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-20x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-130-cm-qualite-galerie",
            "it": "telaio-telato-20-x-130-cm-qualita-gallery"
          },
          "productId": "7999156912413",
          "family": "gallery",
          "variantIds": [
            "43727972827421"
          ],
          "available": true,
          "variantId": "43727972827421"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-20x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x130-cm-4cm",
            "en": "canvas-frame-20x130-cm-4cm",
            "fr": "chassis-20x130-cm-4cm",
            "it": "telaio-20x130-cm-4cm"
          },
          "productId": "7999346245917",
          "family": "bars",
          "variantIds": [
            "43916979142941"
          ],
          "available": true,
          "variantId": "43916979142941"
        }
      ]
    },
    "20x140": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-20x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-140-cm-qualite-galerie",
            "it": "telaio-telato-20-x-140-cm-qualita-gallery"
          },
          "productId": "7999157502237",
          "family": "gallery",
          "variantIds": [
            "43727973417245"
          ],
          "available": true,
          "variantId": "43727973417245"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-20x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x140-cm-roh",
            "en": "floating-frame-set-20x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x140-cm-brut",
            "it": "set-cornice-a-cassetta-20x140-cm-grezzo"
          },
          "productId": "7999052841245",
          "family": "shadow",
          "variantIds": [
            "43727752266013"
          ],
          "available": false,
          "variantId": "43727752266013"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-20x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x140-cm-4cm",
            "en": "canvas-frame-20x140-cm-4cm",
            "fr": "chassis-20x140-cm-4cm",
            "it": "telaio-20x140-cm-4cm"
          },
          "productId": "7999346737437",
          "family": "bars",
          "variantIds": [
            "43916979896605"
          ],
          "available": true,
          "variantId": "43916979896605"
        }
      ]
    },
    "20x150": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-20x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-150-cm-qualite-galerie",
            "it": "telaio-telato-20-x-150-cm-qualita-gallery"
          },
          "productId": "7999158157597",
          "family": "gallery",
          "variantIds": [
            "43727974072605"
          ],
          "available": true,
          "variantId": "43727974072605"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-20x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x150-cm-4cm",
            "en": "canvas-frame-20x150-cm-4cm",
            "fr": "chassis-20x150-cm-4cm",
            "it": "telaio-20x150-cm-4cm"
          },
          "productId": "7999347196189",
          "family": "bars",
          "variantIds": [
            "43916980355357"
          ],
          "available": true,
          "variantId": "43916980355357"
        }
      ]
    },
    "20x160": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-20x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-160-cm-qualite-galerie",
            "it": "telaio-telato-20-x-160-cm-qualita-gallery"
          },
          "productId": "7999158845725",
          "family": "gallery",
          "variantIds": [
            "43727974826269"
          ],
          "available": true,
          "variantId": "43727974826269"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-20x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x160-cm-4cm",
            "en": "canvas-frame-20x160-cm-4cm",
            "fr": "chassis-20x160-cm-4cm",
            "it": "telaio-20x160-cm-4cm"
          },
          "productId": "7999347753245",
          "family": "bars",
          "variantIds": [
            "43916981109021"
          ],
          "available": true,
          "variantId": "43916981109021"
        }
      ]
    },
    "20x170": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-20x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-170-cm-qualite-galerie",
            "it": "telaio-telato-20-x-170-cm-qualita-gallery"
          },
          "productId": "7999159435549",
          "family": "gallery",
          "variantIds": [
            "43727975514397"
          ],
          "available": true,
          "variantId": "43727975514397"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-20x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x170-cm-4cm",
            "en": "canvas-frame-20x170-cm-4cm",
            "fr": "chassis-20x170-cm-4cm",
            "it": "telaio-20x170-cm-4cm"
          },
          "productId": "7999348146461",
          "family": "bars",
          "variantIds": [
            "43916981731613"
          ],
          "available": true,
          "variantId": "43916981731613"
        }
      ]
    },
    "20x180": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-20x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-180-cm-qualite-galerie",
            "it": "telaio-telato-20-x-180-cm-qualita-gallery"
          },
          "productId": "7999159959837",
          "family": "gallery",
          "variantIds": [
            "43727980790045"
          ],
          "available": true,
          "variantId": "43727980790045"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-20x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x180-cm-4cm",
            "en": "canvas-frame-20x180-cm-4cm",
            "fr": "chassis-20x180-cm-4cm",
            "it": "telaio-20x180-cm-4cm"
          },
          "productId": "7999348670749",
          "family": "bars",
          "variantIds": [
            "43916982255901"
          ],
          "available": true,
          "variantId": "43916982255901"
        }
      ]
    },
    "20x195": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-20x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-195-cm-qualite-galerie",
            "it": "telaio-telato-20-x-195-cm-qualita-gallery"
          },
          "productId": "7999160549661",
          "family": "gallery",
          "variantIds": [
            "43727981445405"
          ],
          "available": true,
          "variantId": "43727981445405"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-20x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x195-cm-4cm",
            "en": "canvas-frame-20x195-cm-4cm",
            "fr": "chassis-20x195-cm-4cm",
            "it": "telaio-20x195-cm-4cm"
          },
          "productId": "7999349129501",
          "family": "bars",
          "variantIds": [
            "43916983173405"
          ],
          "available": true,
          "variantId": "43916983173405"
        }
      ]
    },
    "30x30": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-30x30-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x30-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-30-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-30-cm-qualite-galerie",
            "it": "telaio-telato-30-x-30-cm-qualita-gallery"
          },
          "productId": "7999161041181",
          "family": "gallery",
          "variantIds": [
            "43727981936925"
          ],
          "available": true,
          "variantId": "43727981936925"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305369885"
          ],
          "available": true,
          "variantId": "49195305369885"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-30x30-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-30x30-cm-roh",
            "en": "floating-frame-set-30x30-cm-unfinished",
            "fr": "kit-de-caisse-americaine-30x30-cm-brut",
            "it": "set-cornice-a-cassetta-30x30-cm-grezzo"
          },
          "productId": "7999053005085",
          "family": "shadow",
          "variantIds": [
            "43727752659229"
          ],
          "available": true,
          "variantId": "43727752659229"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-30x30-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x30-cm-4cm",
            "en": "canvas-frame-30x30-cm-4cm",
            "fr": "chassis-30x30-cm-4cm",
            "it": "telaio-30x30-cm-4cm"
          },
          "productId": "7999349588253",
          "family": "bars",
          "variantIds": [
            "43916983632157"
          ],
          "available": true,
          "variantId": "43916983632157"
        }
      ]
    },
    "30x40": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-30x40-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x40-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-40-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-40-cm-qualite-galerie",
            "it": "telaio-telato-30-x-40-cm-qualita-gallery"
          },
          "productId": "7999161663773",
          "family": "gallery",
          "variantIds": [
            "43727982625053"
          ],
          "available": true,
          "variantId": "43727982625053"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305337117"
          ],
          "available": true,
          "variantId": "49195305337117"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-30x40-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-30x40-cm-roh",
            "en": "floating-frame-set-30x40-cm-unfinished",
            "fr": "kit-de-caisse-americaine-30x40-cm-brut",
            "it": "set-cornice-a-cassetta-30x40-cm-grezzo"
          },
          "productId": "7999053103389",
          "family": "shadow",
          "variantIds": [
            "43727753249053"
          ],
          "available": true,
          "variantId": "43727753249053"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-30x40-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x40-cm-4cm",
            "en": "canvas-frame-30x40-cm-4cm",
            "fr": "chassis-30x40-cm-4cm",
            "it": "telaio-30x40-cm-4cm"
          },
          "productId": "7999350178077",
          "family": "bars",
          "variantIds": [
            "43916984451357"
          ],
          "available": true,
          "variantId": "43916984451357"
        }
      ]
    },
    "30x50": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-30x50-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x50-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-50-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-50-cm-qualite-galerie",
            "it": "telaio-telato-30-x-50-cm-qualita-gallery"
          },
          "productId": "7999162089757",
          "family": "gallery",
          "variantIds": [
            "43727983345949"
          ],
          "available": true,
          "variantId": "43727983345949"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "50079644647709"
          ],
          "available": true,
          "variantId": "50079644647709"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-30x50-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-30x50-cm-roh",
            "en": "floating-frame-set-30x50-cm-unfinished",
            "fr": "kit-de-caisse-americaine-30x50-cm-brut",
            "it": "set-cornice-a-cassetta-30x50-cm-grezzo"
          },
          "productId": "7999053234461",
          "family": "shadow",
          "variantIds": [
            "43727753576733"
          ],
          "available": true,
          "variantId": "43727753576733"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-30x50-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x50-cm-4cm",
            "en": "canvas-frame-30x50-cm-4cm",
            "fr": "chassis-30x50-cm-4cm",
            "it": "telaio-30x50-cm-4cm"
          },
          "productId": "7999350735133",
          "family": "bars",
          "variantIds": [
            "43916985237789"
          ],
          "available": true,
          "variantId": "43916985237789"
        }
      ]
    },
    "30x60": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-30x60-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x60-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-60-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-60-cm-qualite-galerie",
            "it": "telaio-telato-30-x-60-cm-qualita-gallery"
          },
          "productId": "7999162646813",
          "family": "gallery",
          "variantIds": [
            "43727983870237"
          ],
          "available": true,
          "variantId": "43727983870237"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305435421"
          ],
          "available": true,
          "variantId": "49195305435421"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-30x60-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-30x60-cm-roh",
            "en": "floating-frame-set-30x60-cm-unfinished",
            "fr": "kit-de-caisse-americaine-30x60-cm-brut",
            "it": "set-cornice-a-cassetta-30x60-cm-grezzo"
          },
          "productId": "7999053529373",
          "family": "shadow",
          "variantIds": [
            "43727755444509"
          ],
          "available": true,
          "variantId": "43727755444509"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-30x60-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x60-cm-4cm",
            "en": "canvas-frame-30x60-cm-4cm",
            "fr": "chassis-30x60-cm-4cm",
            "it": "telaio-30x60-cm-4cm"
          },
          "productId": "7999351193885",
          "family": "bars",
          "variantIds": [
            "43916985696541"
          ],
          "available": true,
          "variantId": "43916985696541"
        }
      ]
    },
    "30x70": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-30x70-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x70-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-70-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-70-cm-qualite-galerie",
            "it": "telaio-telato-30-x-70-cm-qualita-gallery"
          },
          "productId": "7999163203869",
          "family": "gallery",
          "variantIds": [
            "43727984754973"
          ],
          "available": true,
          "variantId": "43727984754973"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-30x70-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-30x70-cm-roh",
            "en": "floating-frame-set-30x70-cm-unfinished",
            "fr": "kit-de-caisse-americaine-30x70-cm-brut",
            "it": "set-cornice-a-cassetta-30x70-cm-grezzo"
          },
          "productId": "7999054119197",
          "family": "shadow",
          "variantIds": [
            "43727757443357"
          ],
          "available": true,
          "variantId": "43727757443357"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-30x70-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x70-cm-4cm",
            "en": "canvas-frame-30x70-cm-4cm",
            "fr": "chassis-30x70-cm-4cm",
            "it": "telaio-30x70-cm-4cm"
          },
          "productId": "7999351750941",
          "family": "bars",
          "variantIds": [
            "43916986876189"
          ],
          "available": true,
          "variantId": "43916986876189"
        }
      ]
    },
    "30x80": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-30x80-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x80-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-80-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-80-cm-qualite-galerie",
            "it": "telaio-telato-30-x-80-cm-qualita-gallery"
          },
          "productId": "7999163793693",
          "family": "gallery",
          "variantIds": [
            "43727985344797"
          ],
          "available": true,
          "variantId": "43727985344797"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-30x80-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-30x80-cm-roh",
            "en": "floating-frame-set-30x80-cm-unfinished",
            "fr": "kit-de-caisse-americaine-30x80-cm-brut",
            "it": "set-cornice-a-cassetta-30x80-cm-grezzo"
          },
          "productId": "7999054676253",
          "family": "shadow",
          "variantIds": [
            "43727760720157"
          ],
          "available": true,
          "variantId": "43727760720157"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-30x80-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x80-cm-4cm",
            "en": "canvas-frame-30x80-cm-4cm",
            "fr": "chassis-30x80-cm-4cm",
            "it": "telaio-30x80-cm-4cm"
          },
          "productId": "7999352406301",
          "family": "bars",
          "variantIds": [
            "43916987957533"
          ],
          "available": true,
          "variantId": "43916987957533"
        }
      ]
    },
    "30x90": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-30x90-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x90-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-90-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-90-cm-qualite-galerie",
            "it": "telaio-telato-30-x-90-cm-qualita-gallery"
          },
          "productId": "7999164416285",
          "family": "gallery",
          "variantIds": [
            "43727985967389"
          ],
          "available": true,
          "variantId": "43727985967389"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-30x90-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-30x90-cm-roh",
            "en": "floating-frame-set-30x90-cm-unfinished",
            "fr": "kit-de-caisse-americaine-30x90-cm-brut",
            "it": "set-cornice-a-cassetta-30x90-cm-grezzo"
          },
          "productId": "7999055233309",
          "family": "shadow",
          "variantIds": [
            "43727761375517"
          ],
          "available": true,
          "variantId": "43727761375517"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-30x90-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x90-cm-4cm",
            "en": "canvas-frame-30x90-cm-4cm",
            "fr": "chassis-30x90-cm-4cm",
            "it": "telaio-30x90-cm-4cm"
          },
          "productId": "7999352963357",
          "family": "bars",
          "variantIds": [
            "43916988743965"
          ],
          "available": true,
          "variantId": "43916988743965"
        }
      ]
    },
    "30x100": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-30x100-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x100-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-100-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-100-cm-qualite-galerie",
            "it": "telaio-telato-30-x-100-cm-qualita-gallery"
          },
          "productId": "7999164940573",
          "family": "gallery",
          "variantIds": [
            "43727987704093"
          ],
          "available": true,
          "variantId": "43727987704093"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-30x100-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-30x100-cm-roh",
            "en": "floating-frame-set-30x100-cm-unfinished",
            "fr": "kit-de-caisse-americaine-30x100-cm-brut",
            "it": "set-cornice-a-cassetta-30x100-cm-grezzo"
          },
          "productId": "7999055823133",
          "family": "shadow",
          "variantIds": [
            "43727762325789"
          ],
          "available": true,
          "variantId": "43727762325789"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-30x100-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x100-cm-4cm",
            "en": "canvas-frame-30x100-cm-4cm",
            "fr": "chassis-30x100-cm-4cm",
            "it": "telaio-30x100-cm-4cm"
          },
          "productId": "7999353487645",
          "family": "bars",
          "variantIds": [
            "43916989759773"
          ],
          "available": true,
          "variantId": "43916989759773"
        }
      ]
    },
    "30x110": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-30x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-110-cm-qualite-galerie",
            "it": "telaio-telato-30-x-110-cm-qualita-gallery"
          },
          "productId": "7999165464861",
          "family": "gallery",
          "variantIds": [
            "43727988982045"
          ],
          "available": true,
          "variantId": "43727988982045"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-30x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x110-cm-4cm",
            "en": "canvas-frame-30x110-cm-4cm",
            "fr": "chassis-30x110-cm-4cm",
            "it": "telaio-30x110-cm-4cm"
          },
          "productId": "7999353848093",
          "family": "bars",
          "variantIds": [
            "43916990152989"
          ],
          "available": true,
          "variantId": "43916990152989"
        }
      ]
    },
    "30x120": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-30x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-120-cm-qualite-galerie",
            "it": "telaio-telato-30-x-120-cm-qualita-gallery"
          },
          "productId": "7999166021917",
          "family": "gallery",
          "variantIds": [
            "43727989932317"
          ],
          "available": true,
          "variantId": "43727989932317"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-30x120-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-30x120-cm-roh",
            "en": "floating-frame-set-30x120-cm-unfinished",
            "fr": "kit-de-caisse-americaine-30x120-cm-brut",
            "it": "set-cornice-a-cassetta-30x120-cm-grezzo"
          },
          "productId": "7999056380189",
          "family": "shadow",
          "variantIds": [
            "43727763570973"
          ],
          "available": true,
          "variantId": "43727763570973"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-30x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x120-cm-4cm",
            "en": "canvas-frame-30x120-cm-4cm",
            "fr": "chassis-30x120-cm-4cm",
            "it": "telaio-30x120-cm-4cm"
          },
          "productId": "7999354306845",
          "family": "bars",
          "variantIds": [
            "43944806842653"
          ],
          "available": true,
          "variantId": "43944806842653"
        }
      ]
    },
    "30x130": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-30x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-130-cm-qualite-galerie",
            "it": "telaio-telato-30-x-130-cm-qualita-gallery"
          },
          "productId": "7999166546205",
          "family": "gallery",
          "variantIds": [
            "43727990587677"
          ],
          "available": true,
          "variantId": "43727990587677"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-30x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x130-cm-4cm",
            "en": "canvas-frame-30x130-cm-4cm",
            "fr": "chassis-30x130-cm-4cm",
            "it": "telaio-30x130-cm-4cm"
          },
          "productId": "7999354896669",
          "family": "bars",
          "variantIds": [
            "43944807694621"
          ],
          "available": true,
          "variantId": "43944807694621"
        }
      ]
    },
    "30x140": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-30x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-140-cm-qualite-galerie",
            "it": "telaio-telato-30-x-140-cm-qualita-gallery"
          },
          "productId": "7999167070493",
          "family": "gallery",
          "variantIds": [
            "43727991079197"
          ],
          "available": true,
          "variantId": "43727991079197"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-30x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-30x140-cm-roh",
            "en": "floating-frame-set-30x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-30x140-cm-brut",
            "it": "set-cornice-a-cassetta-30x140-cm-grezzo"
          },
          "productId": "7999056806173",
          "family": "shadow",
          "variantIds": [
            "43727764095261"
          ],
          "available": false,
          "variantId": "43727764095261"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-30x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x140-cm-4cm",
            "en": "canvas-frame-30x140-cm-4cm",
            "fr": "chassis-30x140-cm-4cm",
            "it": "telaio-30x140-cm-4cm"
          },
          "productId": "7999355388189",
          "family": "bars",
          "variantIds": [
            "43944808186141"
          ],
          "available": true,
          "variantId": "43944808186141"
        }
      ]
    },
    "30x150": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-30x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-150-cm-qualite-galerie",
            "it": "telaio-telato-30-x-150-cm-qualita-gallery"
          },
          "productId": "7999167562013",
          "family": "gallery",
          "variantIds": [
            "43727992291613"
          ],
          "available": true,
          "variantId": "43727992291613"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-30x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x150-cm-4cm",
            "en": "canvas-frame-30x150-cm-4cm",
            "fr": "chassis-30x150-cm-4cm",
            "it": "telaio-30x150-cm-4cm"
          },
          "productId": "7999355912477",
          "family": "bars",
          "variantIds": [
            "43944809136413"
          ],
          "available": true,
          "variantId": "43944809136413"
        }
      ]
    },
    "30x160": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-30x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-160-cm-qualite-galerie",
            "it": "telaio-telato-30-x-160-cm-qualita-gallery"
          },
          "productId": "7999168119069",
          "family": "gallery",
          "variantIds": [
            "43727992881437"
          ],
          "available": true,
          "variantId": "43727992881437"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-30x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x160-cm-4cm",
            "en": "canvas-frame-30x160-cm-4cm",
            "fr": "chassis-30x160-cm-4cm",
            "it": "telaio-30x160-cm-4cm"
          },
          "productId": "7999356403997",
          "family": "bars",
          "variantIds": [
            "43944809627933"
          ],
          "available": true,
          "variantId": "43944809627933"
        }
      ]
    },
    "30x170": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-30x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-170-cm-qualite-galerie",
            "it": "telaio-telato-30-x-170-cm-qualita-gallery"
          },
          "productId": "7999168610589",
          "family": "gallery",
          "variantIds": [
            "43727993471261"
          ],
          "available": true,
          "variantId": "43727993471261"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-30x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x170-cm-4cm",
            "en": "canvas-frame-30x170-cm-4cm",
            "fr": "chassis-30x170-cm-4cm",
            "it": "telaio-30x170-cm-4cm"
          },
          "productId": "7999356895517",
          "family": "bars",
          "variantIds": [
            "43944810316061"
          ],
          "available": true,
          "variantId": "43944810316061"
        }
      ]
    },
    "30x180": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-30x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-180-cm-qualite-galerie",
            "it": "telaio-telato-30-x-180-cm-qualita-gallery"
          },
          "productId": "7999169233181",
          "family": "gallery",
          "variantIds": [
            "43727994126621"
          ],
          "available": true,
          "variantId": "43727994126621"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-30x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x180-cm-4cm",
            "en": "canvas-frame-30x180-cm-4cm",
            "fr": "chassis-30x180-cm-4cm",
            "it": "telaio-30x180-cm-4cm"
          },
          "productId": "7999357354269",
          "family": "bars",
          "variantIds": [
            "43944810807581"
          ],
          "available": true,
          "variantId": "43944810807581"
        }
      ]
    },
    "30x195": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-30x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-195-cm-qualite-galerie",
            "it": "telaio-telato-30-x-195-cm-qualita-gallery"
          },
          "productId": "7999169790237",
          "family": "gallery",
          "variantIds": [
            "43727994716445"
          ],
          "available": true,
          "variantId": "43727994716445"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-30x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x195-cm-4cm",
            "en": "canvas-frame-30x195-cm-4cm",
            "fr": "chassis-30x195-cm-4cm",
            "it": "telaio-30x195-cm-4cm"
          },
          "productId": "7999357944093",
          "family": "bars",
          "variantIds": [
            "43944811594013"
          ],
          "available": true,
          "variantId": "43944811594013"
        }
      ]
    },
    "40x40": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-40x40-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x40-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-40-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-40-cm-qualite-galerie",
            "it": "telaio-telato-40-x-40-cm-qualita-gallery"
          },
          "productId": "7999170248989",
          "family": "gallery",
          "variantIds": [
            "43727995502877"
          ],
          "available": true,
          "variantId": "43727995502877"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305304349"
          ],
          "available": true,
          "variantId": "49195305304349"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-40x40-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-40x40-cm-roh",
            "en": "floating-frame-set-40x40-cm-unfinished",
            "fr": "kit-de-caisse-americaine-40x40-cm-brut",
            "it": "set-cornice-a-cassetta-40x40-cm-grezzo"
          },
          "productId": "7999057395997",
          "family": "shadow",
          "variantIds": [
            "43727767437597"
          ],
          "available": true,
          "variantId": "43727767437597"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-40x40-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x40-cm-4cm",
            "en": "canvas-frame-40x40-cm-4cm",
            "fr": "chassis-40x40-cm-4cm",
            "it": "telaio-40x40-cm-4cm"
          },
          "productId": "7999358763293",
          "family": "bars",
          "variantIds": [
            "43944812609821"
          ],
          "available": true,
          "variantId": "43944812609821"
        }
      ]
    },
    "40x50": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-40x50-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x50-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-50-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-50-cm-qualite-galerie",
            "it": "telaio-telato-40-x-50-cm-qualita-gallery"
          },
          "productId": "7999170838813",
          "family": "gallery",
          "variantIds": [
            "43727996289309"
          ],
          "available": true,
          "variantId": "43727996289309"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195609817373"
          ],
          "available": false,
          "variantId": "49195609817373"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-40x50-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-40x50-cm-roh",
            "en": "floating-frame-set-40x50-cm-unfinished",
            "fr": "kit-de-caisse-americaine-40x50-cm-brut",
            "it": "set-cornice-a-cassetta-40x50-cm-grezzo"
          },
          "productId": "7999057920285",
          "family": "shadow",
          "variantIds": [
            "43727768060189"
          ],
          "available": true,
          "variantId": "43727768060189"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-40x50-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x50-cm-4cm",
            "en": "canvas-frame-40x50-cm-4cm",
            "fr": "chassis-40x50-cm-4cm",
            "it": "telaio-40x50-cm-4cm"
          },
          "productId": "7999359451421",
          "family": "bars",
          "variantIds": [
            "43944814182685"
          ],
          "available": true,
          "variantId": "43944814182685"
        }
      ]
    },
    "40x60": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-40x60-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x60-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-60-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-60-cm-qualite-galerie",
            "it": "telaio-telato-40-x-60-cm-qualita-gallery"
          },
          "productId": "7999171428637",
          "family": "gallery",
          "variantIds": [
            "43727996944669"
          ],
          "available": true,
          "variantId": "43727996944669"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305271581"
          ],
          "available": true,
          "variantId": "49195305271581"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-40x60-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-40x60-cm-roh",
            "en": "floating-frame-set-40x60-cm-unfinished",
            "fr": "kit-de-caisse-americaine-40x60-cm-brut",
            "it": "set-cornice-a-cassetta-40x60-cm-grezzo"
          },
          "productId": "7999058706717",
          "family": "shadow",
          "variantIds": [
            "43727772975389"
          ],
          "available": true,
          "variantId": "43727772975389"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-40x60-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x60-cm-4cm",
            "en": "canvas-frame-40x60-cm-4cm",
            "fr": "chassis-40x60-cm-4cm",
            "it": "telaio-40x60-cm-4cm"
          },
          "productId": "7999360205085",
          "family": "bars",
          "variantIds": [
            "43944815231261"
          ],
          "available": true,
          "variantId": "43944815231261"
        }
      ]
    },
    "40x70": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-40x70-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x70-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-70-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-70-cm-qualite-galerie",
            "it": "telaio-telato-40-x-70-cm-qualita-gallery"
          },
          "productId": "7999171952925",
          "family": "gallery",
          "variantIds": [
            "43727998255389"
          ],
          "available": true,
          "variantId": "43727998255389"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-40x70-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-40x70-cm-roh",
            "en": "floating-frame-set-40x70-cm-unfinished",
            "fr": "kit-de-caisse-americaine-40x70-cm-brut",
            "it": "set-cornice-a-cassetta-40x70-cm-grezzo"
          },
          "productId": "7999059263773",
          "family": "shadow",
          "variantIds": [
            "43727773597981"
          ],
          "available": true,
          "variantId": "43727773597981"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-40x70-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x70-cm-4cm",
            "en": "canvas-frame-40x70-cm-4cm",
            "fr": "chassis-40x70-cm-4cm",
            "it": "telaio-40x70-cm-4cm"
          },
          "productId": "7999360827677",
          "family": "bars",
          "variantIds": [
            "43944815821085"
          ],
          "available": true,
          "variantId": "43944815821085"
        }
      ]
    },
    "40x80": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-40x80-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x80-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-80-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-80-cm-qualite-galerie",
            "it": "telaio-telato-40-x-80-cm-qualita-gallery"
          },
          "productId": "7999172608285",
          "family": "gallery",
          "variantIds": [
            "43727998943517"
          ],
          "available": true,
          "variantId": "43727998943517"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305500957"
          ],
          "available": true,
          "variantId": "49195305500957"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-40x80-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-40x80-cm-roh",
            "en": "floating-frame-set-40x80-cm-unfinished",
            "fr": "kit-de-caisse-americaine-40x80-cm-brut",
            "it": "set-cornice-a-cassetta-40x80-cm-grezzo"
          },
          "productId": "7999059755293",
          "family": "shadow",
          "variantIds": [
            "43727774187805"
          ],
          "available": true,
          "variantId": "43727774187805"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-40x80-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x80-cm-4cm",
            "en": "canvas-frame-40x80-cm-4cm",
            "fr": "chassis-40x80-cm-4cm",
            "it": "telaio-40x80-cm-4cm"
          },
          "productId": "7999361745181",
          "family": "bars",
          "variantIds": [
            "43944816967965"
          ],
          "available": true,
          "variantId": "43944816967965"
        }
      ]
    },
    "40x90": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-40x90-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x90-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-90-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-90-cm-qualite-galerie",
            "it": "telaio-telato-40-x-90-cm-qualita-gallery"
          },
          "productId": "7999173099805",
          "family": "gallery",
          "variantIds": [
            "43727999435037"
          ],
          "available": true,
          "variantId": "43727999435037"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-40x90-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-40x90-cm-roh",
            "en": "floating-frame-set-40x90-cm-unfinished",
            "fr": "kit-de-caisse-americaine-40x90-cm-brut",
            "it": "set-cornice-a-cassetta-40x90-cm-grezzo"
          },
          "productId": "7999060345117",
          "family": "shadow",
          "variantIds": [
            "43727774843165"
          ],
          "available": true,
          "variantId": "43727774843165"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-40x90-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x90-cm-4cm",
            "en": "canvas-frame-40x90-cm-4cm",
            "fr": "chassis-40x90-cm-4cm",
            "it": "telaio-40x90-cm-4cm"
          },
          "productId": "7999362466077",
          "family": "bars",
          "variantIds": [
            "43944817852701"
          ],
          "available": true,
          "variantId": "43944817852701"
        }
      ]
    },
    "40x100": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-40x100-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x100-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-100-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-100-cm-qualite-galerie",
            "it": "telaio-telato-40-x-100-cm-qualita-gallery"
          },
          "productId": "7999173722397",
          "family": "gallery",
          "variantIds": [
            "43728000155933"
          ],
          "available": true,
          "variantId": "43728000155933"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-40x100-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-40x100-cm-roh",
            "en": "floating-frame-set-40x100-cm-unfinished",
            "fr": "kit-de-caisse-americaine-40x100-cm-brut",
            "it": "set-cornice-a-cassetta-40x100-cm-grezzo"
          },
          "productId": "7999061000477",
          "family": "shadow",
          "variantIds": [
            "43727775760669"
          ],
          "available": true,
          "variantId": "43727775760669"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-40x100-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x100-cm-4cm",
            "en": "canvas-frame-40x100-cm-4cm",
            "fr": "chassis-40x100-cm-4cm",
            "it": "telaio-40x100-cm-4cm"
          },
          "productId": "7999363219741",
          "family": "bars",
          "variantIds": [
            "43944818868509"
          ],
          "available": true,
          "variantId": "43944818868509"
        }
      ]
    },
    "40x110": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-40x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-110-cm-qualite-galerie",
            "it": "telaio-telato-40-x-110-cm-qualita-gallery"
          },
          "productId": "7999174279453",
          "family": "gallery",
          "variantIds": [
            "43728001171741"
          ],
          "available": true,
          "variantId": "43728001171741"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-40x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x110-cm-4cm",
            "en": "canvas-frame-40x110-cm-4cm",
            "fr": "chassis-40x110-cm-4cm",
            "it": "telaio-40x110-cm-4cm"
          },
          "productId": "7999364006173",
          "family": "bars",
          "variantIds": [
            "43944819884317"
          ],
          "available": true,
          "variantId": "43944819884317"
        }
      ]
    },
    "40x120": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-40x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-120-cm-qualite-galerie",
            "it": "telaio-telato-40-x-120-cm-qualita-gallery"
          },
          "productId": "7999174967581",
          "family": "gallery",
          "variantIds": [
            "43728001958173"
          ],
          "available": true,
          "variantId": "43728001958173"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-40x120-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-40x120-cm-roh",
            "en": "floating-frame-set-40x120-cm-unfinished",
            "fr": "kit-de-caisse-americaine-40x120-cm-brut",
            "it": "set-cornice-a-cassetta-40x120-cm-grezzo"
          },
          "productId": "7999061819677",
          "family": "shadow",
          "variantIds": [
            "43727776743709"
          ],
          "available": true,
          "variantId": "43727776743709"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-40x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x120-cm-4cm",
            "en": "canvas-frame-40x120-cm-4cm",
            "fr": "chassis-40x120-cm-4cm",
            "it": "telaio-40x120-cm-4cm"
          },
          "productId": "7999364989213",
          "family": "bars",
          "variantIds": [
            "43944821260573"
          ],
          "available": true,
          "variantId": "43944821260573"
        }
      ]
    },
    "40x130": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-40x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-130-cm-qualite-galerie",
            "it": "telaio-telato-40-x-130-cm-qualita-gallery"
          },
          "productId": "7999175360797",
          "family": "gallery",
          "variantIds": [
            "43728002777373"
          ],
          "available": true,
          "variantId": "43728002777373"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-40x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x130-cm-4cm",
            "en": "canvas-frame-40x130-cm-4cm",
            "fr": "chassis-40x130-cm-4cm",
            "it": "telaio-40x130-cm-4cm"
          },
          "productId": "7999365775645",
          "family": "bars",
          "variantIds": [
            "43944822014237"
          ],
          "available": true,
          "variantId": "43944822014237"
        }
      ]
    },
    "40x140": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-40x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-140-cm-qualite-galerie",
            "it": "telaio-telato-40-x-140-cm-qualita-gallery"
          },
          "productId": "7999175983389",
          "family": "gallery",
          "variantIds": [
            "43728003432733"
          ],
          "available": true,
          "variantId": "43728003432733"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-40x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-40x140-cm-roh",
            "en": "floating-frame-set-40x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-40x140-cm-brut",
            "it": "set-cornice-a-cassetta-40x140-cm-grezzo"
          },
          "productId": "7999062901021",
          "family": "shadow",
          "variantIds": [
            "43727778054429"
          ],
          "available": false,
          "variantId": "43727778054429"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-40x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x140-cm-4cm",
            "en": "canvas-frame-40x140-cm-4cm",
            "fr": "chassis-40x140-cm-4cm",
            "it": "telaio-40x140-cm-4cm"
          },
          "productId": "7999366562077",
          "family": "bars",
          "variantIds": [
            "43944823128349"
          ],
          "available": true,
          "variantId": "43944823128349"
        }
      ]
    },
    "40x150": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-40x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-150-cm-qualite-galerie",
            "it": "telaio-telato-40-x-150-cm-qualita-gallery"
          },
          "productId": "7999176573213",
          "family": "gallery",
          "variantIds": [
            "43728004710685"
          ],
          "available": true,
          "variantId": "43728004710685"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-40x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x150-cm-4cm",
            "en": "canvas-frame-40x150-cm-4cm",
            "fr": "chassis-40x150-cm-4cm",
            "it": "telaio-40x150-cm-4cm"
          },
          "productId": "7999367250205",
          "family": "bars",
          "variantIds": [
            "43944824733981"
          ],
          "available": true,
          "variantId": "43944824733981"
        }
      ]
    },
    "40x160": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-40x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-160-cm-qualite-galerie",
            "it": "telaio-telato-40-x-160-cm-qualita-gallery"
          },
          "productId": "7999177228573",
          "family": "gallery",
          "variantIds": [
            "43728006086941"
          ],
          "available": true,
          "variantId": "43728006086941"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-40x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x160-cm-4cm",
            "en": "canvas-frame-40x160-cm-4cm",
            "fr": "chassis-40x160-cm-4cm",
            "it": "telaio-40x160-cm-4cm"
          },
          "productId": "7999368888605",
          "family": "bars",
          "variantIds": [
            "43944826143005"
          ],
          "available": true,
          "variantId": "43944826143005"
        }
      ]
    },
    "40x170": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-40x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-170-cm-qualite-galerie",
            "it": "telaio-telato-40-x-170-cm-qualita-gallery"
          },
          "productId": "7999177687325",
          "family": "gallery",
          "variantIds": [
            "43728006545693"
          ],
          "available": true,
          "variantId": "43728006545693"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-40x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x170-cm-4cm",
            "en": "canvas-frame-40x170-cm-4cm",
            "fr": "chassis-40x170-cm-4cm",
            "it": "telaio-40x170-cm-4cm"
          },
          "productId": "7999369838877",
          "family": "bars",
          "variantIds": [
            "43944827453725"
          ],
          "available": true,
          "variantId": "43944827453725"
        }
      ]
    },
    "40x180": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-40x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-180-cm-qualite-galerie",
            "it": "telaio-telato-40-x-180-cm-qualita-gallery"
          },
          "productId": "7999178506525",
          "family": "gallery",
          "variantIds": [
            "43728007856413"
          ],
          "available": true,
          "variantId": "43728007856413"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-40x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x180-cm-4cm",
            "en": "canvas-frame-40x180-cm-4cm",
            "fr": "chassis-40x180-cm-4cm",
            "it": "telaio-40x180-cm-4cm"
          },
          "productId": "7999370527005",
          "family": "bars",
          "variantIds": [
            "43944828141853"
          ],
          "available": true,
          "variantId": "43944828141853"
        }
      ]
    },
    "40x195": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-40x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-195-cm-qualite-galerie",
            "it": "telaio-telato-40-x-195-cm-qualita-gallery"
          },
          "productId": "7999179161885",
          "family": "gallery",
          "variantIds": [
            "43728010248477"
          ],
          "available": true,
          "variantId": "43728010248477"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-40x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x195-cm-4cm",
            "en": "canvas-frame-40x195-cm-4cm",
            "fr": "chassis-40x195-cm-4cm",
            "it": "telaio-40x195-cm-4cm"
          },
          "productId": "7999371346205",
          "family": "bars",
          "variantIds": [
            "43944829583645"
          ],
          "available": true,
          "variantId": "43944829583645"
        }
      ]
    },
    "50x50": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-50x50-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x50-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-50-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-50-cm-qualite-galerie",
            "it": "telaio-telato-50-x-50-cm-qualita-gallery"
          },
          "productId": "7999179686173",
          "family": "gallery",
          "variantIds": [
            "43728011264285"
          ],
          "available": true,
          "variantId": "43728011264285"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305238813"
          ],
          "available": true,
          "variantId": "49195305238813"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-50x50-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-50x50-cm-roh",
            "en": "floating-frame-set-50x50-cm-unfinished",
            "fr": "kit-de-caisse-americaine-50x50-cm-brut",
            "it": "set-cornice-a-cassetta-50x50-cm-grezzo"
          },
          "productId": "7999063785757",
          "family": "shadow",
          "variantIds": [
            "43727778939165"
          ],
          "available": true,
          "variantId": "43727778939165"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-50x50-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x50-cm-4cm",
            "en": "canvas-frame-50x50-cm-4cm",
            "fr": "chassis-50x50-cm-4cm",
            "it": "telaio-50x50-cm-4cm"
          },
          "productId": "7999372099869",
          "family": "bars",
          "variantIds": [
            "43944830664989"
          ],
          "available": true,
          "variantId": "43944830664989"
        }
      ]
    },
    "50x60": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-50x60-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x60-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-60-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-60-cm-qualite-galerie",
            "it": "telaio-telato-50-x-60-cm-qualita-gallery"
          },
          "productId": "7999180177693",
          "family": "gallery",
          "variantIds": [
            "43728011821341"
          ],
          "available": true,
          "variantId": "43728011821341"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305206045"
          ],
          "available": true,
          "variantId": "49195305206045"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-50x60-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-50x60-cm-roh",
            "en": "floating-frame-set-50x60-cm-unfinished",
            "fr": "kit-de-caisse-americaine-50x60-cm-brut",
            "it": "set-cornice-a-cassetta-50x60-cm-grezzo"
          },
          "productId": "7999064867101",
          "family": "shadow",
          "variantIds": [
            "43727782215965"
          ],
          "available": true,
          "variantId": "43727782215965"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-50x60-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x60-cm-4cm",
            "en": "canvas-frame-50x60-cm-4cm",
            "fr": "chassis-50x60-cm-4cm",
            "it": "telaio-50x60-cm-4cm"
          },
          "productId": "7999372820765",
          "family": "bars",
          "variantIds": [
            "43944831582493"
          ],
          "available": true,
          "variantId": "43944831582493"
        }
      ]
    },
    "50x70": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-50x70-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x70-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-70-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-70-cm-qualite-galerie",
            "it": "telaio-telato-50-x-70-cm-qualita-gallery"
          },
          "productId": "7999180603677",
          "family": "gallery",
          "variantIds": [
            "43728012771613"
          ],
          "available": true,
          "variantId": "43728012771613"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305173277"
          ],
          "available": true,
          "variantId": "49195305173277"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-50x70-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-50x70-cm-roh",
            "en": "floating-frame-set-50x70-cm-unfinished",
            "fr": "kit-de-caisse-americaine-50x70-cm-brut",
            "it": "set-cornice-a-cassetta-50x70-cm-grezzo"
          },
          "productId": "7999065948445",
          "family": "shadow",
          "variantIds": [
            "43727789031709"
          ],
          "available": true,
          "variantId": "43727789031709"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-50x70-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x70-cm-4cm",
            "en": "canvas-frame-50x70-cm-4cm",
            "fr": "chassis-50x70-cm-4cm",
            "it": "telaio-50x70-cm-4cm"
          },
          "productId": "7999373443357",
          "family": "bars",
          "variantIds": [
            "43944832205085"
          ],
          "available": true,
          "variantId": "43944832205085"
        }
      ]
    },
    "50x80": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-50x80-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x80-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-80-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-80-cm-qualite-galerie",
            "it": "telaio-telato-50-x-80-cm-qualita-gallery"
          },
          "productId": "7999181160733",
          "family": "gallery",
          "variantIds": [
            "43728013295901"
          ],
          "available": true,
          "variantId": "43728013295901"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-50x80-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-50x80-cm-roh",
            "en": "floating-frame-set-50x80-cm-unfinished",
            "fr": "kit-de-caisse-americaine-50x80-cm-brut",
            "it": "set-cornice-a-cassetta-50x80-cm-grezzo"
          },
          "productId": "7999067062557",
          "family": "shadow",
          "variantIds": [
            "43727790473501"
          ],
          "available": true,
          "variantId": "43727790473501"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-50x80-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x80-cm-4cm",
            "en": "canvas-frame-50x80-cm-4cm",
            "fr": "chassis-50x80-cm-4cm",
            "it": "telaio-50x80-cm-4cm"
          },
          "productId": "7999374164253",
          "family": "bars",
          "variantIds": [
            "43944833122589"
          ],
          "available": true,
          "variantId": "43944833122589"
        }
      ]
    },
    "50x90": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-50x90-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x90-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-90-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-90-cm-qualite-galerie",
            "it": "telaio-telato-50-x-90-cm-qualita-gallery"
          },
          "productId": "7999181750557",
          "family": "gallery",
          "variantIds": [
            "43728013885725"
          ],
          "available": true,
          "variantId": "43728013885725"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-50x90-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-50x90-cm-roh",
            "en": "floating-frame-set-50x90-cm-unfinished",
            "fr": "kit-de-caisse-americaine-50x90-cm-brut",
            "it": "set-cornice-a-cassetta-50x90-cm-grezzo"
          },
          "productId": "7999068111133",
          "family": "shadow",
          "variantIds": [
            "43727791718685"
          ],
          "available": true,
          "variantId": "43727791718685"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-50x90-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x90-cm-4cm",
            "en": "canvas-frame-50x90-cm-4cm",
            "fr": "chassis-50x90-cm-4cm",
            "it": "telaio-50x90-cm-4cm"
          },
          "productId": "7999374917917",
          "family": "bars",
          "variantIds": [
            "43944834400541"
          ],
          "available": true,
          "variantId": "43944834400541"
        }
      ]
    },
    "50x100": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-50x100-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x100-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-100-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-100-cm-qualite-galerie",
            "it": "telaio-telato-50-x-100-cm-qualita-gallery"
          },
          "productId": "7999182340381",
          "family": "gallery",
          "variantIds": [
            "43728014770461"
          ],
          "available": true,
          "variantId": "43728014770461"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-50x100-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-50x100-cm-roh",
            "en": "floating-frame-set-50x100-cm-unfinished",
            "fr": "kit-de-caisse-americaine-50x100-cm-brut",
            "it": "set-cornice-a-cassetta-50x100-cm-grezzo"
          },
          "productId": "7999069126941",
          "family": "shadow",
          "variantIds": [
            "43727793094941"
          ],
          "available": true,
          "variantId": "43727793094941"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-50x100-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x100-cm-4cm",
            "en": "canvas-frame-50x100-cm-4cm",
            "fr": "chassis-50x100-cm-4cm",
            "it": "telaio-50x100-cm-4cm"
          },
          "productId": "7999375606045",
          "family": "bars",
          "variantIds": [
            "43944835088669"
          ],
          "available": true,
          "variantId": "43944835088669"
        }
      ]
    },
    "50x110": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-50x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-110-cm-qualite-galerie",
            "it": "telaio-telato-50-x-110-cm-qualita-gallery"
          },
          "productId": "7999182733597",
          "family": "gallery",
          "variantIds": [
            "43728015425821"
          ],
          "available": true,
          "variantId": "43728015425821"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-50x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x110-cm-4cm",
            "en": "canvas-frame-50x110-cm-4cm",
            "fr": "chassis-50x110-cm-4cm",
            "it": "telaio-50x110-cm-4cm"
          },
          "productId": "7999376261405",
          "family": "bars",
          "variantIds": [
            "43944835744029"
          ],
          "available": true,
          "variantId": "43944835744029"
        }
      ]
    },
    "50x120": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-50x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-120-cm-qualite-galerie",
            "it": "telaio-telato-50-x-120-cm-qualita-gallery"
          },
          "productId": "7999183257885",
          "family": "gallery",
          "variantIds": [
            "43728016048413"
          ],
          "available": true,
          "variantId": "43728016048413"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-50x120-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-50x120-cm-roh",
            "en": "floating-frame-set-50x120-cm-unfinished",
            "fr": "kit-de-caisse-americaine-50x120-cm-brut",
            "it": "set-cornice-a-cassetta-50x120-cm-grezzo"
          },
          "productId": "7999069913373",
          "family": "shadow",
          "variantIds": [
            "43727794077981"
          ],
          "available": true,
          "variantId": "43727794077981"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-50x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x120-cm-4cm",
            "en": "canvas-frame-50x120-cm-4cm",
            "fr": "chassis-50x120-cm-4cm",
            "it": "telaio-50x120-cm-4cm"
          },
          "productId": "7999376818461",
          "family": "bars",
          "variantIds": [
            "43944836497693"
          ],
          "available": true,
          "variantId": "43944836497693"
        }
      ]
    },
    "50x130": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-50x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-130-cm-qualite-galerie",
            "it": "telaio-telato-50-x-130-cm-qualita-gallery"
          },
          "productId": "7999183913245",
          "family": "gallery",
          "variantIds": [
            "43728017064221"
          ],
          "available": true,
          "variantId": "43728017064221"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-50x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x130-cm-4cm",
            "en": "canvas-frame-50x130-cm-4cm",
            "fr": "chassis-50x130-cm-4cm",
            "it": "telaio-50x130-cm-4cm"
          },
          "productId": "7999377309981",
          "family": "bars",
          "variantIds": [
            "43944837087517"
          ],
          "available": true,
          "variantId": "43944837087517"
        }
      ]
    },
    "50x140": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-50x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-140-cm-qualite-galerie",
            "it": "telaio-telato-50-x-140-cm-qualita-gallery"
          },
          "productId": "7999184503069",
          "family": "gallery",
          "variantIds": [
            "43728017948957"
          ],
          "available": true,
          "variantId": "43728017948957"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-50x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-50x140-cm-roh",
            "en": "floating-frame-set-50x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-50x140-cm-brut",
            "it": "set-cornice-a-cassetta-50x140-cm-grezzo"
          },
          "productId": "7999070798109",
          "family": "shadow",
          "variantIds": [
            "43727795552541"
          ],
          "available": false,
          "variantId": "43727795552541"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-50x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x140-cm-4cm",
            "en": "canvas-frame-50x140-cm-4cm",
            "fr": "chassis-50x140-cm-4cm",
            "it": "telaio-50x140-cm-4cm"
          },
          "productId": "7999377834269",
          "family": "bars",
          "variantIds": [
            "43944838332701"
          ],
          "available": true,
          "variantId": "43944838332701"
        }
      ]
    },
    "50x150": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-50x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-150-cm-qualite-galerie",
            "it": "telaio-telato-50-x-150-cm-qualita-gallery"
          },
          "productId": "7999184830749",
          "family": "gallery",
          "variantIds": [
            "43728018276637"
          ],
          "available": true,
          "variantId": "43728018276637"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-50x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x150-cm-4cm",
            "en": "canvas-frame-50x150-cm-4cm",
            "fr": "chassis-50x150-cm-4cm",
            "it": "telaio-50x150-cm-4cm"
          },
          "productId": "7999378325789",
          "family": "bars",
          "variantIds": [
            "43944839250205"
          ],
          "available": true,
          "variantId": "43944839250205"
        }
      ]
    },
    "50x160": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-50x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-160-cm-qualite-galerie",
            "it": "telaio-telato-50-x-160-cm-qualita-gallery"
          },
          "productId": "7999185453341",
          "family": "gallery",
          "variantIds": [
            "43728020308253"
          ],
          "available": true,
          "variantId": "43728020308253"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-50x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x160-cm-4cm",
            "en": "canvas-frame-50x160-cm-4cm",
            "fr": "chassis-50x160-cm-4cm",
            "it": "telaio-50x160-cm-4cm"
          },
          "productId": "7999378915613",
          "family": "bars",
          "variantIds": [
            "43944840495389"
          ],
          "available": true,
          "variantId": "43944840495389"
        }
      ]
    },
    "50x170": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-50x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-170-cm-qualite-galerie",
            "it": "telaio-telato-50-x-170-cm-qualita-gallery"
          },
          "productId": "7999186075933",
          "family": "gallery",
          "variantIds": [
            "43728021815581"
          ],
          "available": true,
          "variantId": "43728021815581"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-50x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x170-cm-4cm",
            "en": "canvas-frame-50x170-cm-4cm",
            "fr": "chassis-50x170-cm-4cm",
            "it": "telaio-50x170-cm-4cm"
          },
          "productId": "7999379570973",
          "family": "bars",
          "variantIds": [
            "43944841478429"
          ],
          "available": true,
          "variantId": "43944841478429"
        }
      ]
    },
    "50x180": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-50x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-180-cm-qualite-galerie",
            "it": "telaio-telato-50-x-180-cm-qualita-gallery"
          },
          "productId": "7999186600221",
          "family": "gallery",
          "variantIds": [
            "43728022700317"
          ],
          "available": true,
          "variantId": "43728022700317"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-50x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x180-cm-4cm",
            "en": "canvas-frame-50x180-cm-4cm",
            "fr": "chassis-50x180-cm-4cm",
            "it": "telaio-50x180-cm-4cm"
          },
          "productId": "7999380029725",
          "family": "bars",
          "variantIds": [
            "43944842002717"
          ],
          "available": true,
          "variantId": "43944842002717"
        }
      ]
    },
    "50x195": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-50x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-195-cm-qualite-galerie",
            "it": "telaio-telato-50-x-195-cm-qualita-gallery"
          },
          "productId": "7999187091741",
          "family": "gallery",
          "variantIds": [
            "43728023191837"
          ],
          "available": true,
          "variantId": "43728023191837"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-50x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x195-cm-4cm",
            "en": "canvas-frame-50x195-cm-4cm",
            "fr": "chassis-50x195-cm-4cm",
            "it": "telaio-50x195-cm-4cm"
          },
          "productId": "7999380554013",
          "family": "bars",
          "variantIds": [
            "43944842821917"
          ],
          "available": true,
          "variantId": "43944842821917"
        }
      ]
    },
    "60x60": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-60x60-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x60-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-60-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-60-cm-qualite-galerie",
            "it": "telaio-telato-60-x-60-cm-qualita-gallery"
          },
          "productId": "7999187484957",
          "family": "gallery",
          "variantIds": [
            "43728023879965"
          ],
          "available": true,
          "variantId": "43728023879965"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305140509"
          ],
          "available": true,
          "variantId": "49195305140509"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-60x60-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-60x60-cm-roh",
            "en": "floating-frame-set-60x60-cm-unfinished",
            "fr": "kit-de-caisse-americaine-60x60-cm-brut",
            "it": "set-cornice-a-cassetta-60x60-cm-grezzo"
          },
          "productId": "7999071748381",
          "family": "shadow",
          "variantIds": [
            "43727796699421"
          ],
          "available": true,
          "variantId": "43727796699421"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-60x60-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x60-cm-4cm",
            "en": "canvas-frame-60x60-cm-4cm",
            "fr": "chassis-60x60-cm-4cm",
            "it": "telaio-60x60-cm-4cm"
          },
          "productId": "7999381143837",
          "family": "bars",
          "variantIds": [
            "43944843444509"
          ],
          "available": true,
          "variantId": "43944843444509"
        }
      ]
    },
    "60x70": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-60x70-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x70-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-70-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-70-cm-qualite-galerie",
            "it": "telaio-telato-60-x-70-cm-qualita-gallery"
          },
          "productId": "7999188140317",
          "family": "gallery",
          "variantIds": [
            "43728024535325"
          ],
          "available": true,
          "variantId": "43728024535325"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-60x70-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-60x70-cm-roh",
            "en": "floating-frame-set-60x70-cm-unfinished",
            "fr": "kit-de-caisse-americaine-60x70-cm-brut",
            "it": "set-cornice-a-cassetta-60x70-cm-grezzo"
          },
          "productId": "7999073026333",
          "family": "shadow",
          "variantIds": [
            "43727800271133"
          ],
          "available": true,
          "variantId": "43727800271133"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-60x70-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x70-cm-4cm",
            "en": "canvas-frame-60x70-cm-4cm",
            "fr": "chassis-60x70-cm-4cm",
            "it": "telaio-60x70-cm-4cm"
          },
          "productId": "7999381635357",
          "family": "bars",
          "variantIds": [
            "43944845967645"
          ],
          "available": true,
          "variantId": "43944845967645"
        }
      ]
    },
    "60x80": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-60x80-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x80-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-80-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-80-cm-qualite-galerie",
            "it": "telaio-telato-60-x-80-cm-qualita-gallery"
          },
          "productId": "7999188795677",
          "family": "gallery",
          "variantIds": [
            "43728025387293"
          ],
          "available": true,
          "variantId": "43728025387293"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305107741"
          ],
          "available": true,
          "variantId": "49195305107741"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-60x80-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-60x80-cm-roh",
            "en": "floating-frame-set-60x80-cm-unfinished",
            "fr": "kit-de-caisse-americaine-60x80-cm-brut",
            "it": "set-cornice-a-cassetta-60x80-cm-grezzo"
          },
          "productId": "7999074009373",
          "family": "shadow",
          "variantIds": [
            "43727801385245"
          ],
          "available": true,
          "variantId": "43727801385245"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-60x80-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x80-cm-4cm",
            "en": "canvas-frame-60x80-cm-4cm",
            "fr": "chassis-60x80-cm-4cm",
            "it": "telaio-60x80-cm-4cm"
          },
          "productId": "7999382257949",
          "family": "bars",
          "variantIds": [
            "43944846917917"
          ],
          "available": true,
          "variantId": "43944846917917"
        }
      ]
    },
    "60x90": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-60x90-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x90-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-90-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-90-cm-qualite-galerie",
            "it": "telaio-telato-60-x-90-cm-qualita-gallery"
          },
          "productId": "7999189418269",
          "family": "gallery",
          "variantIds": [
            "43728027156765"
          ],
          "available": true,
          "variantId": "43728027156765"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-60x90-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-60x90-cm-roh",
            "en": "floating-frame-set-60x90-cm-unfinished",
            "fr": "kit-de-caisse-americaine-60x90-cm-brut",
            "it": "set-cornice-a-cassetta-60x90-cm-grezzo"
          },
          "productId": "7999074959645",
          "family": "shadow",
          "variantIds": [
            "43727803187485"
          ],
          "available": true,
          "variantId": "43727803187485"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-60x90-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x90-cm-4cm",
            "en": "canvas-frame-60x90-cm-4cm",
            "fr": "chassis-60x90-cm-4cm",
            "it": "telaio-60x90-cm-4cm"
          },
          "productId": "7999382683933",
          "family": "bars",
          "variantIds": [
            "43944847606045"
          ],
          "available": true,
          "variantId": "43944847606045"
        }
      ]
    },
    "60x100": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-60x100-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x100-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-100-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-100-cm-qualite-galerie",
            "it": "telaio-telato-60-x-100-cm-qualita-gallery"
          },
          "productId": "7999189909789",
          "family": "gallery",
          "variantIds": [
            "43728027648285"
          ],
          "available": true,
          "variantId": "43728027648285"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-60x100-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-60x100-cm-roh",
            "en": "floating-frame-set-60x100-cm-unfinished",
            "fr": "kit-de-caisse-americaine-60x100-cm-brut",
            "it": "set-cornice-a-cassetta-60x100-cm-grezzo"
          },
          "productId": "7999075877149",
          "family": "shadow",
          "variantIds": [
            "43727804301597"
          ],
          "available": true,
          "variantId": "43727804301597"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-60x100-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x100-cm-4cm",
            "en": "canvas-frame-60x100-cm-4cm",
            "fr": "chassis-60x100-cm-4cm",
            "it": "telaio-60x100-cm-4cm"
          },
          "productId": "7999383208221",
          "family": "bars",
          "variantIds": [
            "43944848326941"
          ],
          "available": true,
          "variantId": "43944848326941"
        }
      ]
    },
    "60x110": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-60x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-110-cm-qualite-galerie",
            "it": "telaio-telato-60-x-110-cm-qualita-gallery"
          },
          "productId": "7999190532381",
          "family": "gallery",
          "variantIds": [
            "43728028434717"
          ],
          "available": true,
          "variantId": "43728028434717"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-60x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x110-cm-4cm",
            "en": "canvas-frame-60x110-cm-4cm",
            "fr": "chassis-60x110-cm-4cm",
            "it": "telaio-60x110-cm-4cm"
          },
          "productId": "7999383830813",
          "family": "bars",
          "variantIds": [
            "43944849015069"
          ],
          "available": true,
          "variantId": "43944849015069"
        }
      ]
    },
    "60x120": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-60x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-120-cm-qualite-galerie",
            "it": "telaio-telato-60-x-120-cm-qualita-gallery"
          },
          "productId": "7999191220509",
          "family": "gallery",
          "variantIds": [
            "43728029614365"
          ],
          "available": true,
          "variantId": "43728029614365"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-60x120-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-60x120-cm-roh",
            "en": "floating-frame-set-60x120-cm-unfinished",
            "fr": "kit-de-caisse-americaine-60x120-cm-brut",
            "it": "set-cornice-a-cassetta-60x120-cm-grezzo"
          },
          "productId": "7999076925725",
          "family": "shadow",
          "variantIds": [
            "43727805546781"
          ],
          "available": true,
          "variantId": "43727805546781"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-60x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x120-cm-4cm",
            "en": "canvas-frame-60x120-cm-4cm",
            "fr": "chassis-60x120-cm-4cm",
            "it": "telaio-60x120-cm-4cm"
          },
          "productId": "7999384453405",
          "family": "bars",
          "variantIds": [
            "43944849867037"
          ],
          "available": true,
          "variantId": "43944849867037"
        }
      ]
    },
    "60x130": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-60x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-130-cm-qualite-galerie",
            "it": "telaio-telato-60-x-130-cm-qualita-gallery"
          },
          "productId": "7999191810333",
          "family": "gallery",
          "variantIds": [
            "43728032629021"
          ],
          "available": true,
          "variantId": "43728032629021"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-60x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x130-cm-4cm",
            "en": "canvas-frame-60x130-cm-4cm",
            "fr": "chassis-60x130-cm-4cm",
            "it": "telaio-60x130-cm-4cm"
          },
          "productId": "7999384879389",
          "family": "bars",
          "variantIds": [
            "43944850293021"
          ],
          "available": true,
          "variantId": "43944850293021"
        }
      ]
    },
    "60x140": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-60x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-140-cm-qualite-galerie",
            "it": "telaio-telato-60-x-140-cm-qualita-gallery"
          },
          "productId": "7999192400157",
          "family": "gallery",
          "variantIds": [
            "43728033644829"
          ],
          "available": true,
          "variantId": "43728033644829"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-60x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-60x140-cm-roh",
            "en": "floating-frame-set-60x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-60x140-cm-brut",
            "it": "set-cornice-a-cassetta-60x140-cm-grezzo"
          },
          "productId": "7999077679389",
          "family": "shadow",
          "variantIds": [
            "43727806529821"
          ],
          "available": false,
          "variantId": "43727806529821"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-60x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x140-cm-4cm",
            "en": "canvas-frame-60x140-cm-4cm",
            "fr": "chassis-60x140-cm-4cm",
            "it": "telaio-60x140-cm-4cm"
          },
          "productId": "7999385272605",
          "family": "bars",
          "variantIds": [
            "43944852259101"
          ],
          "available": true,
          "variantId": "43944852259101"
        }
      ]
    },
    "60x150": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-60x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-150-cm-qualite-galerie",
            "it": "telaio-telato-60-x-150-cm-qualita-gallery"
          },
          "productId": "7999192858909",
          "family": "gallery",
          "variantIds": [
            "43728034103581"
          ],
          "available": true,
          "variantId": "43728034103581"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-60x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x150-cm-4cm",
            "en": "canvas-frame-60x150-cm-4cm",
            "fr": "chassis-60x150-cm-4cm",
            "it": "telaio-60x150-cm-4cm"
          },
          "productId": "7999385829661",
          "family": "bars",
          "variantIds": [
            "43944853274909"
          ],
          "available": true,
          "variantId": "43944853274909"
        }
      ]
    },
    "60x160": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-60x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-160-cm-qualite-galerie",
            "it": "telaio-telato-60-x-160-cm-qualita-gallery"
          },
          "productId": "7999193415965",
          "family": "gallery",
          "variantIds": [
            "43728034824477"
          ],
          "available": true,
          "variantId": "43728034824477"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-60x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x160-cm-4cm",
            "en": "canvas-frame-60x160-cm-4cm",
            "fr": "chassis-60x160-cm-4cm",
            "it": "telaio-60x160-cm-4cm"
          },
          "productId": "7999386222877",
          "family": "bars",
          "variantIds": [
            "43944853668125"
          ],
          "available": true,
          "variantId": "43944853668125"
        }
      ]
    },
    "60x170": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-60x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-170-cm-qualite-galerie",
            "it": "telaio-telato-60-x-170-cm-qualita-gallery"
          },
          "productId": "7999194071325",
          "family": "gallery",
          "variantIds": [
            "43728035741981"
          ],
          "available": true,
          "variantId": "43728035741981"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-60x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x170-cm-4cm",
            "en": "canvas-frame-60x170-cm-4cm",
            "fr": "chassis-60x170-cm-4cm",
            "it": "telaio-60x170-cm-4cm"
          },
          "productId": "7999386681629",
          "family": "bars",
          "variantIds": [
            "43944854126877"
          ],
          "available": true,
          "variantId": "43944854126877"
        }
      ]
    },
    "60x180": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-60x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-180-cm-qualite-galerie",
            "it": "telaio-telato-60-x-180-cm-qualita-gallery"
          },
          "productId": "7999194726685",
          "family": "gallery",
          "variantIds": [
            "43728037511453"
          ],
          "available": true,
          "variantId": "43728037511453"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-60x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x180-cm-4cm",
            "en": "canvas-frame-60x180-cm-4cm",
            "fr": "chassis-60x180-cm-4cm",
            "it": "telaio-60x180-cm-4cm"
          },
          "productId": "7999387173149",
          "family": "bars",
          "variantIds": [
            "43944854716701"
          ],
          "available": true,
          "variantId": "43944854716701"
        }
      ]
    },
    "60x195": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-60x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-195-cm-qualite-galerie",
            "it": "telaio-telato-60-x-195-cm-qualita-gallery"
          },
          "productId": "7999195316509",
          "family": "gallery",
          "variantIds": [
            "43728038265117"
          ],
          "available": true,
          "variantId": "43728038265117"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-60x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x195-cm-4cm",
            "en": "canvas-frame-60x195-cm-4cm",
            "fr": "chassis-60x195-cm-4cm",
            "it": "telaio-60x195-cm-4cm"
          },
          "productId": "7999387533597",
          "family": "bars",
          "variantIds": [
            "43944855077149"
          ],
          "available": true,
          "variantId": "43944855077149"
        }
      ]
    },
    "70x70": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-70x70-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x70-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-70-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-70-cm-qualite-galerie",
            "it": "telaio-telato-70-x-70-cm-qualita-gallery"
          },
          "productId": "7999195775261",
          "family": "gallery",
          "variantIds": [
            "43728038986013"
          ],
          "available": true,
          "variantId": "43728038986013"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "50388583940381"
          ],
          "available": true,
          "variantId": "50388583940381"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-70x70-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-70x70-cm-roh",
            "en": "floating-frame-set-70x70-cm-unfinished",
            "fr": "kit-de-caisse-americaine-70x70-cm-brut",
            "it": "set-cornice-a-cassetta-70x70-cm-grezzo"
          },
          "productId": "7999078760733",
          "family": "shadow",
          "variantIds": [
            "43727809904925"
          ],
          "available": true,
          "variantId": "43727809904925"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-70x70-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x70-cm-4cm",
            "en": "canvas-frame-70x70-cm-4cm",
            "fr": "chassis-70x70-cm-4cm",
            "it": "telaio-70x70-cm-4cm"
          },
          "productId": "7999388025117",
          "family": "bars",
          "variantIds": [
            "43944855568669"
          ],
          "available": true,
          "variantId": "43944855568669"
        }
      ]
    },
    "70x80": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-70x80-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x80-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-80-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-80-cm-qualite-galerie",
            "it": "telaio-telato-70-x-80-cm-qualita-gallery"
          },
          "productId": "7999196397853",
          "family": "gallery",
          "variantIds": [
            "43728040263965"
          ],
          "available": true,
          "variantId": "43728040263965"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305042205"
          ],
          "available": true,
          "variantId": "49195305042205"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-70x80-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-70x80-cm-roh",
            "en": "floating-frame-set-70x80-cm-unfinished",
            "fr": "kit-de-caisse-americaine-70x80-cm-brut",
            "it": "set-cornice-a-cassetta-70x80-cm-grezzo"
          },
          "productId": "7999079678237",
          "family": "shadow",
          "variantIds": [
            "43727811641629"
          ],
          "available": true,
          "variantId": "43727811641629"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-70x80-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x80-cm-4cm",
            "en": "canvas-frame-70x80-cm-4cm",
            "fr": "chassis-70x80-cm-4cm",
            "it": "telaio-70x80-cm-4cm"
          },
          "productId": "7999388483869",
          "family": "bars",
          "variantIds": [
            "43944856027421"
          ],
          "available": true,
          "variantId": "43944856027421"
        }
      ]
    },
    "70x90": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-70x90-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x90-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-90-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-90-cm-qualite-galerie",
            "it": "telaio-telato-70-x-90-cm-qualita-gallery"
          },
          "productId": "7999196823837",
          "family": "gallery",
          "variantIds": [
            "43728040689949"
          ],
          "available": true,
          "variantId": "43728040689949"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-70x90-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-70x90-cm-roh",
            "en": "floating-frame-set-70x90-cm-unfinished",
            "fr": "kit-de-caisse-americaine-70x90-cm-brut",
            "it": "set-cornice-a-cassetta-70x90-cm-grezzo"
          },
          "productId": "7999080694045",
          "family": "shadow",
          "variantIds": [
            "43727813148957"
          ],
          "available": true,
          "variantId": "43727813148957"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-70x90-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x90-cm-4cm",
            "en": "canvas-frame-70x90-cm-4cm",
            "fr": "chassis-70x90-cm-4cm",
            "it": "telaio-70x90-cm-4cm"
          },
          "productId": "7999388975389",
          "family": "bars",
          "variantIds": [
            "43944856584477"
          ],
          "available": true,
          "variantId": "43944856584477"
        }
      ]
    },
    "70x100": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-70x100-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x100-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-100-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-100-cm-qualite-galerie",
            "it": "telaio-telato-70-x-100-cm-qualita-gallery"
          },
          "productId": "7999197544733",
          "family": "gallery",
          "variantIds": [
            "43728041836829"
          ],
          "available": true,
          "variantId": "43728041836829"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49727469060381"
          ],
          "available": true,
          "variantId": "49727469060381"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-70x100-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-70x100-cm-roh",
            "en": "floating-frame-set-70x100-cm-unfinished",
            "fr": "kit-de-caisse-americaine-70x100-cm-brut",
            "it": "set-cornice-a-cassetta-70x100-cm-grezzo"
          },
          "productId": "7999081447709",
          "family": "shadow",
          "variantIds": [
            "43727814099229"
          ],
          "available": true,
          "variantId": "43727814099229"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-70x100-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x100-cm-4cm",
            "en": "canvas-frame-70x100-cm-4cm",
            "fr": "chassis-70x100-cm-4cm",
            "it": "telaio-70x100-cm-4cm"
          },
          "productId": "7999389466909",
          "family": "bars",
          "variantIds": [
            "43944858616093"
          ],
          "available": true,
          "variantId": "43944858616093"
        }
      ]
    },
    "70x110": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-70x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-110-cm-qualite-galerie",
            "it": "telaio-telato-70-x-110-cm-qualita-gallery"
          },
          "productId": "7999198200093",
          "family": "gallery",
          "variantIds": [
            "43728043573533"
          ],
          "available": true,
          "variantId": "43728043573533"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-70x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x110-cm-4cm",
            "en": "canvas-frame-70x110-cm-4cm",
            "fr": "chassis-70x110-cm-4cm",
            "it": "telaio-70x110-cm-4cm"
          },
          "productId": "7999389925661",
          "family": "bars",
          "variantIds": [
            "43944859074845"
          ],
          "available": true,
          "variantId": "43944859074845"
        }
      ]
    },
    "70x120": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-70x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-120-cm-qualite-galerie",
            "it": "telaio-telato-70-x-120-cm-qualita-gallery"
          },
          "productId": "7999198920989",
          "family": "gallery",
          "variantIds": [
            "43728048685341"
          ],
          "available": true,
          "variantId": "43728048685341"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-70x120-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-70x120-cm-roh",
            "en": "floating-frame-set-70x120-cm-unfinished",
            "fr": "kit-de-caisse-americaine-70x120-cm-brut",
            "it": "set-cornice-a-cassetta-70x120-cm-grezzo"
          },
          "productId": "7999082397981",
          "family": "shadow",
          "variantIds": [
            "43727815049501"
          ],
          "available": true,
          "variantId": "43727815049501"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-70x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x120-cm-4cm",
            "en": "canvas-frame-70x120-cm-4cm",
            "fr": "chassis-70x120-cm-4cm",
            "it": "telaio-70x120-cm-4cm"
          },
          "productId": "7999390449949",
          "family": "bars",
          "variantIds": [
            "43944859664669"
          ],
          "available": true,
          "variantId": "43944859664669"
        }
      ]
    },
    "70x130": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-70x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-130-cm-qualite-galerie",
            "it": "telaio-telato-70-x-130-cm-qualita-gallery"
          },
          "productId": "7999199641885",
          "family": "gallery",
          "variantIds": [
            "43728050454813"
          ],
          "available": true,
          "variantId": "43728050454813"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-70x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x130-cm-4cm",
            "en": "canvas-frame-70x130-cm-4cm",
            "fr": "chassis-70x130-cm-4cm",
            "it": "telaio-70x130-cm-4cm"
          },
          "productId": "7999390908701",
          "family": "bars",
          "variantIds": [
            "43944860156189"
          ],
          "available": true,
          "variantId": "43944860156189"
        }
      ]
    },
    "70x140": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-70x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-140-cm-qualite-galerie",
            "it": "telaio-telato-70-x-140-cm-qualita-gallery"
          },
          "productId": "7999200395549",
          "family": "gallery",
          "variantIds": [
            "43728052060445"
          ],
          "available": true,
          "variantId": "43728052060445"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-70x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-70x140-cm-roh",
            "en": "floating-frame-set-70x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-70x140-cm-brut",
            "it": "set-cornice-a-cassetta-70x140-cm-grezzo"
          },
          "productId": "7999083348253",
          "family": "shadow",
          "variantIds": [
            "43727816163613"
          ],
          "available": false,
          "variantId": "43727816163613"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-70x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x140-cm-4cm",
            "en": "canvas-frame-70x140-cm-4cm",
            "fr": "chassis-70x140-cm-4cm",
            "it": "telaio-70x140-cm-4cm"
          },
          "productId": "7999391334685",
          "family": "bars",
          "variantIds": [
            "43944860713245"
          ],
          "available": true,
          "variantId": "43944860713245"
        }
      ]
    },
    "70x150": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-70x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-150-cm-qualite-galerie",
            "it": "telaio-telato-70-x-150-cm-qualita-gallery"
          },
          "productId": "7999201083677",
          "family": "gallery",
          "variantIds": [
            "43728054714653"
          ],
          "available": true,
          "variantId": "43728054714653"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-70x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x150-cm-4cm",
            "en": "canvas-frame-70x150-cm-4cm",
            "fr": "chassis-70x150-cm-4cm",
            "it": "telaio-70x150-cm-4cm"
          },
          "productId": "7999391760669",
          "family": "bars",
          "variantIds": [
            "43944861139229"
          ],
          "available": true,
          "variantId": "43944861139229"
        }
      ]
    },
    "70x160": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-70x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-160-cm-qualite-galerie",
            "it": "telaio-telato-70-x-160-cm-qualita-gallery"
          },
          "productId": "7999201706269",
          "family": "gallery",
          "variantIds": [
            "43728056353053"
          ],
          "available": true,
          "variantId": "43728056353053"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-70x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x160-cm-4cm",
            "en": "canvas-frame-70x160-cm-4cm",
            "fr": "chassis-70x160-cm-4cm",
            "it": "telaio-70x160-cm-4cm"
          },
          "productId": "7999392186653",
          "family": "bars",
          "variantIds": [
            "43944861597981"
          ],
          "available": true,
          "variantId": "43944861597981"
        }
      ]
    },
    "70x170": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-70x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-170-cm-qualite-galerie",
            "it": "telaio-telato-70-x-170-cm-qualita-gallery"
          },
          "productId": "7999202394397",
          "family": "gallery",
          "variantIds": [
            "43728058679581"
          ],
          "available": true,
          "variantId": "43728058679581"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-70x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x170-cm-4cm",
            "en": "canvas-frame-70x170-cm-4cm",
            "fr": "chassis-70x170-cm-4cm",
            "it": "telaio-70x170-cm-4cm"
          },
          "productId": "7999392743709",
          "family": "bars",
          "variantIds": [
            "43944862155037"
          ],
          "available": true,
          "variantId": "43944862155037"
        }
      ]
    },
    "70x180": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-70x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-180-cm-qualite-galerie",
            "it": "telaio-telato-70-x-180-cm-qualita-gallery"
          },
          "productId": "7999203180829",
          "family": "gallery",
          "variantIds": [
            "43728060547357"
          ],
          "available": true,
          "variantId": "43728060547357"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-70x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x180-cm-4cm",
            "en": "canvas-frame-70x180-cm-4cm",
            "fr": "chassis-70x180-cm-4cm",
            "it": "telaio-70x180-cm-4cm"
          },
          "productId": "7999393333533",
          "family": "bars",
          "variantIds": [
            "43944862941469"
          ],
          "available": true,
          "variantId": "43944862941469"
        }
      ]
    },
    "70x195": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-70x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-195-cm-qualite-galerie",
            "it": "telaio-telato-70-x-195-cm-qualita-gallery"
          },
          "productId": "7999203868957",
          "family": "gallery",
          "variantIds": [
            "43728061858077"
          ],
          "available": true,
          "variantId": "43728061858077"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-70x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x195-cm-4cm",
            "en": "canvas-frame-70x195-cm-4cm",
            "fr": "chassis-70x195-cm-4cm",
            "it": "telaio-70x195-cm-4cm"
          },
          "productId": "7999393857821",
          "family": "bars",
          "variantIds": [
            "43944864219421"
          ],
          "available": true,
          "variantId": "43944864219421"
        }
      ]
    },
    "80x80": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-80x80-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x80-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-80-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-80-cm-qualite-galerie",
            "it": "telaio-telato-80-x-80-cm-qualita-gallery"
          },
          "productId": "7999204557085",
          "family": "gallery",
          "variantIds": [
            "43728064807197"
          ],
          "available": true,
          "variantId": "43728064807197"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305533725"
          ],
          "available": true,
          "variantId": "49195305533725"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-80x80-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-80x80-cm-roh",
            "en": "floating-frame-set-80x80-cm-unfinished",
            "fr": "kit-de-caisse-americaine-80x80-cm-brut",
            "it": "set-cornice-a-cassetta-80x80-cm-grezzo"
          },
          "productId": "7999084331293",
          "family": "shadow",
          "variantIds": [
            "43727817277725"
          ],
          "available": true,
          "variantId": "43727817277725"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-80x80-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x80-cm-4cm",
            "en": "canvas-frame-80x80-cm-4cm",
            "fr": "chassis-80x80-cm-4cm",
            "it": "telaio-80x80-cm-4cm"
          },
          "productId": "7999394382109",
          "family": "bars",
          "variantIds": [
            "43944864743709"
          ],
          "available": true,
          "variantId": "43944864743709"
        }
      ]
    },
    "80x90": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-80x90-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x90-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-90-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-90-cm-qualite-galerie",
            "it": "telaio-telato-80-x-90-cm-qualita-gallery"
          },
          "productId": "7999205376285",
          "family": "gallery",
          "variantIds": [
            "43728066642205"
          ],
          "available": true,
          "variantId": "43728066642205"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-80x90-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-80x90-cm-roh",
            "en": "floating-frame-set-80x90-cm-unfinished",
            "fr": "kit-de-caisse-americaine-80x90-cm-brut",
            "it": "set-cornice-a-cassetta-80x90-cm-grezzo"
          },
          "productId": "7999085412637",
          "family": "shadow",
          "variantIds": [
            "43727820685597"
          ],
          "available": true,
          "variantId": "43727820685597"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-80x90-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x90-cm-4cm",
            "en": "canvas-frame-80x90-cm-4cm",
            "fr": "chassis-80x90-cm-4cm",
            "it": "telaio-80x90-cm-4cm"
          },
          "productId": "7999394840861",
          "family": "bars",
          "variantIds": [
            "43944865267997"
          ],
          "available": true,
          "variantId": "43944865267997"
        }
      ]
    },
    "80x100": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-80x100-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x100-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-100-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-100-cm-qualite-galerie",
            "it": "telaio-telato-80-x-100-cm-qualita-gallery"
          },
          "productId": "7999206195485",
          "family": "gallery",
          "variantIds": [
            "43728069853469"
          ],
          "available": true,
          "variantId": "43728069853469"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49725398286621"
          ],
          "available": false,
          "variantId": "49725398286621"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-80x100-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-80x100-cm-roh",
            "en": "floating-frame-set-80x100-cm-unfinished",
            "fr": "kit-de-caisse-americaine-80x100-cm-brut",
            "it": "set-cornice-a-cassetta-80x100-cm-grezzo"
          },
          "productId": "7999086592285",
          "family": "shadow",
          "variantIds": [
            "43727824552221"
          ],
          "available": true,
          "variantId": "43727824552221"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-80x100-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x100-cm-4cm",
            "en": "canvas-frame-80x100-cm-4cm",
            "fr": "chassis-80x100-cm-4cm",
            "it": "telaio-80x100-cm-4cm"
          },
          "productId": "7999395430685",
          "family": "bars",
          "variantIds": [
            "43944867135773"
          ],
          "available": true,
          "variantId": "43944867135773"
        }
      ]
    },
    "80x110": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-80x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-110-cm-qualite-galerie",
            "it": "telaio-telato-80-x-110-cm-qualita-gallery"
          },
          "productId": "7999206883613",
          "family": "gallery",
          "variantIds": [
            "43728071622941"
          ],
          "available": true,
          "variantId": "43728071622941"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-80x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x110-cm-4cm",
            "en": "canvas-frame-80x110-cm-4cm",
            "fr": "chassis-80x110-cm-4cm",
            "it": "telaio-80x110-cm-4cm"
          },
          "productId": "7999396020509",
          "family": "bars",
          "variantIds": [
            "43944867725597"
          ],
          "available": true,
          "variantId": "43944867725597"
        }
      ]
    },
    "80x120": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-80x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-120-cm-qualite-galerie",
            "it": "telaio-telato-80-x-120-cm-qualita-gallery"
          },
          "productId": "7999207506205",
          "family": "gallery",
          "variantIds": [
            "43728073621789"
          ],
          "available": true,
          "variantId": "43728073621789"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49727497077021"
          ],
          "available": true,
          "variantId": "49727497077021"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-80x120-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-80x120-cm-roh",
            "en": "floating-frame-set-80x120-cm-unfinished",
            "fr": "kit-de-caisse-americaine-80x120-cm-brut",
            "it": "set-cornice-a-cassetta-80x120-cm-grezzo"
          },
          "productId": "7999087313181",
          "family": "shadow",
          "variantIds": [
            "43727826649373"
          ],
          "available": true,
          "variantId": "43727826649373"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-80x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x120-cm-4cm",
            "en": "canvas-frame-80x120-cm-4cm",
            "fr": "chassis-80x120-cm-4cm",
            "it": "telaio-80x120-cm-4cm"
          },
          "productId": "7999396544797",
          "family": "bars",
          "variantIds": [
            "43944870805789"
          ],
          "available": true,
          "variantId": "43944870805789"
        }
      ]
    },
    "80x130": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-80x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-130-cm-qualite-galerie",
            "it": "telaio-telato-80-x-130-cm-qualita-gallery"
          },
          "productId": "7999208325405",
          "family": "gallery",
          "variantIds": [
            "43728075915549"
          ],
          "available": true,
          "variantId": "43728075915549"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-80x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x130-cm-4cm",
            "en": "canvas-frame-80x130-cm-4cm",
            "fr": "chassis-80x130-cm-4cm",
            "it": "telaio-80x130-cm-4cm"
          },
          "productId": "7999397069085",
          "family": "bars",
          "variantIds": [
            "43944871330077"
          ],
          "available": true,
          "variantId": "43944871330077"
        }
      ]
    },
    "80x140": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-80x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-140-cm-qualite-galerie",
            "it": "telaio-telato-80-x-140-cm-qualita-gallery"
          },
          "productId": "7999209177373",
          "family": "gallery",
          "variantIds": [
            "43728077750557"
          ],
          "available": true,
          "variantId": "43728077750557"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-80x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-80x140-cm-roh",
            "en": "floating-frame-set-80x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-80x140-cm-brut",
            "it": "set-cornice-a-cassetta-80x140-cm-grezzo"
          },
          "productId": "7999088034077",
          "family": "shadow",
          "variantIds": [
            "43727828877597"
          ],
          "available": false,
          "variantId": "43727828877597"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-80x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x140-cm-4cm",
            "en": "canvas-frame-80x140-cm-4cm",
            "fr": "chassis-80x140-cm-4cm",
            "it": "telaio-80x140-cm-4cm"
          },
          "productId": "7999397724445",
          "family": "bars",
          "variantIds": [
            "43944873787677"
          ],
          "available": true,
          "variantId": "43944873787677"
        }
      ]
    },
    "80x150": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-80x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-150-cm-qualite-galerie",
            "it": "telaio-telato-80-x-150-cm-qualita-gallery"
          },
          "productId": "7999209832733",
          "family": "gallery",
          "variantIds": [
            "43728078635293"
          ],
          "available": true,
          "variantId": "43728078635293"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-80x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x150-cm-4cm",
            "en": "canvas-frame-80x150-cm-4cm",
            "fr": "chassis-80x150-cm-4cm",
            "it": "telaio-80x150-cm-4cm"
          },
          "productId": "7999398019357",
          "family": "bars",
          "variantIds": [
            "43944874049821"
          ],
          "available": true,
          "variantId": "43944874049821"
        }
      ]
    },
    "80x160": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-80x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-160-cm-qualite-galerie",
            "it": "telaio-telato-80-x-160-cm-qualita-gallery"
          },
          "productId": "7999210324253",
          "family": "gallery",
          "variantIds": [
            "43728079257885"
          ],
          "available": true,
          "variantId": "43728079257885"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-80x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x160-cm-4cm",
            "en": "canvas-frame-80x160-cm-4cm",
            "fr": "chassis-80x160-cm-4cm",
            "it": "telaio-80x160-cm-4cm"
          },
          "productId": "7999398379805",
          "family": "bars",
          "variantIds": [
            "43944874443037"
          ],
          "available": true,
          "variantId": "43944874443037"
        }
      ]
    },
    "80x170": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-80x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-170-cm-qualite-galerie",
            "it": "telaio-telato-80-x-170-cm-qualita-gallery"
          },
          "productId": "7999210914077",
          "family": "gallery",
          "variantIds": [
            "43728080503069"
          ],
          "available": true,
          "variantId": "43728080503069"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-80x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x170-cm-4cm",
            "en": "canvas-frame-80x170-cm-4cm",
            "fr": "chassis-80x170-cm-4cm",
            "it": "telaio-80x170-cm-4cm"
          },
          "productId": "7999398707485",
          "family": "bars",
          "variantIds": [
            "43944875163933"
          ],
          "available": true,
          "variantId": "43944875163933"
        }
      ]
    },
    "80x180": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-80x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-180-cm-qualite-galerie",
            "it": "telaio-telato-80-x-180-cm-qualita-gallery"
          },
          "productId": "7999211667741",
          "family": "gallery",
          "variantIds": [
            "43728083091741"
          ],
          "available": true,
          "variantId": "43728083091741"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-80x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x180-cm-4cm",
            "en": "canvas-frame-80x180-cm-4cm",
            "fr": "chassis-80x180-cm-4cm",
            "it": "telaio-80x180-cm-4cm"
          },
          "productId": "7999399395613",
          "family": "bars",
          "variantIds": [
            "43944879194397"
          ],
          "available": true,
          "variantId": "43944879194397"
        }
      ]
    },
    "80x195": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-80x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-195-cm-qualite-galerie",
            "it": "telaio-telato-80-x-195-cm-qualita-gallery"
          },
          "productId": "7999212257565",
          "family": "gallery",
          "variantIds": [
            "43728083976477"
          ],
          "available": true,
          "variantId": "43728083976477"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-80x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x195-cm-4cm",
            "en": "canvas-frame-80x195-cm-4cm",
            "fr": "chassis-80x195-cm-4cm",
            "it": "telaio-80x195-cm-4cm"
          },
          "productId": "7999400050973",
          "family": "bars",
          "variantIds": [
            "43944881127709"
          ],
          "available": true,
          "variantId": "43944881127709"
        }
      ]
    },
    "90x90": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-90x90-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x90-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-90-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-90-cm-qualite-galerie",
            "it": "telaio-telato-90-x-90-cm-qualita-gallery"
          },
          "productId": "7999212683549",
          "family": "gallery",
          "variantIds": [
            "43728084599069"
          ],
          "available": true,
          "variantId": "43728084599069"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "51801724616989"
          ],
          "available": false,
          "variantId": "51801724616989"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-90x90-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-90x90-cm-roh",
            "en": "floating-frame-set-90x90-cm-unfinished",
            "fr": "kit-de-caisse-americaine-90x90-cm-brut",
            "it": "set-cornice-a-cassetta-90x90-cm-grezzo"
          },
          "productId": "7999088689437",
          "family": "shadow",
          "variantIds": [
            "43727831859485"
          ],
          "available": true,
          "variantId": "43727831859485"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-90x90-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x90-cm-4cm",
            "en": "canvas-frame-90x90-cm-4cm",
            "fr": "chassis-90x90-cm-4cm",
            "it": "telaio-90x90-cm-4cm"
          },
          "productId": "7999400476957",
          "family": "bars",
          "variantIds": [
            "43944882274589"
          ],
          "available": true,
          "variantId": "43944882274589"
        }
      ]
    },
    "90x100": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-90x100-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x100-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-100-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-100-cm-qualite-galerie",
            "it": "telaio-telato-90-x-100-cm-qualita-gallery"
          },
          "productId": "7999213207837",
          "family": "gallery",
          "variantIds": [
            "43728086204701"
          ],
          "available": true,
          "variantId": "43728086204701"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49727449202973"
          ],
          "available": true,
          "variantId": "49727449202973"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-90x100-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-90x100-cm-roh",
            "en": "floating-frame-set-90x100-cm-unfinished",
            "fr": "kit-de-caisse-americaine-90x100-cm-brut",
            "it": "set-cornice-a-cassetta-90x100-cm-grezzo"
          },
          "productId": "7999089344797",
          "family": "shadow",
          "variantIds": [
            "43727836381469"
          ],
          "available": true,
          "variantId": "43727836381469"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-90x100-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x100-cm-4cm",
            "en": "canvas-frame-90x100-cm-4cm",
            "fr": "chassis-90x100-cm-4cm",
            "it": "telaio-90x100-cm-4cm"
          },
          "productId": "7999400968477",
          "family": "bars",
          "variantIds": [
            "43944882864413"
          ],
          "available": true,
          "variantId": "43944882864413"
        }
      ]
    },
    "90x110": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-90x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-110-cm-qualite-galerie",
            "it": "telaio-telato-90-x-110-cm-qualita-gallery"
          },
          "productId": "7999214027037",
          "family": "gallery",
          "variantIds": [
            "43728088269085"
          ],
          "available": true,
          "variantId": "43728088269085"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-90x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x110-cm-4cm",
            "en": "canvas-frame-90x110-cm-4cm",
            "fr": "chassis-90x110-cm-4cm",
            "it": "telaio-90x110-cm-4cm"
          },
          "productId": "7999401492765",
          "family": "bars",
          "variantIds": [
            "43944884764957"
          ],
          "available": true,
          "variantId": "43944884764957"
        }
      ]
    },
    "90x120": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-90x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-120-cm-qualite-galerie",
            "it": "telaio-telato-90-x-120-cm-qualita-gallery"
          },
          "productId": "7999214780701",
          "family": "gallery",
          "variantIds": [
            "43728090399005"
          ],
          "available": true,
          "variantId": "43728090399005"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305599261"
          ],
          "available": true,
          "variantId": "49195305599261"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-90x120-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-90x120-cm-roh",
            "en": "floating-frame-set-90x120-cm-unfinished",
            "fr": "kit-de-caisse-americaine-90x120-cm-brut",
            "it": "set-cornice-a-cassetta-90x120-cm-grezzo"
          },
          "productId": "7999090098461",
          "family": "shadow",
          "variantIds": [
            "43727841296669"
          ],
          "available": true,
          "variantId": "43727841296669"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-90x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x120-cm-4cm",
            "en": "canvas-frame-90x120-cm-4cm",
            "fr": "chassis-90x120-cm-4cm",
            "it": "telaio-90x120-cm-4cm"
          },
          "productId": "7999402082589",
          "family": "bars",
          "variantIds": [
            "43944885747997"
          ],
          "available": true,
          "variantId": "43944885747997"
        }
      ]
    },
    "90x130": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-90x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-130-cm-qualite-galerie",
            "it": "telaio-telato-90-x-130-cm-qualita-gallery"
          },
          "productId": "7999215534365",
          "family": "gallery",
          "variantIds": [
            "43728093446429"
          ],
          "available": true,
          "variantId": "43728093446429"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "50388585251101"
          ],
          "available": true,
          "variantId": "50388585251101"
        }
      ],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-90x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x130-cm-4cm",
            "en": "canvas-frame-90x130-cm-4cm",
            "fr": "chassis-90x130-cm-4cm",
            "it": "telaio-90x130-cm-4cm"
          },
          "productId": "7999402475805",
          "family": "bars",
          "variantIds": [
            "43944887058717"
          ],
          "available": true,
          "variantId": "43944887058717"
        }
      ]
    },
    "90x140": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-90x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-140-cm-qualite-galerie",
            "it": "telaio-telato-90-x-140-cm-qualita-gallery"
          },
          "productId": "7999216189725",
          "family": "gallery",
          "variantIds": [
            "43728094658845"
          ],
          "available": true,
          "variantId": "43728094658845"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-90x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-90x140-cm-roh",
            "en": "floating-frame-set-90x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-90x140-cm-brut",
            "it": "set-cornice-a-cassetta-90x140-cm-grezzo"
          },
          "productId": "7999090786589",
          "family": "shadow",
          "variantIds": [
            "43727842803997"
          ],
          "available": false,
          "variantId": "43727842803997"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-90x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x140-cm-4cm",
            "en": "canvas-frame-90x140-cm-4cm",
            "fr": "chassis-90x140-cm-4cm",
            "it": "telaio-90x140-cm-4cm"
          },
          "productId": "7999402934557",
          "family": "bars",
          "variantIds": [
            "43944887714077"
          ],
          "available": true,
          "variantId": "43944887714077"
        }
      ]
    },
    "90x150": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-90x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-150-cm-qualite-galerie",
            "it": "telaio-telato-90-x-150-cm-qualita-gallery"
          },
          "productId": "7999216943389",
          "family": "gallery",
          "variantIds": [
            "43728100163869"
          ],
          "available": true,
          "variantId": "43728100163869"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-90x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x150-cm-4cm",
            "en": "canvas-frame-90x150-cm-4cm",
            "fr": "chassis-90x150-cm-4cm",
            "it": "telaio-90x150-cm-4cm"
          },
          "productId": "7999403491613",
          "family": "bars",
          "variantIds": [
            "43944888500509"
          ],
          "available": true,
          "variantId": "43944888500509"
        }
      ]
    },
    "90x160": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-90x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-160-cm-qualite-galerie",
            "it": "telaio-telato-90-x-160-cm-qualita-gallery"
          },
          "productId": "7999217467677",
          "family": "gallery",
          "variantIds": [
            "43728100983069"
          ],
          "available": true,
          "variantId": "43728100983069"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-90x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x160-cm-4cm",
            "en": "canvas-frame-90x160-cm-4cm",
            "fr": "chassis-90x160-cm-4cm",
            "it": "telaio-90x160-cm-4cm"
          },
          "productId": "7999403950365",
          "family": "bars",
          "variantIds": [
            "43944888959261"
          ],
          "available": true,
          "variantId": "43944888959261"
        }
      ]
    },
    "90x170": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-90x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-170-cm-qualite-galerie",
            "it": "telaio-telato-90-x-170-cm-qualita-gallery"
          },
          "productId": "7999218155805",
          "family": "gallery",
          "variantIds": [
            "43728101736733"
          ],
          "available": true,
          "variantId": "43728101736733"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-90x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x170-cm-4cm",
            "en": "canvas-frame-90x170-cm-4cm",
            "fr": "chassis-90x170-cm-4cm",
            "it": "telaio-90x170-cm-4cm"
          },
          "productId": "7999404376349",
          "family": "bars",
          "variantIds": [
            "43944889483549"
          ],
          "available": true,
          "variantId": "43944889483549"
        }
      ]
    },
    "90x180": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-90x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-180-cm-qualite-galerie",
            "it": "telaio-telato-90-x-180-cm-qualita-gallery"
          },
          "productId": "7999218712861",
          "family": "gallery",
          "variantIds": [
            "43728102359325"
          ],
          "available": true,
          "variantId": "43728102359325"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-90x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x180-cm-4cm",
            "en": "canvas-frame-90x180-cm-4cm",
            "fr": "chassis-90x180-cm-4cm",
            "it": "telaio-90x180-cm-4cm"
          },
          "productId": "7999404966173",
          "family": "bars",
          "variantIds": [
            "43944890302749"
          ],
          "available": true,
          "variantId": "43944890302749"
        }
      ]
    },
    "90x195": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-90x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-195-cm-qualite-galerie",
            "it": "telaio-telato-90-x-195-cm-qualita-gallery"
          },
          "productId": "7999219532061",
          "family": "gallery",
          "variantIds": [
            "43728103735581"
          ],
          "available": true,
          "variantId": "43728103735581"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-90x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x195-cm-4cm",
            "en": "canvas-frame-90x195-cm-4cm",
            "fr": "chassis-90x195-cm-4cm",
            "it": "telaio-90x195-cm-4cm"
          },
          "productId": "7999405621533",
          "family": "bars",
          "variantIds": [
            "43944891154717"
          ],
          "available": true,
          "variantId": "43944891154717"
        }
      ]
    },
    "100x100": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-100x100-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-100x100-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-100-x-100-cm-gallery-quality",
            "fr": "chassis-entoile-100-x-100-cm-qualite-galerie",
            "it": "telaio-telato-100-x-100-cm-qualita-gallery"
          },
          "productId": "7999220187421",
          "family": "gallery",
          "variantIds": [
            "43728104554781"
          ],
          "available": true,
          "variantId": "43728104554781"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305664797"
          ],
          "available": false,
          "variantId": "49195305664797"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-100x100-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-100x100-cm-roh",
            "en": "floating-frame-set-100x100-cm-unfinished",
            "fr": "kit-de-caisse-americaine-100x100-cm-brut",
            "it": "set-cornice-a-cassetta-100x100-cm-grezzo"
          },
          "productId": "7999091278109",
          "family": "shadow",
          "variantIds": [
            "43727844507933"
          ],
          "available": true,
          "variantId": "43727844507933"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-100x100-cm-4cm",
          "handles": {
            "de": "keilrahmen-100x100-cm-4cm",
            "en": "canvas-frame-100x100-cm-4cm",
            "fr": "chassis-100x100-cm-4cm",
            "it": "telaio-100x100-cm-4cm"
          },
          "productId": "7999406113053",
          "family": "bars",
          "variantIds": [
            "43944891744541"
          ],
          "available": true,
          "variantId": "43944891744541"
        }
      ]
    },
    "100x110": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-100x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-100x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-100-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-100-x-110-cm-qualite-galerie",
            "it": "telaio-telato-100-x-110-cm-qualita-gallery"
          },
          "productId": "7999220810013",
          "family": "gallery",
          "variantIds": [
            "43728105439517"
          ],
          "available": true,
          "variantId": "43728105439517"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-100x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-100x110-cm-4cm",
            "en": "canvas-frame-100x110-cm-4cm",
            "fr": "chassis-100x110-cm-4cm",
            "it": "telaio-100x110-cm-4cm"
          },
          "productId": "7999406637341",
          "family": "bars",
          "variantIds": [
            "43944892563741"
          ],
          "available": true,
          "variantId": "43944892563741"
        }
      ]
    },
    "100x120": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-100x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-100x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-100-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-100-x-120-cm-qualite-galerie",
            "it": "telaio-telato-100-x-120-cm-qualita-gallery"
          },
          "productId": "7999221072157",
          "family": "gallery",
          "variantIds": [
            "43728108159261"
          ],
          "available": true,
          "variantId": "43728108159261"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305730333"
          ],
          "available": true,
          "variantId": "49195305730333"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-100x120-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-100x120-cm-roh",
            "en": "floating-frame-set-100x120-cm-unfinished",
            "fr": "kit-de-caisse-americaine-100x120-cm-brut",
            "it": "set-cornice-a-cassetta-100x120-cm-grezzo"
          },
          "productId": "7999091900701",
          "family": "shadow",
          "variantIds": [
            "43727846801693"
          ],
          "available": true,
          "variantId": "43727846801693"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-100x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-100x120-cm-4cm",
            "en": "canvas-frame-100x120-cm-4cm",
            "fr": "chassis-100x120-cm-4cm",
            "it": "telaio-100x120-cm-4cm"
          },
          "productId": "7999407128861",
          "family": "bars",
          "variantIds": [
            "43944893055261"
          ],
          "available": true,
          "variantId": "43944893055261"
        }
      ]
    },
    "100x130": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-100x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-100x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-100-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-100-x-130-cm-qualite-galerie",
            "it": "telaio-telato-100-x-130-cm-qualita-gallery"
          },
          "productId": "7999221170461",
          "family": "gallery",
          "variantIds": [
            "43728108388637"
          ],
          "available": true,
          "variantId": "43728108388637"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-100x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-100x130-cm-4cm",
            "en": "canvas-frame-100x130-cm-4cm",
            "fr": "chassis-100x130-cm-4cm",
            "it": "telaio-100x130-cm-4cm"
          },
          "productId": "7999407718685",
          "family": "bars",
          "variantIds": [
            "43944894234909"
          ],
          "available": true,
          "variantId": "43944894234909"
        }
      ]
    },
    "100x140": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-100x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-100x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-100-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-100-x-140-cm-qualite-galerie",
            "it": "telaio-telato-100-x-140-cm-qualita-gallery"
          },
          "productId": "7999221268765",
          "family": "gallery",
          "variantIds": [
            "43728108880157"
          ],
          "available": true,
          "variantId": "43728108880157"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49424623763741",
            "49195305828637"
          ],
          "available": true
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-100x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-100x140-cm-roh",
            "en": "floating-frame-set-100x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-100x140-cm-brut",
            "it": "set-cornice-a-cassetta-100x140-cm-grezzo"
          },
          "productId": "7999092523293",
          "family": "shadow",
          "variantIds": [
            "43727849095453"
          ],
          "available": false,
          "variantId": "43727849095453"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-100x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-100x140-cm-4cm",
            "en": "canvas-frame-100x140-cm-4cm",
            "fr": "chassis-100x140-cm-4cm",
            "it": "telaio-100x140-cm-4cm"
          },
          "productId": "7999408242973",
          "family": "bars",
          "variantIds": [
            "43944894890269"
          ],
          "available": true,
          "variantId": "43944894890269"
        }
      ]
    },
    "100x150": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-100x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-100x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-100-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-100-x-150-cm-qualite-galerie",
            "it": "telaio-telato-100-x-150-cm-qualita-gallery"
          },
          "productId": "7999221530909",
          "family": "gallery",
          "variantIds": [
            "43728109273373"
          ],
          "available": true,
          "variantId": "43728109273373"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-100x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-100x150-cm-4cm",
            "en": "canvas-frame-100x150-cm-4cm",
            "fr": "chassis-100x150-cm-4cm",
            "it": "telaio-100x150-cm-4cm"
          },
          "productId": "7999408963869",
          "family": "bars",
          "variantIds": [
            "43944899969309"
          ],
          "available": true,
          "variantId": "43944899969309"
        }
      ]
    },
    "100x160": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-100x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-100x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-100-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-100-x-160-cm-qualite-galerie",
            "it": "telaio-telato-100-x-160-cm-qualita-gallery"
          },
          "productId": "7999222087965",
          "family": "gallery",
          "variantIds": [
            "43728109928733"
          ],
          "available": true,
          "variantId": "43728109928733"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-100x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-100x160-cm-4cm",
            "en": "canvas-frame-100x160-cm-4cm",
            "fr": "chassis-100x160-cm-4cm",
            "it": "telaio-100x160-cm-4cm"
          },
          "productId": "7999409422621",
          "family": "bars",
          "variantIds": [
            "43944900559133"
          ],
          "available": true,
          "variantId": "43944900559133"
        }
      ]
    },
    "100x170": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-100x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-100x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-100-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-100-x-170-cm-qualite-galerie",
            "it": "telaio-telato-100-x-170-cm-qualita-gallery"
          },
          "productId": "7999222710557",
          "family": "gallery",
          "variantIds": [
            "43728110813469"
          ],
          "available": true,
          "variantId": "43728110813469"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-100x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-100x170-cm-4cm",
            "en": "canvas-frame-100x170-cm-4cm",
            "fr": "chassis-100x170-cm-4cm",
            "it": "telaio-100x170-cm-4cm"
          },
          "productId": "7999409848605",
          "family": "bars",
          "variantIds": [
            "43944901083421"
          ],
          "available": true,
          "variantId": "43944901083421"
        }
      ]
    },
    "100x180": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-100x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-100x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-100-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-100-x-180-cm-qualite-galerie",
            "it": "telaio-telato-100-x-180-cm-qualita-gallery"
          },
          "productId": "7999223202077",
          "family": "gallery",
          "variantIds": [
            "43728111436061"
          ],
          "available": true,
          "variantId": "43728111436061"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-100x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-100x180-cm-4cm",
            "en": "canvas-frame-100x180-cm-4cm",
            "fr": "chassis-100x180-cm-4cm",
            "it": "telaio-100x180-cm-4cm"
          },
          "productId": "7999410405661",
          "family": "bars",
          "variantIds": [
            "43944901640477"
          ],
          "available": true,
          "variantId": "43944901640477"
        }
      ]
    },
    "100x195": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-100x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-100x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-100-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-100-x-195-cm-qualite-galerie",
            "it": "telaio-telato-100-x-195-cm-qualita-gallery"
          },
          "productId": "7999223660829",
          "family": "gallery",
          "variantIds": [
            "43728111960349"
          ],
          "available": true,
          "variantId": "43728111960349"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-100x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-100x195-cm-4cm",
            "en": "canvas-frame-100x195-cm-4cm",
            "fr": "chassis-100x195-cm-4cm",
            "it": "telaio-100x195-cm-4cm"
          },
          "productId": "7999410864413",
          "family": "bars",
          "variantIds": [
            "43944902328605"
          ],
          "available": true,
          "variantId": "43944902328605"
        }
      ]
    },
    "110x110": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-110x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-110x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-110-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-110-x-110-cm-qualite-galerie",
            "it": "telaio-telato-110-x-110-cm-qualita-gallery"
          },
          "productId": "7999224217885",
          "family": "gallery",
          "variantIds": [
            "43728112648477"
          ],
          "available": true,
          "variantId": "43728112648477"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-110x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-110x110-cm-4cm",
            "en": "canvas-frame-110x110-cm-4cm",
            "fr": "chassis-110x110-cm-4cm",
            "it": "telaio-110x110-cm-4cm"
          },
          "productId": "7999411323165",
          "family": "bars",
          "variantIds": [
            "43944902787357"
          ],
          "available": true,
          "variantId": "43944902787357"
        }
      ]
    },
    "110x120": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-110x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-110x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-110-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-110-x-120-cm-qualite-galerie",
            "it": "telaio-telato-110-x-120-cm-qualita-gallery"
          },
          "productId": "7999224643869",
          "family": "gallery",
          "variantIds": [
            "43728113205533"
          ],
          "available": true,
          "variantId": "43728113205533"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-110x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-110x120-cm-4cm",
            "en": "canvas-frame-110x120-cm-4cm",
            "fr": "chassis-110x120-cm-4cm",
            "it": "telaio-110x120-cm-4cm"
          },
          "productId": "7999411912989",
          "family": "bars",
          "variantIds": [
            "43944903934237"
          ],
          "available": true,
          "variantId": "43944903934237"
        }
      ]
    },
    "110x130": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-110x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-110x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-110-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-110-x-130-cm-qualite-galerie",
            "it": "telaio-telato-110-x-130-cm-qualita-gallery"
          },
          "productId": "7999225069853",
          "family": "gallery",
          "variantIds": [
            "43728113762589"
          ],
          "available": true,
          "variantId": "43728113762589"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-110x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-110x130-cm-4cm",
            "en": "canvas-frame-110x130-cm-4cm",
            "fr": "chassis-110x130-cm-4cm",
            "it": "telaio-110x130-cm-4cm"
          },
          "productId": "7999412306205",
          "family": "bars",
          "variantIds": [
            "43944904327453"
          ],
          "available": true,
          "variantId": "43944904327453"
        }
      ]
    },
    "110x140": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-110x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-110x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-110-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-110-x-140-cm-qualite-galerie",
            "it": "telaio-telato-110-x-140-cm-qualita-gallery"
          },
          "productId": "7999225495837",
          "family": "gallery",
          "variantIds": [
            "43728114319645"
          ],
          "available": true,
          "variantId": "43728114319645"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-110x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-110x140-cm-4cm",
            "en": "canvas-frame-110x140-cm-4cm",
            "fr": "chassis-110x140-cm-4cm",
            "it": "telaio-110x140-cm-4cm"
          },
          "productId": "7999412764957",
          "family": "bars",
          "variantIds": [
            "43944905015581"
          ],
          "available": true,
          "variantId": "43944905015581"
        }
      ]
    },
    "110x150": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-110x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-110x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-110-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-110-x-150-cm-qualite-galerie",
            "it": "telaio-telato-110-x-150-cm-qualita-gallery"
          },
          "productId": "7999226020125",
          "family": "gallery",
          "variantIds": [
            "43728115892509"
          ],
          "available": true,
          "variantId": "43728115892509"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-110x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-110x150-cm-4cm",
            "en": "canvas-frame-110x150-cm-4cm",
            "fr": "chassis-110x150-cm-4cm",
            "it": "telaio-110x150-cm-4cm"
          },
          "productId": "7999413223709",
          "family": "bars",
          "variantIds": [
            "43944905474333"
          ],
          "available": true,
          "variantId": "43944905474333"
        }
      ]
    },
    "110x160": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-110x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-110x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-110-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-110-x-160-cm-qualite-galerie",
            "it": "telaio-telato-110-x-160-cm-qualita-gallery"
          },
          "productId": "7999226577181",
          "family": "gallery",
          "variantIds": [
            "43728116646173"
          ],
          "available": true,
          "variantId": "43728116646173"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-110x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-110x160-cm-4cm",
            "en": "canvas-frame-110x160-cm-4cm",
            "fr": "chassis-110x160-cm-4cm",
            "it": "telaio-110x160-cm-4cm"
          },
          "productId": "7999413879069",
          "family": "bars",
          "variantIds": [
            "43944906490141"
          ],
          "available": true,
          "variantId": "43944906490141"
        }
      ]
    },
    "110x170": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-110x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-110x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-110-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-110-x-170-cm-qualite-galerie",
            "it": "telaio-telato-110-x-170-cm-qualita-gallery"
          },
          "productId": "7999227134237",
          "family": "gallery",
          "variantIds": [
            "43728119267613"
          ],
          "available": true,
          "variantId": "43728119267613"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-110x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-110x170-cm-4cm",
            "en": "canvas-frame-110x170-cm-4cm",
            "fr": "chassis-110x170-cm-4cm",
            "it": "telaio-110x170-cm-4cm"
          },
          "productId": "7999414337821",
          "family": "bars",
          "variantIds": [
            "43944906948893"
          ],
          "available": true,
          "variantId": "43944906948893"
        }
      ]
    },
    "110x180": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-110x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-110x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-110-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-110-x-180-cm-qualite-galerie",
            "it": "telaio-telato-110-x-180-cm-qualita-gallery"
          },
          "productId": "7999227592989",
          "family": "gallery",
          "variantIds": [
            "43728120447261"
          ],
          "available": true,
          "variantId": "43728120447261"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-110x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-110x180-cm-4cm",
            "en": "canvas-frame-110x180-cm-4cm",
            "fr": "chassis-110x180-cm-4cm",
            "it": "telaio-110x180-cm-4cm"
          },
          "productId": "7999414796573",
          "family": "bars",
          "variantIds": [
            "43944907637021"
          ],
          "available": true,
          "variantId": "43944907637021"
        }
      ]
    },
    "110x195": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-110x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-110x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-110-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-110-x-195-cm-qualite-galerie",
            "it": "telaio-telato-110-x-195-cm-qualita-gallery"
          },
          "productId": "7999228182813",
          "family": "gallery",
          "variantIds": [
            "43728122806557"
          ],
          "available": true,
          "variantId": "43728122806557"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-110x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-110x195-cm-4cm",
            "en": "canvas-frame-110x195-cm-4cm",
            "fr": "chassis-110x195-cm-4cm",
            "it": "telaio-110x195-cm-4cm"
          },
          "productId": "7999415288093",
          "family": "bars",
          "variantIds": [
            "43944908390685"
          ],
          "available": true,
          "variantId": "43944908390685"
        }
      ]
    },
    "120x120": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-120x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-120x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-120-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-120-x-120-cm-qualite-galerie",
            "it": "telaio-telato-120-x-120-cm-qualita-gallery"
          },
          "productId": "7999228838173",
          "family": "gallery",
          "variantIds": [
            "43728123592989"
          ],
          "available": true,
          "variantId": "43728123592989"
        }
      ],
      "studio": [
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "50079645597981"
          ],
          "available": true,
          "variantId": "50079645597981"
        }
      ],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-120x120-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-120x120-cm-roh",
            "en": "floating-frame-set-120x120-cm-unfinished",
            "fr": "kit-de-caisse-americaine-120x120-cm-brut",
            "it": "set-cornice-a-cassetta-120x120-cm-grezzo"
          },
          "productId": "7999093408029",
          "family": "shadow",
          "variantIds": [
            "43727852044573"
          ],
          "available": true,
          "variantId": "43727852044573"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-120x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-120x120-cm-4cm",
            "en": "canvas-frame-120x120-cm-4cm",
            "fr": "chassis-120x120-cm-4cm",
            "it": "telaio-120x120-cm-4cm"
          },
          "productId": "7999415845149",
          "family": "bars",
          "variantIds": [
            "43944908914973"
          ],
          "available": true,
          "variantId": "43944908914973"
        }
      ]
    },
    "120x130": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-120x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-120x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-120-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-120-x-130-cm-qualite-galerie",
            "it": "telaio-telato-120-x-130-cm-qualita-gallery"
          },
          "productId": "7999229198621",
          "family": "gallery",
          "variantIds": [
            "43728124018973"
          ],
          "available": true,
          "variantId": "43728124018973"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-120x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-120x130-cm-4cm",
            "en": "canvas-frame-120x130-cm-4cm",
            "fr": "chassis-120x130-cm-4cm",
            "it": "telaio-120x130-cm-4cm"
          },
          "productId": "7999416467741",
          "family": "bars",
          "variantIds": [
            "43944909865245"
          ],
          "available": true,
          "variantId": "43944909865245"
        }
      ]
    },
    "120x140": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-120x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-120x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-120-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-120-x-140-cm-qualite-galerie",
            "it": "telaio-telato-120-x-140-cm-qualita-gallery"
          },
          "productId": "7999229788445",
          "family": "gallery",
          "variantIds": [
            "43728125853981"
          ],
          "available": true,
          "variantId": "43728125853981"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-120x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-120x140-cm-roh",
            "en": "floating-frame-set-120x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-120x140-cm-brut",
            "it": "set-cornice-a-cassetta-120x140-cm-grezzo"
          },
          "productId": "7999094096157",
          "family": "shadow",
          "variantIds": [
            "43727853617437"
          ],
          "available": false,
          "variantId": "43727853617437"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-120x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-120x140-cm-4cm",
            "en": "canvas-frame-120x140-cm-4cm",
            "fr": "chassis-120x140-cm-4cm",
            "it": "telaio-120x140-cm-4cm"
          },
          "productId": "7999417057565",
          "family": "bars",
          "variantIds": [
            "43944910520605"
          ],
          "available": true,
          "variantId": "43944910520605"
        }
      ]
    },
    "120x150": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-120x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-120x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-120-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-120-x-150-cm-qualite-galerie",
            "it": "telaio-telato-120-x-150-cm-qualita-gallery"
          },
          "productId": "7999230411037",
          "family": "gallery",
          "variantIds": [
            "43728126574877"
          ],
          "available": true,
          "variantId": "43728126574877"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-120x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-120x150-cm-4cm",
            "en": "canvas-frame-120x150-cm-4cm",
            "fr": "chassis-120x150-cm-4cm",
            "it": "telaio-120x150-cm-4cm"
          },
          "productId": "7999417614621",
          "family": "bars",
          "variantIds": [
            "43944911077661"
          ],
          "available": true,
          "variantId": "43944911077661"
        }
      ]
    },
    "120x160": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-120x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-120x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-120-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-120-x-160-cm-qualite-galerie",
            "it": "telaio-telato-120-x-160-cm-qualita-gallery"
          },
          "productId": "7999231459613",
          "family": "gallery",
          "variantIds": [
            "43728128180509"
          ],
          "available": true,
          "variantId": "43728128180509"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-120x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-120x160-cm-4cm",
            "en": "canvas-frame-120x160-cm-4cm",
            "fr": "chassis-120x160-cm-4cm",
            "it": "telaio-120x160-cm-4cm"
          },
          "productId": "7999418237213",
          "family": "bars",
          "variantIds": [
            "43944912060701"
          ],
          "available": true,
          "variantId": "43944912060701"
        }
      ]
    },
    "120x170": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-120x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-120x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-120-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-120-x-170-cm-qualite-galerie",
            "it": "telaio-telato-120-x-170-cm-qualita-gallery"
          },
          "productId": "7999232475421",
          "family": "gallery",
          "variantIds": [
            "43728129753373"
          ],
          "available": true,
          "variantId": "43728129753373"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-120x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-120x170-cm-4cm",
            "en": "canvas-frame-120x170-cm-4cm",
            "fr": "chassis-120x170-cm-4cm",
            "it": "telaio-120x170-cm-4cm"
          },
          "productId": "7999418663197",
          "family": "bars",
          "variantIds": [
            "43944912519453"
          ],
          "available": true,
          "variantId": "43944912519453"
        }
      ]
    },
    "120x180": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-120x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-120x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-120-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-120-x-180-cm-qualite-galerie",
            "it": "telaio-telato-120-x-180-cm-qualita-gallery"
          },
          "productId": "7999233491229",
          "family": "gallery",
          "variantIds": [
            "43728131293469"
          ],
          "available": true,
          "variantId": "43728131293469"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-120x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-120x180-cm-4cm",
            "en": "canvas-frame-120x180-cm-4cm",
            "fr": "chassis-120x180-cm-4cm",
            "it": "telaio-120x180-cm-4cm"
          },
          "productId": "7999419253021",
          "family": "bars",
          "variantIds": [
            "43944913502493"
          ],
          "available": true,
          "variantId": "43944913502493"
        }
      ]
    },
    "120x195": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-120x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-120x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-120-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-120-x-195-cm-qualite-galerie",
            "it": "telaio-telato-120-x-195-cm-qualita-gallery"
          },
          "productId": "7999234441501",
          "family": "gallery",
          "variantIds": [
            "43728134111517"
          ],
          "available": true,
          "variantId": "43728134111517"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-120x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-120x195-cm-4cm",
            "en": "canvas-frame-120x195-cm-4cm",
            "fr": "chassis-120x195-cm-4cm",
            "it": "telaio-120x195-cm-4cm"
          },
          "productId": "7999419777309",
          "family": "bars",
          "variantIds": [
            "43944914026781"
          ],
          "available": true,
          "variantId": "43944914026781"
        }
      ]
    },
    "130x130": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-130x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-130x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-130-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-130-x-130-cm-qualite-galerie",
            "it": "telaio-telato-130-x-130-cm-qualita-gallery"
          },
          "productId": "7999235424541",
          "family": "gallery",
          "variantIds": [
            "43728135258397"
          ],
          "available": true,
          "variantId": "43728135258397"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-130x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-130x130-cm-4cm",
            "en": "canvas-frame-130x130-cm-4cm",
            "fr": "chassis-130x130-cm-4cm",
            "it": "telaio-130x130-cm-4cm"
          },
          "productId": "7999420563741",
          "family": "bars",
          "variantIds": [
            "43944914911517"
          ],
          "available": true,
          "variantId": "43944914911517"
        }
      ]
    },
    "130x140": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-130x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-130x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-130-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-130-x-140-cm-qualite-galerie",
            "it": "telaio-telato-130-x-140-cm-qualita-gallery"
          },
          "productId": "7999236210973",
          "family": "gallery",
          "variantIds": [
            "43728139747613"
          ],
          "available": true,
          "variantId": "43728139747613"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-130x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-130x140-cm-4cm",
            "en": "canvas-frame-130x140-cm-4cm",
            "fr": "chassis-130x140-cm-4cm",
            "it": "telaio-130x140-cm-4cm"
          },
          "productId": "7999421120797",
          "family": "bars",
          "variantIds": [
            "43944915501341"
          ],
          "available": true,
          "variantId": "43944915501341"
        }
      ]
    },
    "130x150": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-130x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-130x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-130-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-130-x-150-cm-qualite-galerie",
            "it": "telaio-telato-130-x-150-cm-qualita-gallery"
          },
          "productId": "7999237161245",
          "family": "gallery",
          "variantIds": [
            "43728141549853"
          ],
          "available": true,
          "variantId": "43728141549853"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-130x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-130x150-cm-4cm",
            "en": "canvas-frame-130x150-cm-4cm",
            "fr": "chassis-130x150-cm-4cm",
            "it": "telaio-130x150-cm-4cm"
          },
          "productId": "7999421612317",
          "family": "bars",
          "variantIds": [
            "43944917467421"
          ],
          "available": true,
          "variantId": "43944917467421"
        }
      ]
    },
    "130x160": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-130x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-130x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-130-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-130-x-160-cm-qualite-galerie",
            "it": "telaio-telato-130-x-160-cm-qualita-gallery"
          },
          "productId": "7999238209821",
          "family": "gallery",
          "variantIds": [
            "43728147218717"
          ],
          "available": true,
          "variantId": "43728147218717"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-130x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-130x160-cm-4cm",
            "en": "canvas-frame-130x160-cm-4cm",
            "fr": "chassis-130x160-cm-4cm",
            "it": "telaio-130x160-cm-4cm"
          },
          "productId": "7999422103837",
          "family": "bars",
          "variantIds": [
            "43944917991709"
          ],
          "available": true,
          "variantId": "43944917991709"
        }
      ]
    },
    "130x170": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-130x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-130x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-130-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-130-x-170-cm-qualite-galerie",
            "it": "telaio-telato-130-x-170-cm-qualita-gallery"
          },
          "productId": "7999239455005",
          "family": "gallery",
          "variantIds": [
            "43728149250333"
          ],
          "available": true,
          "variantId": "43728149250333"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-130x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-130x170-cm-4cm",
            "en": "canvas-frame-130x170-cm-4cm",
            "fr": "chassis-130x170-cm-4cm",
            "it": "telaio-130x170-cm-4cm"
          },
          "productId": "7999422759197",
          "family": "bars",
          "variantIds": [
            "43944918876445"
          ],
          "available": true,
          "variantId": "43944918876445"
        }
      ]
    },
    "130x180": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-130x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-130x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-130-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-130-x-180-cm-qualite-galerie",
            "it": "telaio-telato-130-x-180-cm-qualita-gallery"
          },
          "productId": "7999240208669",
          "family": "gallery",
          "variantIds": [
            "43728150003997"
          ],
          "available": true,
          "variantId": "43728150003997"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-130x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-130x180-cm-4cm",
            "en": "canvas-frame-130x180-cm-4cm",
            "fr": "chassis-130x180-cm-4cm",
            "it": "telaio-130x180-cm-4cm"
          },
          "productId": "7999423217949",
          "family": "bars",
          "variantIds": [
            "43944919335197"
          ],
          "available": true,
          "variantId": "43944919335197"
        }
      ]
    },
    "130x195": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-130x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-130x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-130-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-130-x-195-cm-qualite-galerie",
            "it": "telaio-telato-130-x-195-cm-qualita-gallery"
          },
          "productId": "7999241257245",
          "family": "gallery",
          "variantIds": [
            "43728151347485"
          ],
          "available": true,
          "variantId": "43728151347485"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-130x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-130x195-cm-4cm",
            "en": "canvas-frame-130x195-cm-4cm",
            "fr": "chassis-130x195-cm-4cm",
            "it": "telaio-130x195-cm-4cm"
          },
          "productId": "7999423676701",
          "family": "bars",
          "variantIds": [
            "43944920383773"
          ],
          "available": true,
          "variantId": "43944920383773"
        }
      ]
    },
    "140x140": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-140x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-140x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-140-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-140-x-140-cm-qualite-galerie",
            "it": "telaio-telato-140-x-140-cm-qualita-gallery"
          },
          "productId": "7999242305821",
          "family": "gallery",
          "variantIds": [
            "43728153772317"
          ],
          "available": true,
          "variantId": "43728153772317"
        }
      ],
      "studio": [],
      "shadow": [
        {
          "handle": "schattenfugen-rahmen-set-140x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-140x140-cm-roh",
            "en": "floating-frame-set-140x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-140x140-cm-brut",
            "it": "set-cornice-a-cassetta-140x140-cm-grezzo"
          },
          "productId": "7999094882589",
          "family": "shadow",
          "variantIds": [
            "43727855747357"
          ],
          "available": false,
          "variantId": "43727855747357"
        }
      ],
      "bars": [
        {
          "handle": "keilrahmen-140x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-140x140-cm-4cm",
            "en": "canvas-frame-140x140-cm-4cm",
            "fr": "chassis-140x140-cm-4cm",
            "it": "telaio-140x140-cm-4cm"
          },
          "productId": "7999424233757",
          "family": "bars",
          "variantIds": [
            "43944920973597"
          ],
          "available": true,
          "variantId": "43944920973597"
        }
      ]
    },
    "140x150": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-140x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-140x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-140-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-140-x-150-cm-qualite-galerie",
            "it": "telaio-telato-140-x-150-cm-qualita-gallery"
          },
          "productId": "7999243223325",
          "family": "gallery",
          "variantIds": [
            "43728155214109"
          ],
          "available": true,
          "variantId": "43728155214109"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-140x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-140x150-cm-4cm",
            "en": "canvas-frame-140x150-cm-4cm",
            "fr": "chassis-140x150-cm-4cm",
            "it": "telaio-140x150-cm-4cm"
          },
          "productId": "7999424659741",
          "family": "bars",
          "variantIds": [
            "43944921399581"
          ],
          "available": true,
          "variantId": "43944921399581"
        }
      ]
    },
    "140x160": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-140x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-140x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-140-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-140-x-160-cm-qualite-galerie",
            "it": "telaio-telato-140-x-160-cm-qualita-gallery"
          },
          "productId": "7999243976989",
          "family": "gallery",
          "variantIds": [
            "43728155967773"
          ],
          "available": true,
          "variantId": "43728155967773"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-140x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-140x160-cm-4cm",
            "en": "canvas-frame-140x160-cm-4cm",
            "fr": "chassis-140x160-cm-4cm",
            "it": "telaio-140x160-cm-4cm"
          },
          "productId": "7999425085725",
          "family": "bars",
          "variantIds": [
            "43944921923869"
          ],
          "available": true,
          "variantId": "43944921923869"
        }
      ]
    },
    "140x170": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-140x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-140x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-140-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-140-x-170-cm-qualite-galerie",
            "it": "telaio-telato-140-x-170-cm-qualita-gallery"
          },
          "productId": "7999244828957",
          "family": "gallery",
          "variantIds": [
            "43728156950813"
          ],
          "available": true,
          "variantId": "43728156950813"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-140x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-140x170-cm-4cm",
            "en": "canvas-frame-140x170-cm-4cm",
            "fr": "chassis-140x170-cm-4cm",
            "it": "telaio-140x170-cm-4cm"
          },
          "productId": "7999425478941",
          "family": "bars",
          "variantIds": [
            "43944922972445"
          ],
          "available": true,
          "variantId": "43944922972445"
        }
      ]
    },
    "140x180": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-140x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-140x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-140-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-140-x-180-cm-qualite-galerie",
            "it": "telaio-telato-140-x-180-cm-qualita-gallery"
          },
          "productId": "7999245648157",
          "family": "gallery",
          "variantIds": [
            "43728157999389"
          ],
          "available": true,
          "variantId": "43728157999389"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-140x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-140x180-cm-4cm",
            "en": "canvas-frame-140x180-cm-4cm",
            "fr": "chassis-140x180-cm-4cm",
            "it": "telaio-140x180-cm-4cm"
          },
          "productId": "7999425872157",
          "family": "bars",
          "variantIds": [
            "43944923365661"
          ],
          "available": true,
          "variantId": "43944923365661"
        }
      ]
    },
    "140x195": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-140x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-140x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-140-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-140-x-195-cm-qualite-galerie",
            "it": "telaio-telato-140-x-195-cm-qualita-gallery"
          },
          "productId": "7999246631197",
          "family": "gallery",
          "variantIds": [
            "43728159113501"
          ],
          "available": true,
          "variantId": "43728159113501"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-140x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-140x195-cm-4cm",
            "en": "canvas-frame-140x195-cm-4cm",
            "fr": "chassis-140x195-cm-4cm",
            "it": "telaio-140x195-cm-4cm"
          },
          "productId": "7999426396445",
          "family": "bars",
          "variantIds": [
            "43944923889949"
          ],
          "available": true,
          "variantId": "43944923889949"
        }
      ]
    },
    "150x150": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-150x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-150x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-150-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-150-x-150-cm-qualite-galerie",
            "it": "telaio-telato-150-x-150-cm-qualita-gallery"
          },
          "productId": "7999247384861",
          "family": "gallery",
          "variantIds": [
            "43728160260381"
          ],
          "available": true,
          "variantId": "43728160260381"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-150x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-150x150-cm-4cm",
            "en": "canvas-frame-150x150-cm-4cm",
            "fr": "chassis-150x150-cm-4cm",
            "it": "telaio-150x150-cm-4cm"
          },
          "productId": "7999426953501",
          "family": "bars",
          "variantIds": [
            "43944925167901"
          ],
          "available": true,
          "variantId": "43944925167901"
        }
      ]
    },
    "150x160": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-150x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-150x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-150-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-150-x-160-cm-qualite-galerie",
            "it": "telaio-telato-150-x-160-cm-qualita-gallery"
          },
          "productId": "7999248171293",
          "family": "gallery",
          "variantIds": [
            "43728162685213"
          ],
          "available": true,
          "variantId": "43728162685213"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-150x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-150x160-cm-4cm",
            "en": "canvas-frame-150x160-cm-4cm",
            "fr": "chassis-150x160-cm-4cm",
            "it": "telaio-150x160-cm-4cm"
          },
          "productId": "7999427412253",
          "family": "bars",
          "variantIds": [
            "43944925626653"
          ],
          "available": true,
          "variantId": "43944925626653"
        }
      ]
    },
    "150x170": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-150x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-150x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-150-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-150-x-170-cm-qualite-galerie",
            "it": "telaio-telato-150-x-170-cm-qualita-gallery"
          },
          "productId": "7999249121565",
          "family": "gallery",
          "variantIds": [
            "43728164421917"
          ],
          "available": true,
          "variantId": "43728164421917"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-150x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-150x170-cm-4cm",
            "en": "canvas-frame-150x170-cm-4cm",
            "fr": "chassis-150x170-cm-4cm",
            "it": "telaio-150x170-cm-4cm"
          },
          "productId": "7999427903773",
          "family": "bars",
          "variantIds": [
            "43944926150941"
          ],
          "available": true,
          "variantId": "43944926150941"
        }
      ]
    },
    "150x180": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-150x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-150x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-150-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-150-x-180-cm-qualite-galerie",
            "it": "telaio-telato-150-x-180-cm-qualita-gallery"
          },
          "productId": "7999250006301",
          "family": "gallery",
          "variantIds": [
            "43728165732637"
          ],
          "available": true,
          "variantId": "43728165732637"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-150x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-150x180-cm-4cm",
            "en": "canvas-frame-150x180-cm-4cm",
            "fr": "chassis-150x180-cm-4cm",
            "it": "telaio-150x180-cm-4cm"
          },
          "productId": "7999428428061",
          "family": "bars",
          "variantIds": [
            "43944926675229"
          ],
          "available": true,
          "variantId": "43944926675229"
        }
      ]
    },
    "150x195": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-150x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-150x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-150-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-150-x-195-cm-qualite-galerie",
            "it": "telaio-telato-150-x-195-cm-qualita-gallery"
          },
          "productId": "7999251546397",
          "family": "gallery",
          "variantIds": [
            "43728176677149"
          ],
          "available": true,
          "variantId": "43728176677149"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-150x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-150x195-cm-4cm",
            "en": "canvas-frame-150x195-cm-4cm",
            "fr": "chassis-150x195-cm-4cm",
            "it": "telaio-150x195-cm-4cm"
          },
          "productId": "7999429116189",
          "family": "bars",
          "variantIds": [
            "43944928313629"
          ],
          "available": true,
          "variantId": "43944928313629"
        }
      ]
    },
    "160x160": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-160x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-160x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-160-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-160-x-160-cm-qualite-galerie",
            "it": "telaio-telato-160-x-160-cm-qualita-gallery"
          },
          "productId": "7999252594973",
          "family": "gallery",
          "variantIds": [
            "43728179921181"
          ],
          "available": true,
          "variantId": "43728179921181"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-160x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-160x160-cm-4cm",
            "en": "canvas-frame-160x160-cm-4cm",
            "fr": "chassis-160x160-cm-4cm",
            "it": "telaio-160x160-cm-4cm"
          },
          "productId": "7999429574941",
          "family": "bars",
          "variantIds": [
            "43944928772381"
          ],
          "available": true,
          "variantId": "43944928772381"
        }
      ]
    },
    "160x170": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-160x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-160x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-160-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-160-x-170-cm-qualite-galerie",
            "it": "telaio-telato-160-x-170-cm-qualita-gallery"
          },
          "productId": "7999253479709",
          "family": "gallery",
          "variantIds": [
            "43728181264669"
          ],
          "available": true,
          "variantId": "43728181264669"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-160x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-160x170-cm-4cm",
            "en": "canvas-frame-160x170-cm-4cm",
            "fr": "chassis-160x170-cm-4cm",
            "it": "telaio-160x170-cm-4cm"
          },
          "productId": "7999430000925",
          "family": "bars",
          "variantIds": [
            "43944929198365"
          ],
          "available": true,
          "variantId": "43944929198365"
        }
      ]
    },
    "160x180": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-160x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-160x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-160-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-160-x-180-cm-qualite-galerie",
            "it": "telaio-telato-160-x-180-cm-qualita-gallery"
          },
          "productId": "7999254331677",
          "family": "gallery",
          "variantIds": [
            "43728183066909"
          ],
          "available": true,
          "variantId": "43728183066909"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-160x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-160x180-cm-4cm",
            "en": "canvas-frame-160x180-cm-4cm",
            "fr": "chassis-160x180-cm-4cm",
            "it": "telaio-160x180-cm-4cm"
          },
          "productId": "7999430590749",
          "family": "bars",
          "variantIds": [
            "43944932245789"
          ],
          "available": true,
          "variantId": "43944932245789"
        }
      ]
    },
    "160x195": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-160x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-160x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-160-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-160-x-195-cm-qualite-galerie",
            "it": "telaio-telato-160-x-195-cm-qualita-gallery"
          },
          "productId": "7999255478557",
          "family": "gallery",
          "variantIds": [
            "43728198664477"
          ],
          "available": true,
          "variantId": "43728198664477"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-160x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-160x195-cm-4cm",
            "en": "canvas-frame-160x195-cm-4cm",
            "fr": "chassis-160x195-cm-4cm",
            "it": "telaio-160x195-cm-4cm"
          },
          "productId": "7999431082269",
          "family": "bars",
          "variantIds": [
            "43944933523741"
          ],
          "available": true,
          "variantId": "43944933523741"
        }
      ]
    },
    "170x170": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-170x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-170x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-170-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-170-x-170-cm-qualite-galerie",
            "it": "telaio-telato-170-x-170-cm-qualita-gallery"
          },
          "productId": "7999256232221",
          "family": "gallery",
          "variantIds": [
            "43728201384221"
          ],
          "available": true,
          "variantId": "43728201384221"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-170x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-170x170-cm-4cm",
            "en": "canvas-frame-170x170-cm-4cm",
            "fr": "chassis-170x170-cm-4cm",
            "it": "telaio-170x170-cm-4cm"
          },
          "productId": "7999431639325",
          "family": "bars",
          "variantIds": [
            "43944934899997"
          ],
          "available": true,
          "variantId": "43944934899997"
        }
      ]
    },
    "170x180": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-170x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-170x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-170-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-170-x-180-cm-qualite-galerie",
            "it": "telaio-telato-170-x-180-cm-qualita-gallery"
          },
          "productId": "7999257215261",
          "family": "gallery",
          "variantIds": [
            "43728202400029"
          ],
          "available": true,
          "variantId": "43728202400029"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-170x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-170x180-cm-4cm",
            "en": "canvas-frame-170x180-cm-4cm",
            "fr": "chassis-170x180-cm-4cm",
            "it": "telaio-170x180-cm-4cm"
          },
          "productId": "7999432163613",
          "family": "bars",
          "variantIds": [
            "43944935391517"
          ],
          "available": true,
          "variantId": "43944935391517"
        }
      ]
    },
    "170x195": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-170x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-170x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-170-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-170-x-195-cm-qualite-galerie",
            "it": "telaio-telato-170-x-195-cm-qualita-gallery"
          },
          "productId": "7999258853661",
          "family": "gallery",
          "variantIds": [
            "43728207020317"
          ],
          "available": true,
          "variantId": "43728207020317"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-170x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-170x195-cm-4cm",
            "en": "canvas-frame-170x195-cm-4cm",
            "fr": "chassis-170x195-cm-4cm",
            "it": "telaio-170x195-cm-4cm"
          },
          "productId": "7999432556829",
          "family": "bars",
          "variantIds": [
            "43944935784733"
          ],
          "available": true,
          "variantId": "43944935784733"
        }
      ]
    },
    "180x180": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-180x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-180x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-180-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-180-x-180-cm-qualite-galerie",
            "it": "telaio-telato-180-x-180-cm-qualita-gallery"
          },
          "productId": "7999259935005",
          "family": "gallery",
          "variantIds": [
            "43728208265501"
          ],
          "available": true,
          "variantId": "43728208265501"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-180x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-180x180-cm-4cm",
            "en": "canvas-frame-180x180-cm-4cm",
            "fr": "chassis-180x180-cm-4cm",
            "it": "telaio-180x180-cm-4cm"
          },
          "productId": "7999433179421",
          "family": "bars",
          "variantIds": [
            "43944937357597"
          ],
          "available": true,
          "variantId": "43944937357597"
        }
      ]
    },
    "180x195": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-180x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-180x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-180-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-180-x-195-cm-qualite-galerie",
            "it": "telaio-telato-180-x-195-cm-qualita-gallery"
          },
          "productId": "7999261245725",
          "family": "gallery",
          "variantIds": [
            "43728209838365"
          ],
          "available": true,
          "variantId": "43728209838365"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-180x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-180x195-cm-4cm",
            "en": "canvas-frame-180x195-cm-4cm",
            "fr": "chassis-180x195-cm-4cm",
            "it": "telaio-180x195-cm-4cm"
          },
          "productId": "7999433834781",
          "family": "bars",
          "variantIds": [
            "43944938570013"
          ],
          "available": true,
          "variantId": "43944938570013"
        }
      ]
    },
    "195x195": {
      "gallery": [
        {
          "handle": "bespannter-keilrahmen-195x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-195x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-195-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-195-x-195-cm-qualite-galerie",
            "it": "telaio-telato-195-x-195-cm-qualita-gallery"
          },
          "productId": "7999262261533",
          "family": "gallery",
          "variantIds": [
            "43728211018013"
          ],
          "available": true,
          "variantId": "43728211018013"
        }
      ],
      "studio": [],
      "shadow": [],
      "bars": [
        {
          "handle": "keilrahmen-195x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-195x195-cm-4cm",
            "en": "canvas-frame-195x195-cm-4cm",
            "fr": "chassis-195x195-cm-4cm",
            "it": "telaio-195x195-cm-4cm"
          },
          "productId": "7999434359069",
          "family": "bars",
          "variantIds": [
            "43944939094301"
          ],
          "available": true,
          "variantId": "43944939094301"
        }
      ]
    }
  },
  "rounds": {
    "80": [
      {
        "handle": "keilrahmen-bespannt-rund",
        "handles": {
          "de": "keilrahmen-bespannt-rund",
          "en": "canvas-frame-stretched-round",
          "fr": "chassis-entoile-rond",
          "it": "telaio-telato-tondo"
        },
        "productId": "10015394398493",
        "family": "round",
        "variantIds": [
          "50551054139677"
        ],
        "available": true,
        "variantId": "50551054139677"
      }
    ],
    "90": [
      {
        "handle": "keilrahmen-bespannt-rund",
        "handles": {
          "de": "keilrahmen-bespannt-rund",
          "en": "canvas-frame-stretched-round",
          "fr": "chassis-entoile-rond",
          "it": "telaio-telato-tondo"
        },
        "productId": "10015394398493",
        "family": "round",
        "variantIds": [
          "50551054172445"
        ],
        "available": true,
        "variantId": "50551054172445"
      }
    ],
    "100": [
      {
        "handle": "keilrahmen-bespannt-rund",
        "handles": {
          "de": "keilrahmen-bespannt-rund",
          "en": "canvas-frame-stretched-round",
          "fr": "chassis-entoile-rond",
          "it": "telaio-telato-tondo"
        },
        "productId": "10015394398493",
        "family": "round",
        "variantIds": [
          "50551054205213"
        ],
        "available": true,
        "variantId": "50551054205213"
      }
    ],
    "110": [
      {
        "handle": "keilrahmen-bespannt-rund",
        "handles": {
          "de": "keilrahmen-bespannt-rund",
          "en": "canvas-frame-stretched-round",
          "fr": "chassis-entoile-rond",
          "it": "telaio-telato-tondo"
        },
        "productId": "10015394398493",
        "family": "round",
        "variantIds": [
          "50551054237981"
        ],
        "available": true,
        "variantId": "50551054237981"
      }
    ],
    "120": [
      {
        "handle": "keilrahmen-bespannt-rund",
        "handles": {
          "de": "keilrahmen-bespannt-rund",
          "en": "canvas-frame-stretched-round",
          "fr": "chassis-entoile-rond",
          "it": "telaio-telato-tondo"
        },
        "productId": "10015394398493",
        "family": "round",
        "variantIds": [
          "50551054270749"
        ],
        "available": true,
        "variantId": "50551054270749"
      }
    ],
    "130": [
      {
        "handle": "keilrahmen-bespannt-rund",
        "handles": {
          "de": "keilrahmen-bespannt-rund",
          "en": "canvas-frame-stretched-round",
          "fr": "chassis-entoile-rond",
          "it": "telaio-telato-tondo"
        },
        "productId": "10015394398493",
        "family": "round",
        "variantIds": [
          "50551054303517"
        ],
        "available": true,
        "variantId": "50551054303517"
      }
    ],
    "140": [
      {
        "handle": "keilrahmen-bespannt-rund",
        "handles": {
          "de": "keilrahmen-bespannt-rund",
          "en": "canvas-frame-stretched-round",
          "fr": "chassis-entoile-rond",
          "it": "telaio-telato-tondo"
        },
        "productId": "10015394398493",
        "family": "round",
        "variantIds": [
          "50551054336285"
        ],
        "available": true,
        "variantId": "50551054336285"
      }
    ],
    "150": [
      {
        "handle": "keilrahmen-bespannt-rund",
        "handles": {
          "de": "keilrahmen-bespannt-rund",
          "en": "canvas-frame-stretched-round",
          "fr": "chassis-entoile-rond",
          "it": "telaio-telato-tondo"
        },
        "productId": "10015394398493",
        "family": "round",
        "variantIds": [
          "50551054369053"
        ],
        "available": true,
        "variantId": "50551054369053"
      }
    ],
    "160": [
      {
        "handle": "keilrahmen-bespannt-rund",
        "handles": {
          "de": "keilrahmen-bespannt-rund",
          "en": "canvas-frame-stretched-round",
          "fr": "chassis-entoile-rond",
          "it": "telaio-telato-tondo"
        },
        "productId": "10015394398493",
        "family": "round",
        "variantIds": [
          "50551054401821"
        ],
        "available": true,
        "variantId": "50551054401821"
      }
    ],
    "170": [
      {
        "handle": "keilrahmen-bespannt-rund",
        "handles": {
          "de": "keilrahmen-bespannt-rund",
          "en": "canvas-frame-stretched-round",
          "fr": "chassis-entoile-rond",
          "it": "telaio-telato-tondo"
        },
        "productId": "10015394398493",
        "family": "round",
        "variantIds": [
          "50551054434589"
        ],
        "available": true,
        "variantId": "50551054434589"
      }
    ],
    "180": [
      {
        "handle": "keilrahmen-bespannt-rund",
        "handles": {
          "de": "keilrahmen-bespannt-rund",
          "en": "canvas-frame-stretched-round",
          "fr": "chassis-entoile-rond",
          "it": "telaio-telato-tondo"
        },
        "productId": "10015394398493",
        "family": "round",
        "variantIds": [
          "50551054467357"
        ],
        "available": true,
        "variantId": "50551054467357"
      }
    ]
  },
  "candidates": {
    "rectangles": {
      "15x15": [
        {
          "handle": "bespannter-keilrahmen-15x15cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x15cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-15-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-15-cm-qualite-galerie",
            "it": "telaio-telato-15-x-15-cm-qualita-gallery"
          },
          "productId": "7999713771805",
          "family": "gallery",
          "variantIds": [
            "43945625714973"
          ],
          "available": true,
          "variantId": "43945625714973"
        },
        {
          "handle": "keilrahmen-15x15-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x15-cm-4cm",
            "en": "canvas-frame-15x15-cm-4cm",
            "fr": "chassis-15x15-cm-4cm",
            "it": "telaio-15x15-cm-4cm"
          },
          "productId": "7999329927453",
          "family": "bars",
          "variantIds": [
            "43728383312157"
          ],
          "available": true,
          "variantId": "43728383312157"
        }
      ],
      "15x20": [
        {
          "handle": "bespannter-keilrahmen-15x20-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x20-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-20-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-20-cm-qualite-galerie",
            "it": "telaio-telato-15-x-20-cm-qualita-gallery"
          },
          "productId": "7999139447069",
          "family": "gallery",
          "variantIds": [
            "43727948185885"
          ],
          "available": true,
          "variantId": "43727948185885"
        },
        {
          "handle": "keilrahmen-15x20-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x20-cm-4cm",
            "en": "canvas-frame-15x20-cm-4cm",
            "fr": "chassis-15x20-cm-4cm",
            "it": "telaio-15x20-cm-4cm"
          },
          "productId": "7999330353437",
          "family": "bars",
          "variantIds": [
            "43728383967517"
          ],
          "available": true,
          "variantId": "43728383967517"
        }
      ],
      "15x30": [
        {
          "handle": "bespannter-keilrahmen-15x30-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x30-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-30-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-30-cm-qualite-galerie",
            "it": "telaio-telato-15-x-30-cm-qualita-gallery"
          },
          "productId": "7999140331805",
          "family": "gallery",
          "variantIds": [
            "43727948906781"
          ],
          "available": true,
          "variantId": "43727948906781"
        },
        {
          "handle": "keilrahmen-15x30-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x30-cm-4cm",
            "en": "canvas-frame-15x30-cm-4cm",
            "fr": "chassis-15x30-cm-4cm",
            "it": "telaio-15x30-cm-4cm"
          },
          "productId": "7999331041565",
          "family": "bars",
          "variantIds": [
            "43728384917789"
          ],
          "available": true,
          "variantId": "43728384917789"
        }
      ],
      "15x40": [
        {
          "handle": "bespannter-keilrahmen-15x40-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x40-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-40-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-40-cm-qualite-galerie",
            "it": "telaio-telato-15-x-40-cm-qualita-gallery"
          },
          "productId": "7999141380381",
          "family": "gallery",
          "variantIds": [
            "43727949529373"
          ],
          "available": true,
          "variantId": "43727949529373"
        },
        {
          "handle": "keilrahmen-15x40-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x40-cm-4cm",
            "en": "canvas-frame-15x40-cm-4cm",
            "fr": "chassis-15x40-cm-4cm",
            "it": "telaio-15x40-cm-4cm"
          },
          "productId": "7999331467549",
          "family": "bars",
          "variantIds": [
            "43728385343773"
          ],
          "available": true,
          "variantId": "43728385343773"
        }
      ],
      "15x50": [
        {
          "handle": "bespannter-keilrahmen-15x50-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x50-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-50-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-50-cm-qualite-galerie",
            "it": "telaio-telato-15-x-50-cm-qualita-gallery"
          },
          "productId": "7999141904669",
          "family": "gallery",
          "variantIds": [
            "43727950184733"
          ],
          "available": true,
          "variantId": "43727950184733"
        },
        {
          "handle": "keilrahmen-15x50-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x50-cm-4cm",
            "en": "canvas-frame-15x50-cm-4cm",
            "fr": "chassis-15x50-cm-4cm",
            "it": "telaio-15x50-cm-4cm"
          },
          "productId": "7999332024605",
          "family": "bars",
          "variantIds": [
            "43728386195741"
          ],
          "available": true,
          "variantId": "43728386195741"
        }
      ],
      "15x60": [
        {
          "handle": "bespannter-keilrahmen-15x60-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x60-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-60-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-60-cm-qualite-galerie",
            "it": "telaio-telato-15-x-60-cm-qualita-gallery"
          },
          "productId": "7999142428957",
          "family": "gallery",
          "variantIds": [
            "43727950905629"
          ],
          "available": true,
          "variantId": "43727950905629"
        },
        {
          "handle": "keilrahmen-15x60-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x60-cm-4cm",
            "en": "canvas-frame-15x60-cm-4cm",
            "fr": "chassis-15x60-cm-4cm",
            "it": "telaio-15x60-cm-4cm"
          },
          "productId": "7999332450589",
          "family": "bars",
          "variantIds": [
            "43728387080477"
          ],
          "available": true,
          "variantId": "43728387080477"
        }
      ],
      "15x70": [
        {
          "handle": "bespannter-keilrahmen-15x70-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x70-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-70-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-70-cm-qualite-galerie",
            "it": "telaio-telato-15-x-70-cm-qualita-gallery"
          },
          "productId": "7999143117085",
          "family": "gallery",
          "variantIds": [
            "43727951692061"
          ],
          "available": true,
          "variantId": "43727951692061"
        },
        {
          "handle": "keilrahmen-15x70-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x70-cm-4cm",
            "en": "canvas-frame-15x70-cm-4cm",
            "fr": "chassis-15x70-cm-4cm",
            "it": "telaio-15x70-cm-4cm"
          },
          "productId": "7999333007645",
          "family": "bars",
          "variantIds": [
            "43728387932445"
          ],
          "available": true,
          "variantId": "43728387932445"
        }
      ],
      "15x80": [
        {
          "handle": "bespannter-keilrahmen-15x80-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x80-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-80-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-80-cm-qualite-galerie",
            "it": "telaio-telato-15-x-80-cm-qualita-gallery"
          },
          "productId": "7999143608605",
          "family": "gallery",
          "variantIds": [
            "43727952183581"
          ],
          "available": true,
          "variantId": "43727952183581"
        },
        {
          "handle": "keilrahmen-15x80-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x80-cm-4cm",
            "en": "canvas-frame-15x80-cm-4cm",
            "fr": "chassis-15x80-cm-4cm",
            "it": "telaio-15x80-cm-4cm"
          },
          "productId": "7999333499165",
          "family": "bars",
          "variantIds": [
            "43728388653341"
          ],
          "available": true,
          "variantId": "43728388653341"
        }
      ],
      "15x90": [
        {
          "handle": "bespannter-keilrahmen-15x90-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x90-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-90-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-90-cm-qualite-galerie",
            "it": "telaio-telato-15-x-90-cm-qualita-gallery"
          },
          "productId": "7999144198429",
          "family": "gallery",
          "variantIds": [
            "43727952838941"
          ],
          "available": true,
          "variantId": "43727952838941"
        },
        {
          "handle": "keilrahmen-15x90-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x90-cm-4cm",
            "en": "canvas-frame-15x90-cm-4cm",
            "fr": "chassis-15x90-cm-4cm",
            "it": "telaio-15x90-cm-4cm"
          },
          "productId": "7999334056221",
          "family": "bars",
          "variantIds": [
            "43728389407005"
          ],
          "available": true,
          "variantId": "43728389407005"
        }
      ],
      "15x100": [
        {
          "handle": "bespannter-keilrahmen-15x100-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x100-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-100-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-100-cm-qualite-galerie",
            "it": "telaio-telato-15-x-100-cm-qualita-gallery"
          },
          "productId": "7999144657181",
          "family": "gallery",
          "variantIds": [
            "43727953363229"
          ],
          "available": true,
          "variantId": "43727953363229"
        },
        {
          "handle": "keilrahmen-15x100-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x100-cm-4cm",
            "en": "canvas-frame-15x100-cm-4cm",
            "fr": "chassis-15x100-cm-4cm",
            "it": "telaio-15x100-cm-4cm"
          },
          "productId": "7999334580509",
          "family": "bars",
          "variantIds": [
            "43728390160669"
          ],
          "available": true,
          "variantId": "43728390160669"
        }
      ],
      "15x110": [
        {
          "handle": "bespannter-keilrahmen-15x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-110-cm-qualite-galerie",
            "it": "telaio-telato-15-x-110-cm-qualita-gallery"
          },
          "productId": "7999145214237",
          "family": "gallery",
          "variantIds": [
            "43727953953053"
          ],
          "available": true,
          "variantId": "43727953953053"
        },
        {
          "handle": "keilrahmen-15x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x110-cm-4cm",
            "en": "canvas-frame-15x110-cm-4cm",
            "fr": "chassis-15x110-cm-4cm",
            "it": "telaio-15x110-cm-4cm"
          },
          "productId": "7999335170333",
          "family": "bars",
          "variantIds": [
            "43728393601309"
          ],
          "available": true,
          "variantId": "43728393601309"
        }
      ],
      "15x120": [
        {
          "handle": "bespannter-keilrahmen-15x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-120-cm-qualite-galerie",
            "it": "telaio-telato-15-x-120-cm-qualita-gallery"
          },
          "productId": "7999145738525",
          "family": "gallery",
          "variantIds": [
            "43727954575645"
          ],
          "available": true,
          "variantId": "43727954575645"
        },
        {
          "handle": "keilrahmen-15x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x120-cm-4cm",
            "en": "canvas-frame-15x120-cm-4cm",
            "fr": "chassis-15x120-cm-4cm",
            "it": "telaio-15x120-cm-4cm"
          },
          "productId": "7999335596317",
          "family": "bars",
          "variantIds": [
            "43728394354973"
          ],
          "available": true,
          "variantId": "43728394354973"
        }
      ],
      "15x130": [
        {
          "handle": "bespannter-keilrahmen-15x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-130-cm-qualite-galerie",
            "it": "telaio-telato-15-x-130-cm-qualita-gallery"
          },
          "productId": "7999146295581",
          "family": "gallery",
          "variantIds": [
            "43727955165469"
          ],
          "available": true,
          "variantId": "43727955165469"
        },
        {
          "handle": "keilrahmen-15x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x130-cm-4cm",
            "en": "canvas-frame-15x130-cm-4cm",
            "fr": "chassis-15x130-cm-4cm",
            "it": "telaio-15x130-cm-4cm"
          },
          "productId": "7999336055069",
          "family": "bars",
          "variantIds": [
            "43728395043101"
          ],
          "available": true,
          "variantId": "43728395043101"
        }
      ],
      "15x140": [
        {
          "handle": "bespannter-keilrahmen-15x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-140-cm-qualite-galerie",
            "it": "telaio-telato-15-x-140-cm-qualita-gallery"
          },
          "productId": "7999146819869",
          "family": "gallery",
          "variantIds": [
            "43727955820829"
          ],
          "available": true,
          "variantId": "43727955820829"
        },
        {
          "handle": "keilrahmen-15x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x140-cm-4cm",
            "en": "canvas-frame-15x140-cm-4cm",
            "fr": "chassis-15x140-cm-4cm",
            "it": "telaio-15x140-cm-4cm"
          },
          "productId": "7999336546589",
          "family": "bars",
          "variantIds": [
            "43728395763997"
          ],
          "available": true,
          "variantId": "43728395763997"
        }
      ],
      "15x150": [
        {
          "handle": "bespannter-keilrahmen-15x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-150-cm-qualite-galerie",
            "it": "telaio-telato-15-x-150-cm-qualita-gallery"
          },
          "productId": "7999147442461",
          "family": "gallery",
          "variantIds": [
            "43727956574493"
          ],
          "available": true,
          "variantId": "43727956574493"
        },
        {
          "handle": "keilrahmen-15x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x150-cm-4cm",
            "en": "canvas-frame-15x150-cm-4cm",
            "fr": "chassis-15x150-cm-4cm",
            "it": "telaio-15x150-cm-4cm"
          },
          "productId": "7999337201949",
          "family": "bars",
          "variantIds": [
            "43728396681501"
          ],
          "available": true,
          "variantId": "43728396681501"
        }
      ],
      "15x160": [
        {
          "handle": "bespannter-keilrahmen-15x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-160-cm-qualite-galerie",
            "it": "telaio-telato-15-x-160-cm-qualita-gallery"
          },
          "productId": "7999147835677",
          "family": "gallery",
          "variantIds": [
            "43727956967709"
          ],
          "available": true,
          "variantId": "43727956967709"
        },
        {
          "handle": "keilrahmen-15x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x160-cm-4cm",
            "en": "canvas-frame-15x160-cm-4cm",
            "fr": "chassis-15x160-cm-4cm",
            "it": "telaio-15x160-cm-4cm"
          },
          "productId": "7999337693469",
          "family": "bars",
          "variantIds": [
            "43728397140253"
          ],
          "available": true,
          "variantId": "43728397140253"
        }
      ],
      "15x170": [
        {
          "handle": "bespannter-keilrahmen-15x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-170-cm-qualite-galerie",
            "it": "telaio-telato-15-x-170-cm-qualita-gallery"
          },
          "productId": "7999148425501",
          "family": "gallery",
          "variantIds": [
            "43727957688605"
          ],
          "available": true,
          "variantId": "43727957688605"
        },
        {
          "handle": "keilrahmen-15x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x170-cm-4cm",
            "en": "canvas-frame-15x170-cm-4cm",
            "fr": "chassis-15x170-cm-4cm",
            "it": "telaio-15x170-cm-4cm"
          },
          "productId": "7999338250525",
          "family": "bars",
          "variantIds": [
            "43728397992221"
          ],
          "available": true,
          "variantId": "43728397992221"
        }
      ],
      "15x180": [
        {
          "handle": "bespannter-keilrahmen-15x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-180-cm-qualite-galerie",
            "it": "telaio-telato-15-x-180-cm-qualita-gallery"
          },
          "productId": "7999149080861",
          "family": "gallery",
          "variantIds": [
            "43727958409501"
          ],
          "available": true,
          "variantId": "43727958409501"
        },
        {
          "handle": "keilrahmen-15x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x180-cm-4cm",
            "en": "canvas-frame-15x180-cm-4cm",
            "fr": "chassis-15x180-cm-4cm",
            "it": "telaio-15x180-cm-4cm"
          },
          "productId": "7999338873117",
          "family": "bars",
          "variantIds": [
            "43728398614813"
          ],
          "available": true,
          "variantId": "43728398614813"
        }
      ],
      "15x195": [
        {
          "handle": "bespannter-keilrahmen-15x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-15x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-15-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-15-x-195-cm-qualite-galerie",
            "it": "telaio-telato-15-x-195-cm-qualita-gallery"
          },
          "productId": "7999149703453",
          "family": "gallery",
          "variantIds": [
            "43727959064861"
          ],
          "available": true,
          "variantId": "43727959064861"
        },
        {
          "handle": "keilrahmen-15x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-15x195-cm-4cm",
            "en": "canvas-frame-15x195-cm-4cm",
            "fr": "chassis-15x195-cm-4cm",
            "it": "telaio-15x195-cm-4cm"
          },
          "productId": "7999339561245",
          "family": "bars",
          "variantIds": [
            "43728399991069"
          ],
          "available": true,
          "variantId": "43728399991069"
        }
      ],
      "20x20": [
        {
          "handle": "schattenfugen-rahmen-set-20x20-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x20-cm-roh",
            "en": "floating-frame-set-20x20-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x20-cm-brut",
            "it": "set-cornice-a-cassetta-20x20-cm-grezzo"
          },
          "productId": "7999051628829",
          "family": "shadow",
          "variantIds": [
            "43727748170013"
          ],
          "available": true,
          "variantId": "43727748170013"
        },
        {
          "handle": "bespannter-keilrahmen-20x20-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x20-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-20-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-20-cm-qualite-galerie",
            "it": "telaio-telato-20-x-20-cm-qualita-gallery"
          },
          "productId": "7999150260509",
          "family": "gallery",
          "variantIds": [
            "43727959654685"
          ],
          "available": true,
          "variantId": "43727959654685"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305074973"
          ],
          "available": true,
          "variantId": "49195305074973"
        },
        {
          "handle": "keilrahmen-20x20-cm-4cm-1",
          "handles": {
            "de": "keilrahmen-20x20-cm-4cm-1",
            "en": "canvas-frame-20x20-cm-4cm",
            "fr": "chassis-20x20-cm-4cm",
            "it": "telaio-20x20-cm-4cm"
          },
          "productId": "7999340019997",
          "family": "bars",
          "variantIds": [
            "43728400875805"
          ],
          "available": true,
          "variantId": "43728400875805"
        }
      ],
      "20x30": [
        {
          "handle": "schattenfugen-rahmen-set-20x30-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x30-cm-roh",
            "en": "floating-frame-set-20x30-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x30-cm-brut",
            "it": "set-cornice-a-cassetta-20x30-cm-grezzo"
          },
          "productId": "7999051727133",
          "family": "shadow",
          "variantIds": [
            "43727748268317"
          ],
          "available": true,
          "variantId": "43727748268317"
        },
        {
          "handle": "bespannter-keilrahmen-20x30-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x30-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-30-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-30-cm-qualite-galerie",
            "it": "telaio-telato-20-x-30-cm-qualita-gallery"
          },
          "productId": "7999150719261",
          "family": "gallery",
          "variantIds": [
            "43727960146205"
          ],
          "available": true,
          "variantId": "43727960146205"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305402653"
          ],
          "available": true,
          "variantId": "49195305402653"
        },
        {
          "handle": "keilrahmen-20x30-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x30-cm-4cm",
            "en": "canvas-frame-20x30-cm-4cm",
            "fr": "chassis-20x30-cm-4cm",
            "it": "telaio-20x30-cm-4cm"
          },
          "productId": "7999340478749",
          "family": "bars",
          "variantIds": [
            "43728401334557"
          ],
          "available": true,
          "variantId": "43728401334557"
        }
      ],
      "20x40": [
        {
          "handle": "schattenfugen-rahmen-set-20x40-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x40-cm-roh",
            "en": "floating-frame-set-20x40-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x40-cm-brut",
            "it": "set-cornice-a-cassetta-20x40-cm-grezzo"
          },
          "productId": "7999051858205",
          "family": "shadow",
          "variantIds": [
            "43727748595997"
          ],
          "available": true,
          "variantId": "43727748595997"
        },
        {
          "handle": "bespannter-keilrahmen-20x40-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x40-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-40-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-40-cm-qualite-galerie",
            "it": "telaio-telato-20-x-40-cm-qualita-gallery"
          },
          "productId": "7999151407389",
          "family": "gallery",
          "variantIds": [
            "43727961948445"
          ],
          "available": true,
          "variantId": "43727961948445"
        },
        {
          "handle": "keilrahmen-20x40-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x40-cm-4cm",
            "en": "canvas-frame-20x40-cm-4cm",
            "fr": "chassis-20x40-cm-4cm",
            "it": "telaio-20x40-cm-4cm"
          },
          "productId": "7999340904733",
          "family": "bars",
          "variantIds": [
            "43728401760541"
          ],
          "available": true,
          "variantId": "43728401760541"
        }
      ],
      "20x50": [
        {
          "handle": "schattenfugen-rahmen-set-20x50-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x50-cm-roh",
            "en": "floating-frame-set-20x50-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x50-cm-brut",
            "it": "set-cornice-a-cassetta-20x50-cm-grezzo"
          },
          "productId": "7999051989277",
          "family": "shadow",
          "variantIds": [
            "43727748923677"
          ],
          "available": true,
          "variantId": "43727748923677"
        },
        {
          "handle": "bespannter-keilrahmen-20x50-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x50-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-50-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-50-cm-qualite-galerie",
            "it": "telaio-telato-20-x-50-cm-qualita-gallery"
          },
          "productId": "7999151997213",
          "family": "gallery",
          "variantIds": [
            "43727964340509"
          ],
          "available": true,
          "variantId": "43727964340509"
        },
        {
          "handle": "keilrahmen-20x50-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x50-cm-4cm",
            "en": "canvas-frame-20x50-cm-4cm",
            "fr": "chassis-20x50-cm-4cm",
            "it": "telaio-20x50-cm-4cm"
          },
          "productId": "7999341625629",
          "family": "bars",
          "variantIds": [
            "43728402776349"
          ],
          "available": true,
          "variantId": "43728402776349"
        }
      ],
      "20x60": [
        {
          "handle": "schattenfugen-rahmen-set-20x60-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x60-cm-roh",
            "en": "floating-frame-set-20x60-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x60-cm-brut",
            "it": "set-cornice-a-cassetta-20x60-cm-grezzo"
          },
          "productId": "7999052120349",
          "family": "shadow",
          "variantIds": [
            "43727749284125"
          ],
          "available": true,
          "variantId": "43727749284125"
        },
        {
          "handle": "bespannter-keilrahmen-20x60-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x60-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-60-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-60-cm-qualite-galerie",
            "it": "telaio-telato-20-x-60-cm-qualita-gallery"
          },
          "productId": "7999152619805",
          "family": "gallery",
          "variantIds": [
            "43727965356317"
          ],
          "available": true,
          "variantId": "43727965356317"
        },
        {
          "handle": "keilrahmen-20x60-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x60-cm-4cm",
            "en": "canvas-frame-20x60-cm-4cm",
            "fr": "chassis-20x60-cm-4cm",
            "it": "telaio-20x60-cm-4cm"
          },
          "productId": "7999342215453",
          "family": "bars",
          "variantIds": [
            "43728405823773"
          ],
          "available": true,
          "variantId": "43728405823773"
        }
      ],
      "20x70": [
        {
          "handle": "schattenfugen-rahmen-set-20x70-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x70-cm-roh",
            "en": "floating-frame-set-20x70-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x70-cm-brut",
            "it": "set-cornice-a-cassetta-20x70-cm-grezzo"
          },
          "productId": "7999052284189",
          "family": "shadow",
          "variantIds": [
            "43727749644573"
          ],
          "available": true,
          "variantId": "43727749644573"
        },
        {
          "handle": "bespannter-keilrahmen-20x70-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x70-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-70-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-70-cm-qualite-galerie",
            "it": "telaio-telato-20-x-70-cm-qualita-gallery"
          },
          "productId": "7999153275165",
          "family": "gallery",
          "variantIds": [
            "43727966208285"
          ],
          "available": true,
          "variantId": "43727966208285"
        },
        {
          "handle": "keilrahmen-20x70-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x70-cm-4cm",
            "en": "canvas-frame-20x70-cm-4cm",
            "fr": "chassis-20x70-cm-4cm",
            "it": "telaio-20x70-cm-4cm"
          },
          "productId": "7999342772509",
          "family": "bars",
          "variantIds": [
            "43728409461021"
          ],
          "available": true,
          "variantId": "43728409461021"
        }
      ],
      "20x80": [
        {
          "handle": "schattenfugen-rahmen-set-20x80-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x80-cm-roh",
            "en": "floating-frame-set-20x80-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x80-cm-brut",
            "it": "set-cornice-a-cassetta-20x80-cm-grezzo"
          },
          "productId": "7999052382493",
          "family": "shadow",
          "variantIds": [
            "43727749939485"
          ],
          "available": true,
          "variantId": "43727749939485"
        },
        {
          "handle": "bespannter-keilrahmen-20x80-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x80-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-80-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-80-cm-qualite-galerie",
            "it": "telaio-telato-20-x-80-cm-qualita-gallery"
          },
          "productId": "7999153930525",
          "family": "gallery",
          "variantIds": [
            "43727966896413"
          ],
          "available": true,
          "variantId": "43727966896413"
        },
        {
          "handle": "keilrahmen-20x80-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x80-cm-4cm",
            "en": "canvas-frame-20x80-cm-4cm",
            "fr": "chassis-20x80-cm-4cm",
            "it": "telaio-20x80-cm-4cm"
          },
          "productId": "7999343427869",
          "family": "bars",
          "variantIds": [
            "43728412279069"
          ],
          "available": true,
          "variantId": "43728412279069"
        }
      ],
      "20x90": [
        {
          "handle": "schattenfugen-rahmen-set-20x90-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x90-cm-roh",
            "en": "floating-frame-set-20x90-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x90-cm-brut",
            "it": "set-cornice-a-cassetta-20x90-cm-grezzo"
          },
          "productId": "7999052513565",
          "family": "shadow",
          "variantIds": [
            "43727751348509"
          ],
          "available": true,
          "variantId": "43727751348509"
        },
        {
          "handle": "bespannter-keilrahmen-20x90-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x90-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-90-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-90-cm-qualite-galerie",
            "it": "telaio-telato-20-x-90-cm-qualita-gallery"
          },
          "productId": "7999154520349",
          "family": "gallery",
          "variantIds": [
            "43727967584541"
          ],
          "available": true,
          "variantId": "43727967584541"
        },
        {
          "handle": "keilrahmen-20x90-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x90-cm-4cm",
            "en": "canvas-frame-20x90-cm-4cm",
            "fr": "chassis-20x90-cm-4cm",
            "it": "telaio-20x90-cm-4cm"
          },
          "productId": "7999344050461",
          "family": "bars",
          "variantIds": [
            "43728413131037"
          ],
          "available": true,
          "variantId": "43728413131037"
        }
      ],
      "20x100": [
        {
          "handle": "schattenfugen-rahmen-set-20x100-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x100-cm-roh",
            "en": "floating-frame-set-20x100-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x100-cm-brut",
            "it": "set-cornice-a-cassetta-20x100-cm-grezzo"
          },
          "productId": "7999052579101",
          "family": "shadow",
          "variantIds": [
            "43727751414045"
          ],
          "available": true,
          "variantId": "43727751414045"
        },
        {
          "handle": "bespannter-keilrahmen-20x100-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x100-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-100-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-100-cm-qualite-galerie",
            "it": "telaio-telato-20-x-100-cm-qualita-gallery"
          },
          "productId": "7999155142941",
          "family": "gallery",
          "variantIds": [
            "43727968370973"
          ],
          "available": true,
          "variantId": "43727968370973"
        },
        {
          "handle": "keilrahmen-20x100-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x100-cm-4cm",
            "en": "canvas-frame-20x100-cm-4cm",
            "fr": "chassis-20x100-cm-4cm",
            "it": "telaio-20x100-cm-4cm"
          },
          "productId": "7999344640285",
          "family": "bars",
          "variantIds": [
            "43728413851933"
          ],
          "available": true,
          "variantId": "43728413851933"
        }
      ],
      "20x110": [
        {
          "handle": "bespannter-keilrahmen-20x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-110-cm-qualite-galerie",
            "it": "telaio-telato-20-x-110-cm-qualita-gallery"
          },
          "productId": "7999155732765",
          "family": "gallery",
          "variantIds": [
            "43727968960797"
          ],
          "available": true,
          "variantId": "43727968960797"
        },
        {
          "handle": "keilrahmen-20x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x110-cm-4cm",
            "en": "canvas-frame-20x110-cm-4cm",
            "fr": "chassis-20x110-cm-4cm",
            "it": "telaio-20x110-cm-4cm"
          },
          "productId": "7999345262877",
          "family": "bars",
          "variantIds": [
            "43728414998813"
          ],
          "available": true,
          "variantId": "43728414998813"
        }
      ],
      "20x120": [
        {
          "handle": "schattenfugen-rahmen-set-20x120-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x120-cm-roh",
            "en": "floating-frame-set-20x120-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x120-cm-brut",
            "it": "set-cornice-a-cassetta-20x120-cm-grezzo"
          },
          "productId": "7999052710173",
          "family": "shadow",
          "variantIds": [
            "43727751741725"
          ],
          "available": true,
          "variantId": "43727751741725"
        },
        {
          "handle": "bespannter-keilrahmen-20x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-120-cm-qualite-galerie",
            "it": "telaio-telato-20-x-120-cm-qualita-gallery"
          },
          "productId": "7999156355357",
          "family": "gallery",
          "variantIds": [
            "43727969747229"
          ],
          "available": true,
          "variantId": "43727969747229"
        },
        {
          "handle": "keilrahmen-20x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x120-cm-4cm",
            "en": "canvas-frame-20x120-cm-4cm",
            "fr": "chassis-20x120-cm-4cm",
            "it": "telaio-20x120-cm-4cm"
          },
          "productId": "7999345623325",
          "family": "bars",
          "variantIds": [
            "43916978290973"
          ],
          "available": true,
          "variantId": "43916978290973"
        }
      ],
      "20x130": [
        {
          "handle": "bespannter-keilrahmen-20x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-130-cm-qualite-galerie",
            "it": "telaio-telato-20-x-130-cm-qualita-gallery"
          },
          "productId": "7999156912413",
          "family": "gallery",
          "variantIds": [
            "43727972827421"
          ],
          "available": true,
          "variantId": "43727972827421"
        },
        {
          "handle": "keilrahmen-20x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x130-cm-4cm",
            "en": "canvas-frame-20x130-cm-4cm",
            "fr": "chassis-20x130-cm-4cm",
            "it": "telaio-20x130-cm-4cm"
          },
          "productId": "7999346245917",
          "family": "bars",
          "variantIds": [
            "43916979142941"
          ],
          "available": true,
          "variantId": "43916979142941"
        }
      ],
      "20x140": [
        {
          "handle": "schattenfugen-rahmen-set-20x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-20x140-cm-roh",
            "en": "floating-frame-set-20x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-20x140-cm-brut",
            "it": "set-cornice-a-cassetta-20x140-cm-grezzo"
          },
          "productId": "7999052841245",
          "family": "shadow",
          "variantIds": [
            "43727752266013"
          ],
          "available": false,
          "variantId": "43727752266013"
        },
        {
          "handle": "bespannter-keilrahmen-20x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-140-cm-qualite-galerie",
            "it": "telaio-telato-20-x-140-cm-qualita-gallery"
          },
          "productId": "7999157502237",
          "family": "gallery",
          "variantIds": [
            "43727973417245"
          ],
          "available": true,
          "variantId": "43727973417245"
        },
        {
          "handle": "keilrahmen-20x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x140-cm-4cm",
            "en": "canvas-frame-20x140-cm-4cm",
            "fr": "chassis-20x140-cm-4cm",
            "it": "telaio-20x140-cm-4cm"
          },
          "productId": "7999346737437",
          "family": "bars",
          "variantIds": [
            "43916979896605"
          ],
          "available": true,
          "variantId": "43916979896605"
        }
      ],
      "20x150": [
        {
          "handle": "bespannter-keilrahmen-20x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-150-cm-qualite-galerie",
            "it": "telaio-telato-20-x-150-cm-qualita-gallery"
          },
          "productId": "7999158157597",
          "family": "gallery",
          "variantIds": [
            "43727974072605"
          ],
          "available": true,
          "variantId": "43727974072605"
        },
        {
          "handle": "keilrahmen-20x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x150-cm-4cm",
            "en": "canvas-frame-20x150-cm-4cm",
            "fr": "chassis-20x150-cm-4cm",
            "it": "telaio-20x150-cm-4cm"
          },
          "productId": "7999347196189",
          "family": "bars",
          "variantIds": [
            "43916980355357"
          ],
          "available": true,
          "variantId": "43916980355357"
        }
      ],
      "20x160": [
        {
          "handle": "bespannter-keilrahmen-20x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-160-cm-qualite-galerie",
            "it": "telaio-telato-20-x-160-cm-qualita-gallery"
          },
          "productId": "7999158845725",
          "family": "gallery",
          "variantIds": [
            "43727974826269"
          ],
          "available": true,
          "variantId": "43727974826269"
        },
        {
          "handle": "keilrahmen-20x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x160-cm-4cm",
            "en": "canvas-frame-20x160-cm-4cm",
            "fr": "chassis-20x160-cm-4cm",
            "it": "telaio-20x160-cm-4cm"
          },
          "productId": "7999347753245",
          "family": "bars",
          "variantIds": [
            "43916981109021"
          ],
          "available": true,
          "variantId": "43916981109021"
        }
      ],
      "20x170": [
        {
          "handle": "bespannter-keilrahmen-20x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-170-cm-qualite-galerie",
            "it": "telaio-telato-20-x-170-cm-qualita-gallery"
          },
          "productId": "7999159435549",
          "family": "gallery",
          "variantIds": [
            "43727975514397"
          ],
          "available": true,
          "variantId": "43727975514397"
        },
        {
          "handle": "keilrahmen-20x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x170-cm-4cm",
            "en": "canvas-frame-20x170-cm-4cm",
            "fr": "chassis-20x170-cm-4cm",
            "it": "telaio-20x170-cm-4cm"
          },
          "productId": "7999348146461",
          "family": "bars",
          "variantIds": [
            "43916981731613"
          ],
          "available": true,
          "variantId": "43916981731613"
        }
      ],
      "20x180": [
        {
          "handle": "bespannter-keilrahmen-20x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-180-cm-qualite-galerie",
            "it": "telaio-telato-20-x-180-cm-qualita-gallery"
          },
          "productId": "7999159959837",
          "family": "gallery",
          "variantIds": [
            "43727980790045"
          ],
          "available": true,
          "variantId": "43727980790045"
        },
        {
          "handle": "keilrahmen-20x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x180-cm-4cm",
            "en": "canvas-frame-20x180-cm-4cm",
            "fr": "chassis-20x180-cm-4cm",
            "it": "telaio-20x180-cm-4cm"
          },
          "productId": "7999348670749",
          "family": "bars",
          "variantIds": [
            "43916982255901"
          ],
          "available": true,
          "variantId": "43916982255901"
        }
      ],
      "20x195": [
        {
          "handle": "bespannter-keilrahmen-20x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-20x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-20-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-20-x-195-cm-qualite-galerie",
            "it": "telaio-telato-20-x-195-cm-qualita-gallery"
          },
          "productId": "7999160549661",
          "family": "gallery",
          "variantIds": [
            "43727981445405"
          ],
          "available": true,
          "variantId": "43727981445405"
        },
        {
          "handle": "keilrahmen-20x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-20x195-cm-4cm",
            "en": "canvas-frame-20x195-cm-4cm",
            "fr": "chassis-20x195-cm-4cm",
            "it": "telaio-20x195-cm-4cm"
          },
          "productId": "7999349129501",
          "family": "bars",
          "variantIds": [
            "43916983173405"
          ],
          "available": true,
          "variantId": "43916983173405"
        }
      ],
      "30x30": [
        {
          "handle": "schattenfugen-rahmen-set-30x30-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-30x30-cm-roh",
            "en": "floating-frame-set-30x30-cm-unfinished",
            "fr": "kit-de-caisse-americaine-30x30-cm-brut",
            "it": "set-cornice-a-cassetta-30x30-cm-grezzo"
          },
          "productId": "7999053005085",
          "family": "shadow",
          "variantIds": [
            "43727752659229"
          ],
          "available": true,
          "variantId": "43727752659229"
        },
        {
          "handle": "bespannter-keilrahmen-30x30-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x30-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-30-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-30-cm-qualite-galerie",
            "it": "telaio-telato-30-x-30-cm-qualita-gallery"
          },
          "productId": "7999161041181",
          "family": "gallery",
          "variantIds": [
            "43727981936925"
          ],
          "available": true,
          "variantId": "43727981936925"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305369885"
          ],
          "available": true,
          "variantId": "49195305369885"
        },
        {
          "handle": "keilrahmen-30x30-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x30-cm-4cm",
            "en": "canvas-frame-30x30-cm-4cm",
            "fr": "chassis-30x30-cm-4cm",
            "it": "telaio-30x30-cm-4cm"
          },
          "productId": "7999349588253",
          "family": "bars",
          "variantIds": [
            "43916983632157"
          ],
          "available": true,
          "variantId": "43916983632157"
        }
      ],
      "30x40": [
        {
          "handle": "schattenfugen-rahmen-set-30x40-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-30x40-cm-roh",
            "en": "floating-frame-set-30x40-cm-unfinished",
            "fr": "kit-de-caisse-americaine-30x40-cm-brut",
            "it": "set-cornice-a-cassetta-30x40-cm-grezzo"
          },
          "productId": "7999053103389",
          "family": "shadow",
          "variantIds": [
            "43727753249053"
          ],
          "available": true,
          "variantId": "43727753249053"
        },
        {
          "handle": "bespannter-keilrahmen-30x40-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x40-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-40-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-40-cm-qualite-galerie",
            "it": "telaio-telato-30-x-40-cm-qualita-gallery"
          },
          "productId": "7999161663773",
          "family": "gallery",
          "variantIds": [
            "43727982625053"
          ],
          "available": true,
          "variantId": "43727982625053"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305337117"
          ],
          "available": true,
          "variantId": "49195305337117"
        },
        {
          "handle": "keilrahmen-30x40-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x40-cm-4cm",
            "en": "canvas-frame-30x40-cm-4cm",
            "fr": "chassis-30x40-cm-4cm",
            "it": "telaio-30x40-cm-4cm"
          },
          "productId": "7999350178077",
          "family": "bars",
          "variantIds": [
            "43916984451357"
          ],
          "available": true,
          "variantId": "43916984451357"
        }
      ],
      "30x50": [
        {
          "handle": "schattenfugen-rahmen-set-30x50-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-30x50-cm-roh",
            "en": "floating-frame-set-30x50-cm-unfinished",
            "fr": "kit-de-caisse-americaine-30x50-cm-brut",
            "it": "set-cornice-a-cassetta-30x50-cm-grezzo"
          },
          "productId": "7999053234461",
          "family": "shadow",
          "variantIds": [
            "43727753576733"
          ],
          "available": true,
          "variantId": "43727753576733"
        },
        {
          "handle": "bespannter-keilrahmen-30x50-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x50-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-50-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-50-cm-qualite-galerie",
            "it": "telaio-telato-30-x-50-cm-qualita-gallery"
          },
          "productId": "7999162089757",
          "family": "gallery",
          "variantIds": [
            "43727983345949"
          ],
          "available": true,
          "variantId": "43727983345949"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "50079644647709"
          ],
          "available": true,
          "variantId": "50079644647709"
        },
        {
          "handle": "keilrahmen-30x50-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x50-cm-4cm",
            "en": "canvas-frame-30x50-cm-4cm",
            "fr": "chassis-30x50-cm-4cm",
            "it": "telaio-30x50-cm-4cm"
          },
          "productId": "7999350735133",
          "family": "bars",
          "variantIds": [
            "43916985237789"
          ],
          "available": true,
          "variantId": "43916985237789"
        }
      ],
      "30x60": [
        {
          "handle": "schattenfugen-rahmen-set-30x60-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-30x60-cm-roh",
            "en": "floating-frame-set-30x60-cm-unfinished",
            "fr": "kit-de-caisse-americaine-30x60-cm-brut",
            "it": "set-cornice-a-cassetta-30x60-cm-grezzo"
          },
          "productId": "7999053529373",
          "family": "shadow",
          "variantIds": [
            "43727755444509"
          ],
          "available": true,
          "variantId": "43727755444509"
        },
        {
          "handle": "bespannter-keilrahmen-30x60-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x60-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-60-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-60-cm-qualite-galerie",
            "it": "telaio-telato-30-x-60-cm-qualita-gallery"
          },
          "productId": "7999162646813",
          "family": "gallery",
          "variantIds": [
            "43727983870237"
          ],
          "available": true,
          "variantId": "43727983870237"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305435421"
          ],
          "available": true,
          "variantId": "49195305435421"
        },
        {
          "handle": "keilrahmen-30x60-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x60-cm-4cm",
            "en": "canvas-frame-30x60-cm-4cm",
            "fr": "chassis-30x60-cm-4cm",
            "it": "telaio-30x60-cm-4cm"
          },
          "productId": "7999351193885",
          "family": "bars",
          "variantIds": [
            "43916985696541"
          ],
          "available": true,
          "variantId": "43916985696541"
        }
      ],
      "30x70": [
        {
          "handle": "schattenfugen-rahmen-set-30x70-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-30x70-cm-roh",
            "en": "floating-frame-set-30x70-cm-unfinished",
            "fr": "kit-de-caisse-americaine-30x70-cm-brut",
            "it": "set-cornice-a-cassetta-30x70-cm-grezzo"
          },
          "productId": "7999054119197",
          "family": "shadow",
          "variantIds": [
            "43727757443357"
          ],
          "available": true,
          "variantId": "43727757443357"
        },
        {
          "handle": "bespannter-keilrahmen-30x70-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x70-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-70-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-70-cm-qualite-galerie",
            "it": "telaio-telato-30-x-70-cm-qualita-gallery"
          },
          "productId": "7999163203869",
          "family": "gallery",
          "variantIds": [
            "43727984754973"
          ],
          "available": true,
          "variantId": "43727984754973"
        },
        {
          "handle": "keilrahmen-30x70-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x70-cm-4cm",
            "en": "canvas-frame-30x70-cm-4cm",
            "fr": "chassis-30x70-cm-4cm",
            "it": "telaio-30x70-cm-4cm"
          },
          "productId": "7999351750941",
          "family": "bars",
          "variantIds": [
            "43916986876189"
          ],
          "available": true,
          "variantId": "43916986876189"
        }
      ],
      "30x80": [
        {
          "handle": "schattenfugen-rahmen-set-30x80-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-30x80-cm-roh",
            "en": "floating-frame-set-30x80-cm-unfinished",
            "fr": "kit-de-caisse-americaine-30x80-cm-brut",
            "it": "set-cornice-a-cassetta-30x80-cm-grezzo"
          },
          "productId": "7999054676253",
          "family": "shadow",
          "variantIds": [
            "43727760720157"
          ],
          "available": true,
          "variantId": "43727760720157"
        },
        {
          "handle": "bespannter-keilrahmen-30x80-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x80-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-80-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-80-cm-qualite-galerie",
            "it": "telaio-telato-30-x-80-cm-qualita-gallery"
          },
          "productId": "7999163793693",
          "family": "gallery",
          "variantIds": [
            "43727985344797"
          ],
          "available": true,
          "variantId": "43727985344797"
        },
        {
          "handle": "keilrahmen-30x80-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x80-cm-4cm",
            "en": "canvas-frame-30x80-cm-4cm",
            "fr": "chassis-30x80-cm-4cm",
            "it": "telaio-30x80-cm-4cm"
          },
          "productId": "7999352406301",
          "family": "bars",
          "variantIds": [
            "43916987957533"
          ],
          "available": true,
          "variantId": "43916987957533"
        }
      ],
      "30x90": [
        {
          "handle": "schattenfugen-rahmen-set-30x90-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-30x90-cm-roh",
            "en": "floating-frame-set-30x90-cm-unfinished",
            "fr": "kit-de-caisse-americaine-30x90-cm-brut",
            "it": "set-cornice-a-cassetta-30x90-cm-grezzo"
          },
          "productId": "7999055233309",
          "family": "shadow",
          "variantIds": [
            "43727761375517"
          ],
          "available": true,
          "variantId": "43727761375517"
        },
        {
          "handle": "bespannter-keilrahmen-30x90-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x90-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-90-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-90-cm-qualite-galerie",
            "it": "telaio-telato-30-x-90-cm-qualita-gallery"
          },
          "productId": "7999164416285",
          "family": "gallery",
          "variantIds": [
            "43727985967389"
          ],
          "available": true,
          "variantId": "43727985967389"
        },
        {
          "handle": "keilrahmen-30x90-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x90-cm-4cm",
            "en": "canvas-frame-30x90-cm-4cm",
            "fr": "chassis-30x90-cm-4cm",
            "it": "telaio-30x90-cm-4cm"
          },
          "productId": "7999352963357",
          "family": "bars",
          "variantIds": [
            "43916988743965"
          ],
          "available": true,
          "variantId": "43916988743965"
        }
      ],
      "30x100": [
        {
          "handle": "schattenfugen-rahmen-set-30x100-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-30x100-cm-roh",
            "en": "floating-frame-set-30x100-cm-unfinished",
            "fr": "kit-de-caisse-americaine-30x100-cm-brut",
            "it": "set-cornice-a-cassetta-30x100-cm-grezzo"
          },
          "productId": "7999055823133",
          "family": "shadow",
          "variantIds": [
            "43727762325789"
          ],
          "available": true,
          "variantId": "43727762325789"
        },
        {
          "handle": "bespannter-keilrahmen-30x100-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x100-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-100-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-100-cm-qualite-galerie",
            "it": "telaio-telato-30-x-100-cm-qualita-gallery"
          },
          "productId": "7999164940573",
          "family": "gallery",
          "variantIds": [
            "43727987704093"
          ],
          "available": true,
          "variantId": "43727987704093"
        },
        {
          "handle": "keilrahmen-30x100-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x100-cm-4cm",
            "en": "canvas-frame-30x100-cm-4cm",
            "fr": "chassis-30x100-cm-4cm",
            "it": "telaio-30x100-cm-4cm"
          },
          "productId": "7999353487645",
          "family": "bars",
          "variantIds": [
            "43916989759773"
          ],
          "available": true,
          "variantId": "43916989759773"
        }
      ],
      "30x110": [
        {
          "handle": "bespannter-keilrahmen-30x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-110-cm-qualite-galerie",
            "it": "telaio-telato-30-x-110-cm-qualita-gallery"
          },
          "productId": "7999165464861",
          "family": "gallery",
          "variantIds": [
            "43727988982045"
          ],
          "available": true,
          "variantId": "43727988982045"
        },
        {
          "handle": "keilrahmen-30x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x110-cm-4cm",
            "en": "canvas-frame-30x110-cm-4cm",
            "fr": "chassis-30x110-cm-4cm",
            "it": "telaio-30x110-cm-4cm"
          },
          "productId": "7999353848093",
          "family": "bars",
          "variantIds": [
            "43916990152989"
          ],
          "available": true,
          "variantId": "43916990152989"
        }
      ],
      "30x120": [
        {
          "handle": "schattenfugen-rahmen-set-30x120-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-30x120-cm-roh",
            "en": "floating-frame-set-30x120-cm-unfinished",
            "fr": "kit-de-caisse-americaine-30x120-cm-brut",
            "it": "set-cornice-a-cassetta-30x120-cm-grezzo"
          },
          "productId": "7999056380189",
          "family": "shadow",
          "variantIds": [
            "43727763570973"
          ],
          "available": true,
          "variantId": "43727763570973"
        },
        {
          "handle": "bespannter-keilrahmen-30x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-120-cm-qualite-galerie",
            "it": "telaio-telato-30-x-120-cm-qualita-gallery"
          },
          "productId": "7999166021917",
          "family": "gallery",
          "variantIds": [
            "43727989932317"
          ],
          "available": true,
          "variantId": "43727989932317"
        },
        {
          "handle": "keilrahmen-30x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x120-cm-4cm",
            "en": "canvas-frame-30x120-cm-4cm",
            "fr": "chassis-30x120-cm-4cm",
            "it": "telaio-30x120-cm-4cm"
          },
          "productId": "7999354306845",
          "family": "bars",
          "variantIds": [
            "43944806842653"
          ],
          "available": true,
          "variantId": "43944806842653"
        }
      ],
      "30x130": [
        {
          "handle": "bespannter-keilrahmen-30x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-130-cm-qualite-galerie",
            "it": "telaio-telato-30-x-130-cm-qualita-gallery"
          },
          "productId": "7999166546205",
          "family": "gallery",
          "variantIds": [
            "43727990587677"
          ],
          "available": true,
          "variantId": "43727990587677"
        },
        {
          "handle": "keilrahmen-30x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x130-cm-4cm",
            "en": "canvas-frame-30x130-cm-4cm",
            "fr": "chassis-30x130-cm-4cm",
            "it": "telaio-30x130-cm-4cm"
          },
          "productId": "7999354896669",
          "family": "bars",
          "variantIds": [
            "43944807694621"
          ],
          "available": true,
          "variantId": "43944807694621"
        }
      ],
      "30x140": [
        {
          "handle": "schattenfugen-rahmen-set-30x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-30x140-cm-roh",
            "en": "floating-frame-set-30x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-30x140-cm-brut",
            "it": "set-cornice-a-cassetta-30x140-cm-grezzo"
          },
          "productId": "7999056806173",
          "family": "shadow",
          "variantIds": [
            "43727764095261"
          ],
          "available": false,
          "variantId": "43727764095261"
        },
        {
          "handle": "bespannter-keilrahmen-30x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-140-cm-qualite-galerie",
            "it": "telaio-telato-30-x-140-cm-qualita-gallery"
          },
          "productId": "7999167070493",
          "family": "gallery",
          "variantIds": [
            "43727991079197"
          ],
          "available": true,
          "variantId": "43727991079197"
        },
        {
          "handle": "keilrahmen-30x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x140-cm-4cm",
            "en": "canvas-frame-30x140-cm-4cm",
            "fr": "chassis-30x140-cm-4cm",
            "it": "telaio-30x140-cm-4cm"
          },
          "productId": "7999355388189",
          "family": "bars",
          "variantIds": [
            "43944808186141"
          ],
          "available": true,
          "variantId": "43944808186141"
        }
      ],
      "30x150": [
        {
          "handle": "bespannter-keilrahmen-30x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-150-cm-qualite-galerie",
            "it": "telaio-telato-30-x-150-cm-qualita-gallery"
          },
          "productId": "7999167562013",
          "family": "gallery",
          "variantIds": [
            "43727992291613"
          ],
          "available": true,
          "variantId": "43727992291613"
        },
        {
          "handle": "keilrahmen-30x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x150-cm-4cm",
            "en": "canvas-frame-30x150-cm-4cm",
            "fr": "chassis-30x150-cm-4cm",
            "it": "telaio-30x150-cm-4cm"
          },
          "productId": "7999355912477",
          "family": "bars",
          "variantIds": [
            "43944809136413"
          ],
          "available": true,
          "variantId": "43944809136413"
        }
      ],
      "30x160": [
        {
          "handle": "bespannter-keilrahmen-30x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-160-cm-qualite-galerie",
            "it": "telaio-telato-30-x-160-cm-qualita-gallery"
          },
          "productId": "7999168119069",
          "family": "gallery",
          "variantIds": [
            "43727992881437"
          ],
          "available": true,
          "variantId": "43727992881437"
        },
        {
          "handle": "keilrahmen-30x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x160-cm-4cm",
            "en": "canvas-frame-30x160-cm-4cm",
            "fr": "chassis-30x160-cm-4cm",
            "it": "telaio-30x160-cm-4cm"
          },
          "productId": "7999356403997",
          "family": "bars",
          "variantIds": [
            "43944809627933"
          ],
          "available": true,
          "variantId": "43944809627933"
        }
      ],
      "30x170": [
        {
          "handle": "bespannter-keilrahmen-30x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-170-cm-qualite-galerie",
            "it": "telaio-telato-30-x-170-cm-qualita-gallery"
          },
          "productId": "7999168610589",
          "family": "gallery",
          "variantIds": [
            "43727993471261"
          ],
          "available": true,
          "variantId": "43727993471261"
        },
        {
          "handle": "keilrahmen-30x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x170-cm-4cm",
            "en": "canvas-frame-30x170-cm-4cm",
            "fr": "chassis-30x170-cm-4cm",
            "it": "telaio-30x170-cm-4cm"
          },
          "productId": "7999356895517",
          "family": "bars",
          "variantIds": [
            "43944810316061"
          ],
          "available": true,
          "variantId": "43944810316061"
        }
      ],
      "30x180": [
        {
          "handle": "bespannter-keilrahmen-30x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-180-cm-qualite-galerie",
            "it": "telaio-telato-30-x-180-cm-qualita-gallery"
          },
          "productId": "7999169233181",
          "family": "gallery",
          "variantIds": [
            "43727994126621"
          ],
          "available": true,
          "variantId": "43727994126621"
        },
        {
          "handle": "keilrahmen-30x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x180-cm-4cm",
            "en": "canvas-frame-30x180-cm-4cm",
            "fr": "chassis-30x180-cm-4cm",
            "it": "telaio-30x180-cm-4cm"
          },
          "productId": "7999357354269",
          "family": "bars",
          "variantIds": [
            "43944810807581"
          ],
          "available": true,
          "variantId": "43944810807581"
        }
      ],
      "30x195": [
        {
          "handle": "bespannter-keilrahmen-30x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-30x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-30-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-30-x-195-cm-qualite-galerie",
            "it": "telaio-telato-30-x-195-cm-qualita-gallery"
          },
          "productId": "7999169790237",
          "family": "gallery",
          "variantIds": [
            "43727994716445"
          ],
          "available": true,
          "variantId": "43727994716445"
        },
        {
          "handle": "keilrahmen-30x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-30x195-cm-4cm",
            "en": "canvas-frame-30x195-cm-4cm",
            "fr": "chassis-30x195-cm-4cm",
            "it": "telaio-30x195-cm-4cm"
          },
          "productId": "7999357944093",
          "family": "bars",
          "variantIds": [
            "43944811594013"
          ],
          "available": true,
          "variantId": "43944811594013"
        }
      ],
      "40x40": [
        {
          "handle": "schattenfugen-rahmen-set-40x40-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-40x40-cm-roh",
            "en": "floating-frame-set-40x40-cm-unfinished",
            "fr": "kit-de-caisse-americaine-40x40-cm-brut",
            "it": "set-cornice-a-cassetta-40x40-cm-grezzo"
          },
          "productId": "7999057395997",
          "family": "shadow",
          "variantIds": [
            "43727767437597"
          ],
          "available": true,
          "variantId": "43727767437597"
        },
        {
          "handle": "bespannter-keilrahmen-40x40-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x40-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-40-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-40-cm-qualite-galerie",
            "it": "telaio-telato-40-x-40-cm-qualita-gallery"
          },
          "productId": "7999170248989",
          "family": "gallery",
          "variantIds": [
            "43727995502877"
          ],
          "available": true,
          "variantId": "43727995502877"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305304349"
          ],
          "available": true,
          "variantId": "49195305304349"
        },
        {
          "handle": "keilrahmen-40x40-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x40-cm-4cm",
            "en": "canvas-frame-40x40-cm-4cm",
            "fr": "chassis-40x40-cm-4cm",
            "it": "telaio-40x40-cm-4cm"
          },
          "productId": "7999358763293",
          "family": "bars",
          "variantIds": [
            "43944812609821"
          ],
          "available": true,
          "variantId": "43944812609821"
        }
      ],
      "40x50": [
        {
          "handle": "schattenfugen-rahmen-set-40x50-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-40x50-cm-roh",
            "en": "floating-frame-set-40x50-cm-unfinished",
            "fr": "kit-de-caisse-americaine-40x50-cm-brut",
            "it": "set-cornice-a-cassetta-40x50-cm-grezzo"
          },
          "productId": "7999057920285",
          "family": "shadow",
          "variantIds": [
            "43727768060189"
          ],
          "available": true,
          "variantId": "43727768060189"
        },
        {
          "handle": "bespannter-keilrahmen-40x50-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x50-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-50-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-50-cm-qualite-galerie",
            "it": "telaio-telato-40-x-50-cm-qualita-gallery"
          },
          "productId": "7999170838813",
          "family": "gallery",
          "variantIds": [
            "43727996289309"
          ],
          "available": true,
          "variantId": "43727996289309"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195609817373"
          ],
          "available": false,
          "variantId": "49195609817373"
        },
        {
          "handle": "keilrahmen-40x50-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x50-cm-4cm",
            "en": "canvas-frame-40x50-cm-4cm",
            "fr": "chassis-40x50-cm-4cm",
            "it": "telaio-40x50-cm-4cm"
          },
          "productId": "7999359451421",
          "family": "bars",
          "variantIds": [
            "43944814182685"
          ],
          "available": true,
          "variantId": "43944814182685"
        }
      ],
      "40x60": [
        {
          "handle": "schattenfugen-rahmen-set-40x60-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-40x60-cm-roh",
            "en": "floating-frame-set-40x60-cm-unfinished",
            "fr": "kit-de-caisse-americaine-40x60-cm-brut",
            "it": "set-cornice-a-cassetta-40x60-cm-grezzo"
          },
          "productId": "7999058706717",
          "family": "shadow",
          "variantIds": [
            "43727772975389"
          ],
          "available": true,
          "variantId": "43727772975389"
        },
        {
          "handle": "bespannter-keilrahmen-40x60-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x60-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-60-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-60-cm-qualite-galerie",
            "it": "telaio-telato-40-x-60-cm-qualita-gallery"
          },
          "productId": "7999171428637",
          "family": "gallery",
          "variantIds": [
            "43727996944669"
          ],
          "available": true,
          "variantId": "43727996944669"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305271581"
          ],
          "available": true,
          "variantId": "49195305271581"
        },
        {
          "handle": "keilrahmen-40x60-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x60-cm-4cm",
            "en": "canvas-frame-40x60-cm-4cm",
            "fr": "chassis-40x60-cm-4cm",
            "it": "telaio-40x60-cm-4cm"
          },
          "productId": "7999360205085",
          "family": "bars",
          "variantIds": [
            "43944815231261"
          ],
          "available": true,
          "variantId": "43944815231261"
        }
      ],
      "40x70": [
        {
          "handle": "schattenfugen-rahmen-set-40x70-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-40x70-cm-roh",
            "en": "floating-frame-set-40x70-cm-unfinished",
            "fr": "kit-de-caisse-americaine-40x70-cm-brut",
            "it": "set-cornice-a-cassetta-40x70-cm-grezzo"
          },
          "productId": "7999059263773",
          "family": "shadow",
          "variantIds": [
            "43727773597981"
          ],
          "available": true,
          "variantId": "43727773597981"
        },
        {
          "handle": "bespannter-keilrahmen-40x70-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x70-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-70-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-70-cm-qualite-galerie",
            "it": "telaio-telato-40-x-70-cm-qualita-gallery"
          },
          "productId": "7999171952925",
          "family": "gallery",
          "variantIds": [
            "43727998255389"
          ],
          "available": true,
          "variantId": "43727998255389"
        },
        {
          "handle": "keilrahmen-40x70-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x70-cm-4cm",
            "en": "canvas-frame-40x70-cm-4cm",
            "fr": "chassis-40x70-cm-4cm",
            "it": "telaio-40x70-cm-4cm"
          },
          "productId": "7999360827677",
          "family": "bars",
          "variantIds": [
            "43944815821085"
          ],
          "available": true,
          "variantId": "43944815821085"
        }
      ],
      "40x80": [
        {
          "handle": "schattenfugen-rahmen-set-40x80-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-40x80-cm-roh",
            "en": "floating-frame-set-40x80-cm-unfinished",
            "fr": "kit-de-caisse-americaine-40x80-cm-brut",
            "it": "set-cornice-a-cassetta-40x80-cm-grezzo"
          },
          "productId": "7999059755293",
          "family": "shadow",
          "variantIds": [
            "43727774187805"
          ],
          "available": true,
          "variantId": "43727774187805"
        },
        {
          "handle": "bespannter-keilrahmen-40x80-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x80-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-80-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-80-cm-qualite-galerie",
            "it": "telaio-telato-40-x-80-cm-qualita-gallery"
          },
          "productId": "7999172608285",
          "family": "gallery",
          "variantIds": [
            "43727998943517"
          ],
          "available": true,
          "variantId": "43727998943517"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305500957"
          ],
          "available": true,
          "variantId": "49195305500957"
        },
        {
          "handle": "keilrahmen-40x80-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x80-cm-4cm",
            "en": "canvas-frame-40x80-cm-4cm",
            "fr": "chassis-40x80-cm-4cm",
            "it": "telaio-40x80-cm-4cm"
          },
          "productId": "7999361745181",
          "family": "bars",
          "variantIds": [
            "43944816967965"
          ],
          "available": true,
          "variantId": "43944816967965"
        }
      ],
      "40x90": [
        {
          "handle": "schattenfugen-rahmen-set-40x90-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-40x90-cm-roh",
            "en": "floating-frame-set-40x90-cm-unfinished",
            "fr": "kit-de-caisse-americaine-40x90-cm-brut",
            "it": "set-cornice-a-cassetta-40x90-cm-grezzo"
          },
          "productId": "7999060345117",
          "family": "shadow",
          "variantIds": [
            "43727774843165"
          ],
          "available": true,
          "variantId": "43727774843165"
        },
        {
          "handle": "bespannter-keilrahmen-40x90-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x90-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-90-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-90-cm-qualite-galerie",
            "it": "telaio-telato-40-x-90-cm-qualita-gallery"
          },
          "productId": "7999173099805",
          "family": "gallery",
          "variantIds": [
            "43727999435037"
          ],
          "available": true,
          "variantId": "43727999435037"
        },
        {
          "handle": "keilrahmen-40x90-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x90-cm-4cm",
            "en": "canvas-frame-40x90-cm-4cm",
            "fr": "chassis-40x90-cm-4cm",
            "it": "telaio-40x90-cm-4cm"
          },
          "productId": "7999362466077",
          "family": "bars",
          "variantIds": [
            "43944817852701"
          ],
          "available": true,
          "variantId": "43944817852701"
        }
      ],
      "40x100": [
        {
          "handle": "schattenfugen-rahmen-set-40x100-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-40x100-cm-roh",
            "en": "floating-frame-set-40x100-cm-unfinished",
            "fr": "kit-de-caisse-americaine-40x100-cm-brut",
            "it": "set-cornice-a-cassetta-40x100-cm-grezzo"
          },
          "productId": "7999061000477",
          "family": "shadow",
          "variantIds": [
            "43727775760669"
          ],
          "available": true,
          "variantId": "43727775760669"
        },
        {
          "handle": "bespannter-keilrahmen-40x100-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x100-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-100-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-100-cm-qualite-galerie",
            "it": "telaio-telato-40-x-100-cm-qualita-gallery"
          },
          "productId": "7999173722397",
          "family": "gallery",
          "variantIds": [
            "43728000155933"
          ],
          "available": true,
          "variantId": "43728000155933"
        },
        {
          "handle": "keilrahmen-40x100-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x100-cm-4cm",
            "en": "canvas-frame-40x100-cm-4cm",
            "fr": "chassis-40x100-cm-4cm",
            "it": "telaio-40x100-cm-4cm"
          },
          "productId": "7999363219741",
          "family": "bars",
          "variantIds": [
            "43944818868509"
          ],
          "available": true,
          "variantId": "43944818868509"
        }
      ],
      "40x110": [
        {
          "handle": "bespannter-keilrahmen-40x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-110-cm-qualite-galerie",
            "it": "telaio-telato-40-x-110-cm-qualita-gallery"
          },
          "productId": "7999174279453",
          "family": "gallery",
          "variantIds": [
            "43728001171741"
          ],
          "available": true,
          "variantId": "43728001171741"
        },
        {
          "handle": "keilrahmen-40x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x110-cm-4cm",
            "en": "canvas-frame-40x110-cm-4cm",
            "fr": "chassis-40x110-cm-4cm",
            "it": "telaio-40x110-cm-4cm"
          },
          "productId": "7999364006173",
          "family": "bars",
          "variantIds": [
            "43944819884317"
          ],
          "available": true,
          "variantId": "43944819884317"
        }
      ],
      "40x120": [
        {
          "handle": "schattenfugen-rahmen-set-40x120-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-40x120-cm-roh",
            "en": "floating-frame-set-40x120-cm-unfinished",
            "fr": "kit-de-caisse-americaine-40x120-cm-brut",
            "it": "set-cornice-a-cassetta-40x120-cm-grezzo"
          },
          "productId": "7999061819677",
          "family": "shadow",
          "variantIds": [
            "43727776743709"
          ],
          "available": true,
          "variantId": "43727776743709"
        },
        {
          "handle": "bespannter-keilrahmen-40x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-120-cm-qualite-galerie",
            "it": "telaio-telato-40-x-120-cm-qualita-gallery"
          },
          "productId": "7999174967581",
          "family": "gallery",
          "variantIds": [
            "43728001958173"
          ],
          "available": true,
          "variantId": "43728001958173"
        },
        {
          "handle": "keilrahmen-40x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x120-cm-4cm",
            "en": "canvas-frame-40x120-cm-4cm",
            "fr": "chassis-40x120-cm-4cm",
            "it": "telaio-40x120-cm-4cm"
          },
          "productId": "7999364989213",
          "family": "bars",
          "variantIds": [
            "43944821260573"
          ],
          "available": true,
          "variantId": "43944821260573"
        }
      ],
      "40x130": [
        {
          "handle": "bespannter-keilrahmen-40x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-130-cm-qualite-galerie",
            "it": "telaio-telato-40-x-130-cm-qualita-gallery"
          },
          "productId": "7999175360797",
          "family": "gallery",
          "variantIds": [
            "43728002777373"
          ],
          "available": true,
          "variantId": "43728002777373"
        },
        {
          "handle": "keilrahmen-40x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x130-cm-4cm",
            "en": "canvas-frame-40x130-cm-4cm",
            "fr": "chassis-40x130-cm-4cm",
            "it": "telaio-40x130-cm-4cm"
          },
          "productId": "7999365775645",
          "family": "bars",
          "variantIds": [
            "43944822014237"
          ],
          "available": true,
          "variantId": "43944822014237"
        }
      ],
      "40x140": [
        {
          "handle": "schattenfugen-rahmen-set-40x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-40x140-cm-roh",
            "en": "floating-frame-set-40x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-40x140-cm-brut",
            "it": "set-cornice-a-cassetta-40x140-cm-grezzo"
          },
          "productId": "7999062901021",
          "family": "shadow",
          "variantIds": [
            "43727778054429"
          ],
          "available": false,
          "variantId": "43727778054429"
        },
        {
          "handle": "bespannter-keilrahmen-40x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-140-cm-qualite-galerie",
            "it": "telaio-telato-40-x-140-cm-qualita-gallery"
          },
          "productId": "7999175983389",
          "family": "gallery",
          "variantIds": [
            "43728003432733"
          ],
          "available": true,
          "variantId": "43728003432733"
        },
        {
          "handle": "keilrahmen-40x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x140-cm-4cm",
            "en": "canvas-frame-40x140-cm-4cm",
            "fr": "chassis-40x140-cm-4cm",
            "it": "telaio-40x140-cm-4cm"
          },
          "productId": "7999366562077",
          "family": "bars",
          "variantIds": [
            "43944823128349"
          ],
          "available": true,
          "variantId": "43944823128349"
        }
      ],
      "40x150": [
        {
          "handle": "bespannter-keilrahmen-40x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-150-cm-qualite-galerie",
            "it": "telaio-telato-40-x-150-cm-qualita-gallery"
          },
          "productId": "7999176573213",
          "family": "gallery",
          "variantIds": [
            "43728004710685"
          ],
          "available": true,
          "variantId": "43728004710685"
        },
        {
          "handle": "keilrahmen-40x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x150-cm-4cm",
            "en": "canvas-frame-40x150-cm-4cm",
            "fr": "chassis-40x150-cm-4cm",
            "it": "telaio-40x150-cm-4cm"
          },
          "productId": "7999367250205",
          "family": "bars",
          "variantIds": [
            "43944824733981"
          ],
          "available": true,
          "variantId": "43944824733981"
        }
      ],
      "40x160": [
        {
          "handle": "bespannter-keilrahmen-40x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-160-cm-qualite-galerie",
            "it": "telaio-telato-40-x-160-cm-qualita-gallery"
          },
          "productId": "7999177228573",
          "family": "gallery",
          "variantIds": [
            "43728006086941"
          ],
          "available": true,
          "variantId": "43728006086941"
        },
        {
          "handle": "keilrahmen-40x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x160-cm-4cm",
            "en": "canvas-frame-40x160-cm-4cm",
            "fr": "chassis-40x160-cm-4cm",
            "it": "telaio-40x160-cm-4cm"
          },
          "productId": "7999368888605",
          "family": "bars",
          "variantIds": [
            "43944826143005"
          ],
          "available": true,
          "variantId": "43944826143005"
        }
      ],
      "40x170": [
        {
          "handle": "bespannter-keilrahmen-40x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-170-cm-qualite-galerie",
            "it": "telaio-telato-40-x-170-cm-qualita-gallery"
          },
          "productId": "7999177687325",
          "family": "gallery",
          "variantIds": [
            "43728006545693"
          ],
          "available": true,
          "variantId": "43728006545693"
        },
        {
          "handle": "keilrahmen-40x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x170-cm-4cm",
            "en": "canvas-frame-40x170-cm-4cm",
            "fr": "chassis-40x170-cm-4cm",
            "it": "telaio-40x170-cm-4cm"
          },
          "productId": "7999369838877",
          "family": "bars",
          "variantIds": [
            "43944827453725"
          ],
          "available": true,
          "variantId": "43944827453725"
        }
      ],
      "40x180": [
        {
          "handle": "bespannter-keilrahmen-40x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-180-cm-qualite-galerie",
            "it": "telaio-telato-40-x-180-cm-qualita-gallery"
          },
          "productId": "7999178506525",
          "family": "gallery",
          "variantIds": [
            "43728007856413"
          ],
          "available": true,
          "variantId": "43728007856413"
        },
        {
          "handle": "keilrahmen-40x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x180-cm-4cm",
            "en": "canvas-frame-40x180-cm-4cm",
            "fr": "chassis-40x180-cm-4cm",
            "it": "telaio-40x180-cm-4cm"
          },
          "productId": "7999370527005",
          "family": "bars",
          "variantIds": [
            "43944828141853"
          ],
          "available": true,
          "variantId": "43944828141853"
        }
      ],
      "40x195": [
        {
          "handle": "bespannter-keilrahmen-40x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-40x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-40-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-40-x-195-cm-qualite-galerie",
            "it": "telaio-telato-40-x-195-cm-qualita-gallery"
          },
          "productId": "7999179161885",
          "family": "gallery",
          "variantIds": [
            "43728010248477"
          ],
          "available": true,
          "variantId": "43728010248477"
        },
        {
          "handle": "keilrahmen-40x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-40x195-cm-4cm",
            "en": "canvas-frame-40x195-cm-4cm",
            "fr": "chassis-40x195-cm-4cm",
            "it": "telaio-40x195-cm-4cm"
          },
          "productId": "7999371346205",
          "family": "bars",
          "variantIds": [
            "43944829583645"
          ],
          "available": true,
          "variantId": "43944829583645"
        }
      ],
      "50x50": [
        {
          "handle": "schattenfugen-rahmen-set-50x50-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-50x50-cm-roh",
            "en": "floating-frame-set-50x50-cm-unfinished",
            "fr": "kit-de-caisse-americaine-50x50-cm-brut",
            "it": "set-cornice-a-cassetta-50x50-cm-grezzo"
          },
          "productId": "7999063785757",
          "family": "shadow",
          "variantIds": [
            "43727778939165"
          ],
          "available": true,
          "variantId": "43727778939165"
        },
        {
          "handle": "bespannter-keilrahmen-50x50-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x50-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-50-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-50-cm-qualite-galerie",
            "it": "telaio-telato-50-x-50-cm-qualita-gallery"
          },
          "productId": "7999179686173",
          "family": "gallery",
          "variantIds": [
            "43728011264285"
          ],
          "available": true,
          "variantId": "43728011264285"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305238813"
          ],
          "available": true,
          "variantId": "49195305238813"
        },
        {
          "handle": "keilrahmen-50x50-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x50-cm-4cm",
            "en": "canvas-frame-50x50-cm-4cm",
            "fr": "chassis-50x50-cm-4cm",
            "it": "telaio-50x50-cm-4cm"
          },
          "productId": "7999372099869",
          "family": "bars",
          "variantIds": [
            "43944830664989"
          ],
          "available": true,
          "variantId": "43944830664989"
        }
      ],
      "50x60": [
        {
          "handle": "schattenfugen-rahmen-set-50x60-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-50x60-cm-roh",
            "en": "floating-frame-set-50x60-cm-unfinished",
            "fr": "kit-de-caisse-americaine-50x60-cm-brut",
            "it": "set-cornice-a-cassetta-50x60-cm-grezzo"
          },
          "productId": "7999064867101",
          "family": "shadow",
          "variantIds": [
            "43727782215965"
          ],
          "available": true,
          "variantId": "43727782215965"
        },
        {
          "handle": "bespannter-keilrahmen-50x60-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x60-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-60-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-60-cm-qualite-galerie",
            "it": "telaio-telato-50-x-60-cm-qualita-gallery"
          },
          "productId": "7999180177693",
          "family": "gallery",
          "variantIds": [
            "43728011821341"
          ],
          "available": true,
          "variantId": "43728011821341"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305206045"
          ],
          "available": true,
          "variantId": "49195305206045"
        },
        {
          "handle": "keilrahmen-50x60-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x60-cm-4cm",
            "en": "canvas-frame-50x60-cm-4cm",
            "fr": "chassis-50x60-cm-4cm",
            "it": "telaio-50x60-cm-4cm"
          },
          "productId": "7999372820765",
          "family": "bars",
          "variantIds": [
            "43944831582493"
          ],
          "available": true,
          "variantId": "43944831582493"
        }
      ],
      "50x70": [
        {
          "handle": "schattenfugen-rahmen-set-50x70-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-50x70-cm-roh",
            "en": "floating-frame-set-50x70-cm-unfinished",
            "fr": "kit-de-caisse-americaine-50x70-cm-brut",
            "it": "set-cornice-a-cassetta-50x70-cm-grezzo"
          },
          "productId": "7999065948445",
          "family": "shadow",
          "variantIds": [
            "43727789031709"
          ],
          "available": true,
          "variantId": "43727789031709"
        },
        {
          "handle": "bespannter-keilrahmen-50x70-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x70-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-70-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-70-cm-qualite-galerie",
            "it": "telaio-telato-50-x-70-cm-qualita-gallery"
          },
          "productId": "7999180603677",
          "family": "gallery",
          "variantIds": [
            "43728012771613"
          ],
          "available": true,
          "variantId": "43728012771613"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305173277"
          ],
          "available": true,
          "variantId": "49195305173277"
        },
        {
          "handle": "keilrahmen-50x70-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x70-cm-4cm",
            "en": "canvas-frame-50x70-cm-4cm",
            "fr": "chassis-50x70-cm-4cm",
            "it": "telaio-50x70-cm-4cm"
          },
          "productId": "7999373443357",
          "family": "bars",
          "variantIds": [
            "43944832205085"
          ],
          "available": true,
          "variantId": "43944832205085"
        }
      ],
      "50x80": [
        {
          "handle": "schattenfugen-rahmen-set-50x80-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-50x80-cm-roh",
            "en": "floating-frame-set-50x80-cm-unfinished",
            "fr": "kit-de-caisse-americaine-50x80-cm-brut",
            "it": "set-cornice-a-cassetta-50x80-cm-grezzo"
          },
          "productId": "7999067062557",
          "family": "shadow",
          "variantIds": [
            "43727790473501"
          ],
          "available": true,
          "variantId": "43727790473501"
        },
        {
          "handle": "bespannter-keilrahmen-50x80-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x80-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-80-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-80-cm-qualite-galerie",
            "it": "telaio-telato-50-x-80-cm-qualita-gallery"
          },
          "productId": "7999181160733",
          "family": "gallery",
          "variantIds": [
            "43728013295901"
          ],
          "available": true,
          "variantId": "43728013295901"
        },
        {
          "handle": "keilrahmen-50x80-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x80-cm-4cm",
            "en": "canvas-frame-50x80-cm-4cm",
            "fr": "chassis-50x80-cm-4cm",
            "it": "telaio-50x80-cm-4cm"
          },
          "productId": "7999374164253",
          "family": "bars",
          "variantIds": [
            "43944833122589"
          ],
          "available": true,
          "variantId": "43944833122589"
        }
      ],
      "50x90": [
        {
          "handle": "schattenfugen-rahmen-set-50x90-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-50x90-cm-roh",
            "en": "floating-frame-set-50x90-cm-unfinished",
            "fr": "kit-de-caisse-americaine-50x90-cm-brut",
            "it": "set-cornice-a-cassetta-50x90-cm-grezzo"
          },
          "productId": "7999068111133",
          "family": "shadow",
          "variantIds": [
            "43727791718685"
          ],
          "available": true,
          "variantId": "43727791718685"
        },
        {
          "handle": "bespannter-keilrahmen-50x90-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x90-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-90-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-90-cm-qualite-galerie",
            "it": "telaio-telato-50-x-90-cm-qualita-gallery"
          },
          "productId": "7999181750557",
          "family": "gallery",
          "variantIds": [
            "43728013885725"
          ],
          "available": true,
          "variantId": "43728013885725"
        },
        {
          "handle": "keilrahmen-50x90-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x90-cm-4cm",
            "en": "canvas-frame-50x90-cm-4cm",
            "fr": "chassis-50x90-cm-4cm",
            "it": "telaio-50x90-cm-4cm"
          },
          "productId": "7999374917917",
          "family": "bars",
          "variantIds": [
            "43944834400541"
          ],
          "available": true,
          "variantId": "43944834400541"
        }
      ],
      "50x100": [
        {
          "handle": "schattenfugen-rahmen-set-50x100-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-50x100-cm-roh",
            "en": "floating-frame-set-50x100-cm-unfinished",
            "fr": "kit-de-caisse-americaine-50x100-cm-brut",
            "it": "set-cornice-a-cassetta-50x100-cm-grezzo"
          },
          "productId": "7999069126941",
          "family": "shadow",
          "variantIds": [
            "43727793094941"
          ],
          "available": true,
          "variantId": "43727793094941"
        },
        {
          "handle": "bespannter-keilrahmen-50x100-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x100-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-100-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-100-cm-qualite-galerie",
            "it": "telaio-telato-50-x-100-cm-qualita-gallery"
          },
          "productId": "7999182340381",
          "family": "gallery",
          "variantIds": [
            "43728014770461"
          ],
          "available": true,
          "variantId": "43728014770461"
        },
        {
          "handle": "keilrahmen-50x100-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x100-cm-4cm",
            "en": "canvas-frame-50x100-cm-4cm",
            "fr": "chassis-50x100-cm-4cm",
            "it": "telaio-50x100-cm-4cm"
          },
          "productId": "7999375606045",
          "family": "bars",
          "variantIds": [
            "43944835088669"
          ],
          "available": true,
          "variantId": "43944835088669"
        }
      ],
      "50x110": [
        {
          "handle": "bespannter-keilrahmen-50x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-110-cm-qualite-galerie",
            "it": "telaio-telato-50-x-110-cm-qualita-gallery"
          },
          "productId": "7999182733597",
          "family": "gallery",
          "variantIds": [
            "43728015425821"
          ],
          "available": true,
          "variantId": "43728015425821"
        },
        {
          "handle": "keilrahmen-50x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x110-cm-4cm",
            "en": "canvas-frame-50x110-cm-4cm",
            "fr": "chassis-50x110-cm-4cm",
            "it": "telaio-50x110-cm-4cm"
          },
          "productId": "7999376261405",
          "family": "bars",
          "variantIds": [
            "43944835744029"
          ],
          "available": true,
          "variantId": "43944835744029"
        }
      ],
      "50x120": [
        {
          "handle": "schattenfugen-rahmen-set-50x120-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-50x120-cm-roh",
            "en": "floating-frame-set-50x120-cm-unfinished",
            "fr": "kit-de-caisse-americaine-50x120-cm-brut",
            "it": "set-cornice-a-cassetta-50x120-cm-grezzo"
          },
          "productId": "7999069913373",
          "family": "shadow",
          "variantIds": [
            "43727794077981"
          ],
          "available": true,
          "variantId": "43727794077981"
        },
        {
          "handle": "bespannter-keilrahmen-50x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-120-cm-qualite-galerie",
            "it": "telaio-telato-50-x-120-cm-qualita-gallery"
          },
          "productId": "7999183257885",
          "family": "gallery",
          "variantIds": [
            "43728016048413"
          ],
          "available": true,
          "variantId": "43728016048413"
        },
        {
          "handle": "keilrahmen-50x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x120-cm-4cm",
            "en": "canvas-frame-50x120-cm-4cm",
            "fr": "chassis-50x120-cm-4cm",
            "it": "telaio-50x120-cm-4cm"
          },
          "productId": "7999376818461",
          "family": "bars",
          "variantIds": [
            "43944836497693"
          ],
          "available": true,
          "variantId": "43944836497693"
        }
      ],
      "50x130": [
        {
          "handle": "bespannter-keilrahmen-50x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-130-cm-qualite-galerie",
            "it": "telaio-telato-50-x-130-cm-qualita-gallery"
          },
          "productId": "7999183913245",
          "family": "gallery",
          "variantIds": [
            "43728017064221"
          ],
          "available": true,
          "variantId": "43728017064221"
        },
        {
          "handle": "keilrahmen-50x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x130-cm-4cm",
            "en": "canvas-frame-50x130-cm-4cm",
            "fr": "chassis-50x130-cm-4cm",
            "it": "telaio-50x130-cm-4cm"
          },
          "productId": "7999377309981",
          "family": "bars",
          "variantIds": [
            "43944837087517"
          ],
          "available": true,
          "variantId": "43944837087517"
        }
      ],
      "50x140": [
        {
          "handle": "schattenfugen-rahmen-set-50x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-50x140-cm-roh",
            "en": "floating-frame-set-50x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-50x140-cm-brut",
            "it": "set-cornice-a-cassetta-50x140-cm-grezzo"
          },
          "productId": "7999070798109",
          "family": "shadow",
          "variantIds": [
            "43727795552541"
          ],
          "available": false,
          "variantId": "43727795552541"
        },
        {
          "handle": "bespannter-keilrahmen-50x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-140-cm-qualite-galerie",
            "it": "telaio-telato-50-x-140-cm-qualita-gallery"
          },
          "productId": "7999184503069",
          "family": "gallery",
          "variantIds": [
            "43728017948957"
          ],
          "available": true,
          "variantId": "43728017948957"
        },
        {
          "handle": "keilrahmen-50x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x140-cm-4cm",
            "en": "canvas-frame-50x140-cm-4cm",
            "fr": "chassis-50x140-cm-4cm",
            "it": "telaio-50x140-cm-4cm"
          },
          "productId": "7999377834269",
          "family": "bars",
          "variantIds": [
            "43944838332701"
          ],
          "available": true,
          "variantId": "43944838332701"
        }
      ],
      "50x150": [
        {
          "handle": "bespannter-keilrahmen-50x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-150-cm-qualite-galerie",
            "it": "telaio-telato-50-x-150-cm-qualita-gallery"
          },
          "productId": "7999184830749",
          "family": "gallery",
          "variantIds": [
            "43728018276637"
          ],
          "available": true,
          "variantId": "43728018276637"
        },
        {
          "handle": "keilrahmen-50x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x150-cm-4cm",
            "en": "canvas-frame-50x150-cm-4cm",
            "fr": "chassis-50x150-cm-4cm",
            "it": "telaio-50x150-cm-4cm"
          },
          "productId": "7999378325789",
          "family": "bars",
          "variantIds": [
            "43944839250205"
          ],
          "available": true,
          "variantId": "43944839250205"
        }
      ],
      "50x160": [
        {
          "handle": "bespannter-keilrahmen-50x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-160-cm-qualite-galerie",
            "it": "telaio-telato-50-x-160-cm-qualita-gallery"
          },
          "productId": "7999185453341",
          "family": "gallery",
          "variantIds": [
            "43728020308253"
          ],
          "available": true,
          "variantId": "43728020308253"
        },
        {
          "handle": "keilrahmen-50x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x160-cm-4cm",
            "en": "canvas-frame-50x160-cm-4cm",
            "fr": "chassis-50x160-cm-4cm",
            "it": "telaio-50x160-cm-4cm"
          },
          "productId": "7999378915613",
          "family": "bars",
          "variantIds": [
            "43944840495389"
          ],
          "available": true,
          "variantId": "43944840495389"
        }
      ],
      "50x170": [
        {
          "handle": "bespannter-keilrahmen-50x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-170-cm-qualite-galerie",
            "it": "telaio-telato-50-x-170-cm-qualita-gallery"
          },
          "productId": "7999186075933",
          "family": "gallery",
          "variantIds": [
            "43728021815581"
          ],
          "available": true,
          "variantId": "43728021815581"
        },
        {
          "handle": "keilrahmen-50x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x170-cm-4cm",
            "en": "canvas-frame-50x170-cm-4cm",
            "fr": "chassis-50x170-cm-4cm",
            "it": "telaio-50x170-cm-4cm"
          },
          "productId": "7999379570973",
          "family": "bars",
          "variantIds": [
            "43944841478429"
          ],
          "available": true,
          "variantId": "43944841478429"
        }
      ],
      "50x180": [
        {
          "handle": "bespannter-keilrahmen-50x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-180-cm-qualite-galerie",
            "it": "telaio-telato-50-x-180-cm-qualita-gallery"
          },
          "productId": "7999186600221",
          "family": "gallery",
          "variantIds": [
            "43728022700317"
          ],
          "available": true,
          "variantId": "43728022700317"
        },
        {
          "handle": "keilrahmen-50x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x180-cm-4cm",
            "en": "canvas-frame-50x180-cm-4cm",
            "fr": "chassis-50x180-cm-4cm",
            "it": "telaio-50x180-cm-4cm"
          },
          "productId": "7999380029725",
          "family": "bars",
          "variantIds": [
            "43944842002717"
          ],
          "available": true,
          "variantId": "43944842002717"
        }
      ],
      "50x195": [
        {
          "handle": "bespannter-keilrahmen-50x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-50x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-50-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-50-x-195-cm-qualite-galerie",
            "it": "telaio-telato-50-x-195-cm-qualita-gallery"
          },
          "productId": "7999187091741",
          "family": "gallery",
          "variantIds": [
            "43728023191837"
          ],
          "available": true,
          "variantId": "43728023191837"
        },
        {
          "handle": "keilrahmen-50x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-50x195-cm-4cm",
            "en": "canvas-frame-50x195-cm-4cm",
            "fr": "chassis-50x195-cm-4cm",
            "it": "telaio-50x195-cm-4cm"
          },
          "productId": "7999380554013",
          "family": "bars",
          "variantIds": [
            "43944842821917"
          ],
          "available": true,
          "variantId": "43944842821917"
        }
      ],
      "60x60": [
        {
          "handle": "schattenfugen-rahmen-set-60x60-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-60x60-cm-roh",
            "en": "floating-frame-set-60x60-cm-unfinished",
            "fr": "kit-de-caisse-americaine-60x60-cm-brut",
            "it": "set-cornice-a-cassetta-60x60-cm-grezzo"
          },
          "productId": "7999071748381",
          "family": "shadow",
          "variantIds": [
            "43727796699421"
          ],
          "available": true,
          "variantId": "43727796699421"
        },
        {
          "handle": "bespannter-keilrahmen-60x60-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x60-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-60-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-60-cm-qualite-galerie",
            "it": "telaio-telato-60-x-60-cm-qualita-gallery"
          },
          "productId": "7999187484957",
          "family": "gallery",
          "variantIds": [
            "43728023879965"
          ],
          "available": true,
          "variantId": "43728023879965"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305140509"
          ],
          "available": true,
          "variantId": "49195305140509"
        },
        {
          "handle": "keilrahmen-60x60-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x60-cm-4cm",
            "en": "canvas-frame-60x60-cm-4cm",
            "fr": "chassis-60x60-cm-4cm",
            "it": "telaio-60x60-cm-4cm"
          },
          "productId": "7999381143837",
          "family": "bars",
          "variantIds": [
            "43944843444509"
          ],
          "available": true,
          "variantId": "43944843444509"
        }
      ],
      "60x70": [
        {
          "handle": "schattenfugen-rahmen-set-60x70-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-60x70-cm-roh",
            "en": "floating-frame-set-60x70-cm-unfinished",
            "fr": "kit-de-caisse-americaine-60x70-cm-brut",
            "it": "set-cornice-a-cassetta-60x70-cm-grezzo"
          },
          "productId": "7999073026333",
          "family": "shadow",
          "variantIds": [
            "43727800271133"
          ],
          "available": true,
          "variantId": "43727800271133"
        },
        {
          "handle": "bespannter-keilrahmen-60x70-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x70-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-70-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-70-cm-qualite-galerie",
            "it": "telaio-telato-60-x-70-cm-qualita-gallery"
          },
          "productId": "7999188140317",
          "family": "gallery",
          "variantIds": [
            "43728024535325"
          ],
          "available": true,
          "variantId": "43728024535325"
        },
        {
          "handle": "keilrahmen-60x70-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x70-cm-4cm",
            "en": "canvas-frame-60x70-cm-4cm",
            "fr": "chassis-60x70-cm-4cm",
            "it": "telaio-60x70-cm-4cm"
          },
          "productId": "7999381635357",
          "family": "bars",
          "variantIds": [
            "43944845967645"
          ],
          "available": true,
          "variantId": "43944845967645"
        }
      ],
      "60x80": [
        {
          "handle": "schattenfugen-rahmen-set-60x80-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-60x80-cm-roh",
            "en": "floating-frame-set-60x80-cm-unfinished",
            "fr": "kit-de-caisse-americaine-60x80-cm-brut",
            "it": "set-cornice-a-cassetta-60x80-cm-grezzo"
          },
          "productId": "7999074009373",
          "family": "shadow",
          "variantIds": [
            "43727801385245"
          ],
          "available": true,
          "variantId": "43727801385245"
        },
        {
          "handle": "bespannter-keilrahmen-60x80-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x80-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-80-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-80-cm-qualite-galerie",
            "it": "telaio-telato-60-x-80-cm-qualita-gallery"
          },
          "productId": "7999188795677",
          "family": "gallery",
          "variantIds": [
            "43728025387293"
          ],
          "available": true,
          "variantId": "43728025387293"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305107741"
          ],
          "available": true,
          "variantId": "49195305107741"
        },
        {
          "handle": "keilrahmen-60x80-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x80-cm-4cm",
            "en": "canvas-frame-60x80-cm-4cm",
            "fr": "chassis-60x80-cm-4cm",
            "it": "telaio-60x80-cm-4cm"
          },
          "productId": "7999382257949",
          "family": "bars",
          "variantIds": [
            "43944846917917"
          ],
          "available": true,
          "variantId": "43944846917917"
        }
      ],
      "60x90": [
        {
          "handle": "schattenfugen-rahmen-set-60x90-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-60x90-cm-roh",
            "en": "floating-frame-set-60x90-cm-unfinished",
            "fr": "kit-de-caisse-americaine-60x90-cm-brut",
            "it": "set-cornice-a-cassetta-60x90-cm-grezzo"
          },
          "productId": "7999074959645",
          "family": "shadow",
          "variantIds": [
            "43727803187485"
          ],
          "available": true,
          "variantId": "43727803187485"
        },
        {
          "handle": "bespannter-keilrahmen-60x90-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x90-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-90-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-90-cm-qualite-galerie",
            "it": "telaio-telato-60-x-90-cm-qualita-gallery"
          },
          "productId": "7999189418269",
          "family": "gallery",
          "variantIds": [
            "43728027156765"
          ],
          "available": true,
          "variantId": "43728027156765"
        },
        {
          "handle": "keilrahmen-60x90-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x90-cm-4cm",
            "en": "canvas-frame-60x90-cm-4cm",
            "fr": "chassis-60x90-cm-4cm",
            "it": "telaio-60x90-cm-4cm"
          },
          "productId": "7999382683933",
          "family": "bars",
          "variantIds": [
            "43944847606045"
          ],
          "available": true,
          "variantId": "43944847606045"
        }
      ],
      "60x100": [
        {
          "handle": "schattenfugen-rahmen-set-60x100-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-60x100-cm-roh",
            "en": "floating-frame-set-60x100-cm-unfinished",
            "fr": "kit-de-caisse-americaine-60x100-cm-brut",
            "it": "set-cornice-a-cassetta-60x100-cm-grezzo"
          },
          "productId": "7999075877149",
          "family": "shadow",
          "variantIds": [
            "43727804301597"
          ],
          "available": true,
          "variantId": "43727804301597"
        },
        {
          "handle": "bespannter-keilrahmen-60x100-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x100-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-100-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-100-cm-qualite-galerie",
            "it": "telaio-telato-60-x-100-cm-qualita-gallery"
          },
          "productId": "7999189909789",
          "family": "gallery",
          "variantIds": [
            "43728027648285"
          ],
          "available": true,
          "variantId": "43728027648285"
        },
        {
          "handle": "keilrahmen-60x100-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x100-cm-4cm",
            "en": "canvas-frame-60x100-cm-4cm",
            "fr": "chassis-60x100-cm-4cm",
            "it": "telaio-60x100-cm-4cm"
          },
          "productId": "7999383208221",
          "family": "bars",
          "variantIds": [
            "43944848326941"
          ],
          "available": true,
          "variantId": "43944848326941"
        }
      ],
      "60x110": [
        {
          "handle": "bespannter-keilrahmen-60x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-110-cm-qualite-galerie",
            "it": "telaio-telato-60-x-110-cm-qualita-gallery"
          },
          "productId": "7999190532381",
          "family": "gallery",
          "variantIds": [
            "43728028434717"
          ],
          "available": true,
          "variantId": "43728028434717"
        },
        {
          "handle": "keilrahmen-60x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x110-cm-4cm",
            "en": "canvas-frame-60x110-cm-4cm",
            "fr": "chassis-60x110-cm-4cm",
            "it": "telaio-60x110-cm-4cm"
          },
          "productId": "7999383830813",
          "family": "bars",
          "variantIds": [
            "43944849015069"
          ],
          "available": true,
          "variantId": "43944849015069"
        }
      ],
      "60x120": [
        {
          "handle": "schattenfugen-rahmen-set-60x120-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-60x120-cm-roh",
            "en": "floating-frame-set-60x120-cm-unfinished",
            "fr": "kit-de-caisse-americaine-60x120-cm-brut",
            "it": "set-cornice-a-cassetta-60x120-cm-grezzo"
          },
          "productId": "7999076925725",
          "family": "shadow",
          "variantIds": [
            "43727805546781"
          ],
          "available": true,
          "variantId": "43727805546781"
        },
        {
          "handle": "bespannter-keilrahmen-60x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-120-cm-qualite-galerie",
            "it": "telaio-telato-60-x-120-cm-qualita-gallery"
          },
          "productId": "7999191220509",
          "family": "gallery",
          "variantIds": [
            "43728029614365"
          ],
          "available": true,
          "variantId": "43728029614365"
        },
        {
          "handle": "keilrahmen-60x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x120-cm-4cm",
            "en": "canvas-frame-60x120-cm-4cm",
            "fr": "chassis-60x120-cm-4cm",
            "it": "telaio-60x120-cm-4cm"
          },
          "productId": "7999384453405",
          "family": "bars",
          "variantIds": [
            "43944849867037"
          ],
          "available": true,
          "variantId": "43944849867037"
        }
      ],
      "60x130": [
        {
          "handle": "bespannter-keilrahmen-60x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-130-cm-qualite-galerie",
            "it": "telaio-telato-60-x-130-cm-qualita-gallery"
          },
          "productId": "7999191810333",
          "family": "gallery",
          "variantIds": [
            "43728032629021"
          ],
          "available": true,
          "variantId": "43728032629021"
        },
        {
          "handle": "keilrahmen-60x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x130-cm-4cm",
            "en": "canvas-frame-60x130-cm-4cm",
            "fr": "chassis-60x130-cm-4cm",
            "it": "telaio-60x130-cm-4cm"
          },
          "productId": "7999384879389",
          "family": "bars",
          "variantIds": [
            "43944850293021"
          ],
          "available": true,
          "variantId": "43944850293021"
        }
      ],
      "60x140": [
        {
          "handle": "schattenfugen-rahmen-set-60x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-60x140-cm-roh",
            "en": "floating-frame-set-60x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-60x140-cm-brut",
            "it": "set-cornice-a-cassetta-60x140-cm-grezzo"
          },
          "productId": "7999077679389",
          "family": "shadow",
          "variantIds": [
            "43727806529821"
          ],
          "available": false,
          "variantId": "43727806529821"
        },
        {
          "handle": "bespannter-keilrahmen-60x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-140-cm-qualite-galerie",
            "it": "telaio-telato-60-x-140-cm-qualita-gallery"
          },
          "productId": "7999192400157",
          "family": "gallery",
          "variantIds": [
            "43728033644829"
          ],
          "available": true,
          "variantId": "43728033644829"
        },
        {
          "handle": "keilrahmen-60x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x140-cm-4cm",
            "en": "canvas-frame-60x140-cm-4cm",
            "fr": "chassis-60x140-cm-4cm",
            "it": "telaio-60x140-cm-4cm"
          },
          "productId": "7999385272605",
          "family": "bars",
          "variantIds": [
            "43944852259101"
          ],
          "available": true,
          "variantId": "43944852259101"
        }
      ],
      "60x150": [
        {
          "handle": "bespannter-keilrahmen-60x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-150-cm-qualite-galerie",
            "it": "telaio-telato-60-x-150-cm-qualita-gallery"
          },
          "productId": "7999192858909",
          "family": "gallery",
          "variantIds": [
            "43728034103581"
          ],
          "available": true,
          "variantId": "43728034103581"
        },
        {
          "handle": "keilrahmen-60x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x150-cm-4cm",
            "en": "canvas-frame-60x150-cm-4cm",
            "fr": "chassis-60x150-cm-4cm",
            "it": "telaio-60x150-cm-4cm"
          },
          "productId": "7999385829661",
          "family": "bars",
          "variantIds": [
            "43944853274909"
          ],
          "available": true,
          "variantId": "43944853274909"
        }
      ],
      "60x160": [
        {
          "handle": "bespannter-keilrahmen-60x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-160-cm-qualite-galerie",
            "it": "telaio-telato-60-x-160-cm-qualita-gallery"
          },
          "productId": "7999193415965",
          "family": "gallery",
          "variantIds": [
            "43728034824477"
          ],
          "available": true,
          "variantId": "43728034824477"
        },
        {
          "handle": "keilrahmen-60x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x160-cm-4cm",
            "en": "canvas-frame-60x160-cm-4cm",
            "fr": "chassis-60x160-cm-4cm",
            "it": "telaio-60x160-cm-4cm"
          },
          "productId": "7999386222877",
          "family": "bars",
          "variantIds": [
            "43944853668125"
          ],
          "available": true,
          "variantId": "43944853668125"
        }
      ],
      "60x170": [
        {
          "handle": "bespannter-keilrahmen-60x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-170-cm-qualite-galerie",
            "it": "telaio-telato-60-x-170-cm-qualita-gallery"
          },
          "productId": "7999194071325",
          "family": "gallery",
          "variantIds": [
            "43728035741981"
          ],
          "available": true,
          "variantId": "43728035741981"
        },
        {
          "handle": "keilrahmen-60x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x170-cm-4cm",
            "en": "canvas-frame-60x170-cm-4cm",
            "fr": "chassis-60x170-cm-4cm",
            "it": "telaio-60x170-cm-4cm"
          },
          "productId": "7999386681629",
          "family": "bars",
          "variantIds": [
            "43944854126877"
          ],
          "available": true,
          "variantId": "43944854126877"
        }
      ],
      "60x180": [
        {
          "handle": "bespannter-keilrahmen-60x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-180-cm-qualite-galerie",
            "it": "telaio-telato-60-x-180-cm-qualita-gallery"
          },
          "productId": "7999194726685",
          "family": "gallery",
          "variantIds": [
            "43728037511453"
          ],
          "available": true,
          "variantId": "43728037511453"
        },
        {
          "handle": "keilrahmen-60x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x180-cm-4cm",
            "en": "canvas-frame-60x180-cm-4cm",
            "fr": "chassis-60x180-cm-4cm",
            "it": "telaio-60x180-cm-4cm"
          },
          "productId": "7999387173149",
          "family": "bars",
          "variantIds": [
            "43944854716701"
          ],
          "available": true,
          "variantId": "43944854716701"
        }
      ],
      "60x195": [
        {
          "handle": "bespannter-keilrahmen-60x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-60x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-60-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-60-x-195-cm-qualite-galerie",
            "it": "telaio-telato-60-x-195-cm-qualita-gallery"
          },
          "productId": "7999195316509",
          "family": "gallery",
          "variantIds": [
            "43728038265117"
          ],
          "available": true,
          "variantId": "43728038265117"
        },
        {
          "handle": "keilrahmen-60x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-60x195-cm-4cm",
            "en": "canvas-frame-60x195-cm-4cm",
            "fr": "chassis-60x195-cm-4cm",
            "it": "telaio-60x195-cm-4cm"
          },
          "productId": "7999387533597",
          "family": "bars",
          "variantIds": [
            "43944855077149"
          ],
          "available": true,
          "variantId": "43944855077149"
        }
      ],
      "70x70": [
        {
          "handle": "schattenfugen-rahmen-set-70x70-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-70x70-cm-roh",
            "en": "floating-frame-set-70x70-cm-unfinished",
            "fr": "kit-de-caisse-americaine-70x70-cm-brut",
            "it": "set-cornice-a-cassetta-70x70-cm-grezzo"
          },
          "productId": "7999078760733",
          "family": "shadow",
          "variantIds": [
            "43727809904925"
          ],
          "available": true,
          "variantId": "43727809904925"
        },
        {
          "handle": "bespannter-keilrahmen-70x70-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x70-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-70-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-70-cm-qualite-galerie",
            "it": "telaio-telato-70-x-70-cm-qualita-gallery"
          },
          "productId": "7999195775261",
          "family": "gallery",
          "variantIds": [
            "43728038986013"
          ],
          "available": true,
          "variantId": "43728038986013"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "50388583940381"
          ],
          "available": true,
          "variantId": "50388583940381"
        },
        {
          "handle": "keilrahmen-70x70-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x70-cm-4cm",
            "en": "canvas-frame-70x70-cm-4cm",
            "fr": "chassis-70x70-cm-4cm",
            "it": "telaio-70x70-cm-4cm"
          },
          "productId": "7999388025117",
          "family": "bars",
          "variantIds": [
            "43944855568669"
          ],
          "available": true,
          "variantId": "43944855568669"
        }
      ],
      "70x80": [
        {
          "handle": "schattenfugen-rahmen-set-70x80-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-70x80-cm-roh",
            "en": "floating-frame-set-70x80-cm-unfinished",
            "fr": "kit-de-caisse-americaine-70x80-cm-brut",
            "it": "set-cornice-a-cassetta-70x80-cm-grezzo"
          },
          "productId": "7999079678237",
          "family": "shadow",
          "variantIds": [
            "43727811641629"
          ],
          "available": true,
          "variantId": "43727811641629"
        },
        {
          "handle": "bespannter-keilrahmen-70x80-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x80-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-80-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-80-cm-qualite-galerie",
            "it": "telaio-telato-70-x-80-cm-qualita-gallery"
          },
          "productId": "7999196397853",
          "family": "gallery",
          "variantIds": [
            "43728040263965"
          ],
          "available": true,
          "variantId": "43728040263965"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305042205"
          ],
          "available": true,
          "variantId": "49195305042205"
        },
        {
          "handle": "keilrahmen-70x80-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x80-cm-4cm",
            "en": "canvas-frame-70x80-cm-4cm",
            "fr": "chassis-70x80-cm-4cm",
            "it": "telaio-70x80-cm-4cm"
          },
          "productId": "7999388483869",
          "family": "bars",
          "variantIds": [
            "43944856027421"
          ],
          "available": true,
          "variantId": "43944856027421"
        }
      ],
      "70x90": [
        {
          "handle": "schattenfugen-rahmen-set-70x90-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-70x90-cm-roh",
            "en": "floating-frame-set-70x90-cm-unfinished",
            "fr": "kit-de-caisse-americaine-70x90-cm-brut",
            "it": "set-cornice-a-cassetta-70x90-cm-grezzo"
          },
          "productId": "7999080694045",
          "family": "shadow",
          "variantIds": [
            "43727813148957"
          ],
          "available": true,
          "variantId": "43727813148957"
        },
        {
          "handle": "bespannter-keilrahmen-70x90-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x90-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-90-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-90-cm-qualite-galerie",
            "it": "telaio-telato-70-x-90-cm-qualita-gallery"
          },
          "productId": "7999196823837",
          "family": "gallery",
          "variantIds": [
            "43728040689949"
          ],
          "available": true,
          "variantId": "43728040689949"
        },
        {
          "handle": "keilrahmen-70x90-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x90-cm-4cm",
            "en": "canvas-frame-70x90-cm-4cm",
            "fr": "chassis-70x90-cm-4cm",
            "it": "telaio-70x90-cm-4cm"
          },
          "productId": "7999388975389",
          "family": "bars",
          "variantIds": [
            "43944856584477"
          ],
          "available": true,
          "variantId": "43944856584477"
        }
      ],
      "70x100": [
        {
          "handle": "schattenfugen-rahmen-set-70x100-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-70x100-cm-roh",
            "en": "floating-frame-set-70x100-cm-unfinished",
            "fr": "kit-de-caisse-americaine-70x100-cm-brut",
            "it": "set-cornice-a-cassetta-70x100-cm-grezzo"
          },
          "productId": "7999081447709",
          "family": "shadow",
          "variantIds": [
            "43727814099229"
          ],
          "available": true,
          "variantId": "43727814099229"
        },
        {
          "handle": "bespannter-keilrahmen-70x100-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x100-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-100-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-100-cm-qualite-galerie",
            "it": "telaio-telato-70-x-100-cm-qualita-gallery"
          },
          "productId": "7999197544733",
          "family": "gallery",
          "variantIds": [
            "43728041836829"
          ],
          "available": true,
          "variantId": "43728041836829"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49727469060381"
          ],
          "available": true,
          "variantId": "49727469060381"
        },
        {
          "handle": "keilrahmen-70x100-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x100-cm-4cm",
            "en": "canvas-frame-70x100-cm-4cm",
            "fr": "chassis-70x100-cm-4cm",
            "it": "telaio-70x100-cm-4cm"
          },
          "productId": "7999389466909",
          "family": "bars",
          "variantIds": [
            "43944858616093"
          ],
          "available": true,
          "variantId": "43944858616093"
        }
      ],
      "70x110": [
        {
          "handle": "bespannter-keilrahmen-70x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-110-cm-qualite-galerie",
            "it": "telaio-telato-70-x-110-cm-qualita-gallery"
          },
          "productId": "7999198200093",
          "family": "gallery",
          "variantIds": [
            "43728043573533"
          ],
          "available": true,
          "variantId": "43728043573533"
        },
        {
          "handle": "keilrahmen-70x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x110-cm-4cm",
            "en": "canvas-frame-70x110-cm-4cm",
            "fr": "chassis-70x110-cm-4cm",
            "it": "telaio-70x110-cm-4cm"
          },
          "productId": "7999389925661",
          "family": "bars",
          "variantIds": [
            "43944859074845"
          ],
          "available": true,
          "variantId": "43944859074845"
        }
      ],
      "70x120": [
        {
          "handle": "schattenfugen-rahmen-set-70x120-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-70x120-cm-roh",
            "en": "floating-frame-set-70x120-cm-unfinished",
            "fr": "kit-de-caisse-americaine-70x120-cm-brut",
            "it": "set-cornice-a-cassetta-70x120-cm-grezzo"
          },
          "productId": "7999082397981",
          "family": "shadow",
          "variantIds": [
            "43727815049501"
          ],
          "available": true,
          "variantId": "43727815049501"
        },
        {
          "handle": "bespannter-keilrahmen-70x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-120-cm-qualite-galerie",
            "it": "telaio-telato-70-x-120-cm-qualita-gallery"
          },
          "productId": "7999198920989",
          "family": "gallery",
          "variantIds": [
            "43728048685341"
          ],
          "available": true,
          "variantId": "43728048685341"
        },
        {
          "handle": "keilrahmen-70x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x120-cm-4cm",
            "en": "canvas-frame-70x120-cm-4cm",
            "fr": "chassis-70x120-cm-4cm",
            "it": "telaio-70x120-cm-4cm"
          },
          "productId": "7999390449949",
          "family": "bars",
          "variantIds": [
            "43944859664669"
          ],
          "available": true,
          "variantId": "43944859664669"
        }
      ],
      "70x130": [
        {
          "handle": "bespannter-keilrahmen-70x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-130-cm-qualite-galerie",
            "it": "telaio-telato-70-x-130-cm-qualita-gallery"
          },
          "productId": "7999199641885",
          "family": "gallery",
          "variantIds": [
            "43728050454813"
          ],
          "available": true,
          "variantId": "43728050454813"
        },
        {
          "handle": "keilrahmen-70x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x130-cm-4cm",
            "en": "canvas-frame-70x130-cm-4cm",
            "fr": "chassis-70x130-cm-4cm",
            "it": "telaio-70x130-cm-4cm"
          },
          "productId": "7999390908701",
          "family": "bars",
          "variantIds": [
            "43944860156189"
          ],
          "available": true,
          "variantId": "43944860156189"
        }
      ],
      "70x140": [
        {
          "handle": "schattenfugen-rahmen-set-70x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-70x140-cm-roh",
            "en": "floating-frame-set-70x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-70x140-cm-brut",
            "it": "set-cornice-a-cassetta-70x140-cm-grezzo"
          },
          "productId": "7999083348253",
          "family": "shadow",
          "variantIds": [
            "43727816163613"
          ],
          "available": false,
          "variantId": "43727816163613"
        },
        {
          "handle": "bespannter-keilrahmen-70x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-140-cm-qualite-galerie",
            "it": "telaio-telato-70-x-140-cm-qualita-gallery"
          },
          "productId": "7999200395549",
          "family": "gallery",
          "variantIds": [
            "43728052060445"
          ],
          "available": true,
          "variantId": "43728052060445"
        },
        {
          "handle": "keilrahmen-70x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x140-cm-4cm",
            "en": "canvas-frame-70x140-cm-4cm",
            "fr": "chassis-70x140-cm-4cm",
            "it": "telaio-70x140-cm-4cm"
          },
          "productId": "7999391334685",
          "family": "bars",
          "variantIds": [
            "43944860713245"
          ],
          "available": true,
          "variantId": "43944860713245"
        }
      ],
      "70x150": [
        {
          "handle": "bespannter-keilrahmen-70x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-150-cm-qualite-galerie",
            "it": "telaio-telato-70-x-150-cm-qualita-gallery"
          },
          "productId": "7999201083677",
          "family": "gallery",
          "variantIds": [
            "43728054714653"
          ],
          "available": true,
          "variantId": "43728054714653"
        },
        {
          "handle": "keilrahmen-70x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x150-cm-4cm",
            "en": "canvas-frame-70x150-cm-4cm",
            "fr": "chassis-70x150-cm-4cm",
            "it": "telaio-70x150-cm-4cm"
          },
          "productId": "7999391760669",
          "family": "bars",
          "variantIds": [
            "43944861139229"
          ],
          "available": true,
          "variantId": "43944861139229"
        }
      ],
      "70x160": [
        {
          "handle": "bespannter-keilrahmen-70x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-160-cm-qualite-galerie",
            "it": "telaio-telato-70-x-160-cm-qualita-gallery"
          },
          "productId": "7999201706269",
          "family": "gallery",
          "variantIds": [
            "43728056353053"
          ],
          "available": true,
          "variantId": "43728056353053"
        },
        {
          "handle": "keilrahmen-70x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x160-cm-4cm",
            "en": "canvas-frame-70x160-cm-4cm",
            "fr": "chassis-70x160-cm-4cm",
            "it": "telaio-70x160-cm-4cm"
          },
          "productId": "7999392186653",
          "family": "bars",
          "variantIds": [
            "43944861597981"
          ],
          "available": true,
          "variantId": "43944861597981"
        }
      ],
      "70x170": [
        {
          "handle": "bespannter-keilrahmen-70x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-170-cm-qualite-galerie",
            "it": "telaio-telato-70-x-170-cm-qualita-gallery"
          },
          "productId": "7999202394397",
          "family": "gallery",
          "variantIds": [
            "43728058679581"
          ],
          "available": true,
          "variantId": "43728058679581"
        },
        {
          "handle": "keilrahmen-70x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x170-cm-4cm",
            "en": "canvas-frame-70x170-cm-4cm",
            "fr": "chassis-70x170-cm-4cm",
            "it": "telaio-70x170-cm-4cm"
          },
          "productId": "7999392743709",
          "family": "bars",
          "variantIds": [
            "43944862155037"
          ],
          "available": true,
          "variantId": "43944862155037"
        }
      ],
      "70x180": [
        {
          "handle": "bespannter-keilrahmen-70x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-180-cm-qualite-galerie",
            "it": "telaio-telato-70-x-180-cm-qualita-gallery"
          },
          "productId": "7999203180829",
          "family": "gallery",
          "variantIds": [
            "43728060547357"
          ],
          "available": true,
          "variantId": "43728060547357"
        },
        {
          "handle": "keilrahmen-70x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x180-cm-4cm",
            "en": "canvas-frame-70x180-cm-4cm",
            "fr": "chassis-70x180-cm-4cm",
            "it": "telaio-70x180-cm-4cm"
          },
          "productId": "7999393333533",
          "family": "bars",
          "variantIds": [
            "43944862941469"
          ],
          "available": true,
          "variantId": "43944862941469"
        }
      ],
      "70x195": [
        {
          "handle": "bespannter-keilrahmen-70x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-70x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-70-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-70-x-195-cm-qualite-galerie",
            "it": "telaio-telato-70-x-195-cm-qualita-gallery"
          },
          "productId": "7999203868957",
          "family": "gallery",
          "variantIds": [
            "43728061858077"
          ],
          "available": true,
          "variantId": "43728061858077"
        },
        {
          "handle": "keilrahmen-70x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-70x195-cm-4cm",
            "en": "canvas-frame-70x195-cm-4cm",
            "fr": "chassis-70x195-cm-4cm",
            "it": "telaio-70x195-cm-4cm"
          },
          "productId": "7999393857821",
          "family": "bars",
          "variantIds": [
            "43944864219421"
          ],
          "available": true,
          "variantId": "43944864219421"
        }
      ],
      "80x80": [
        {
          "handle": "schattenfugen-rahmen-set-80x80-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-80x80-cm-roh",
            "en": "floating-frame-set-80x80-cm-unfinished",
            "fr": "kit-de-caisse-americaine-80x80-cm-brut",
            "it": "set-cornice-a-cassetta-80x80-cm-grezzo"
          },
          "productId": "7999084331293",
          "family": "shadow",
          "variantIds": [
            "43727817277725"
          ],
          "available": true,
          "variantId": "43727817277725"
        },
        {
          "handle": "bespannter-keilrahmen-80x80-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x80-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-80-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-80-cm-qualite-galerie",
            "it": "telaio-telato-80-x-80-cm-qualita-gallery"
          },
          "productId": "7999204557085",
          "family": "gallery",
          "variantIds": [
            "43728064807197"
          ],
          "available": true,
          "variantId": "43728064807197"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305533725"
          ],
          "available": true,
          "variantId": "49195305533725"
        },
        {
          "handle": "keilrahmen-80x80-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x80-cm-4cm",
            "en": "canvas-frame-80x80-cm-4cm",
            "fr": "chassis-80x80-cm-4cm",
            "it": "telaio-80x80-cm-4cm"
          },
          "productId": "7999394382109",
          "family": "bars",
          "variantIds": [
            "43944864743709"
          ],
          "available": true,
          "variantId": "43944864743709"
        }
      ],
      "80x90": [
        {
          "handle": "schattenfugen-rahmen-set-80x90-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-80x90-cm-roh",
            "en": "floating-frame-set-80x90-cm-unfinished",
            "fr": "kit-de-caisse-americaine-80x90-cm-brut",
            "it": "set-cornice-a-cassetta-80x90-cm-grezzo"
          },
          "productId": "7999085412637",
          "family": "shadow",
          "variantIds": [
            "43727820685597"
          ],
          "available": true,
          "variantId": "43727820685597"
        },
        {
          "handle": "bespannter-keilrahmen-80x90-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x90-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-90-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-90-cm-qualite-galerie",
            "it": "telaio-telato-80-x-90-cm-qualita-gallery"
          },
          "productId": "7999205376285",
          "family": "gallery",
          "variantIds": [
            "43728066642205"
          ],
          "available": true,
          "variantId": "43728066642205"
        },
        {
          "handle": "keilrahmen-80x90-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x90-cm-4cm",
            "en": "canvas-frame-80x90-cm-4cm",
            "fr": "chassis-80x90-cm-4cm",
            "it": "telaio-80x90-cm-4cm"
          },
          "productId": "7999394840861",
          "family": "bars",
          "variantIds": [
            "43944865267997"
          ],
          "available": true,
          "variantId": "43944865267997"
        }
      ],
      "80x100": [
        {
          "handle": "schattenfugen-rahmen-set-80x100-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-80x100-cm-roh",
            "en": "floating-frame-set-80x100-cm-unfinished",
            "fr": "kit-de-caisse-americaine-80x100-cm-brut",
            "it": "set-cornice-a-cassetta-80x100-cm-grezzo"
          },
          "productId": "7999086592285",
          "family": "shadow",
          "variantIds": [
            "43727824552221"
          ],
          "available": true,
          "variantId": "43727824552221"
        },
        {
          "handle": "bespannter-keilrahmen-80x100-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x100-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-100-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-100-cm-qualite-galerie",
            "it": "telaio-telato-80-x-100-cm-qualita-gallery"
          },
          "productId": "7999206195485",
          "family": "gallery",
          "variantIds": [
            "43728069853469"
          ],
          "available": true,
          "variantId": "43728069853469"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49725398286621"
          ],
          "available": false,
          "variantId": "49725398286621"
        },
        {
          "handle": "keilrahmen-80x100-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x100-cm-4cm",
            "en": "canvas-frame-80x100-cm-4cm",
            "fr": "chassis-80x100-cm-4cm",
            "it": "telaio-80x100-cm-4cm"
          },
          "productId": "7999395430685",
          "family": "bars",
          "variantIds": [
            "43944867135773"
          ],
          "available": true,
          "variantId": "43944867135773"
        }
      ],
      "80x110": [
        {
          "handle": "bespannter-keilrahmen-80x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-110-cm-qualite-galerie",
            "it": "telaio-telato-80-x-110-cm-qualita-gallery"
          },
          "productId": "7999206883613",
          "family": "gallery",
          "variantIds": [
            "43728071622941"
          ],
          "available": true,
          "variantId": "43728071622941"
        },
        {
          "handle": "keilrahmen-80x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x110-cm-4cm",
            "en": "canvas-frame-80x110-cm-4cm",
            "fr": "chassis-80x110-cm-4cm",
            "it": "telaio-80x110-cm-4cm"
          },
          "productId": "7999396020509",
          "family": "bars",
          "variantIds": [
            "43944867725597"
          ],
          "available": true,
          "variantId": "43944867725597"
        }
      ],
      "80x120": [
        {
          "handle": "schattenfugen-rahmen-set-80x120-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-80x120-cm-roh",
            "en": "floating-frame-set-80x120-cm-unfinished",
            "fr": "kit-de-caisse-americaine-80x120-cm-brut",
            "it": "set-cornice-a-cassetta-80x120-cm-grezzo"
          },
          "productId": "7999087313181",
          "family": "shadow",
          "variantIds": [
            "43727826649373"
          ],
          "available": true,
          "variantId": "43727826649373"
        },
        {
          "handle": "bespannter-keilrahmen-80x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-120-cm-qualite-galerie",
            "it": "telaio-telato-80-x-120-cm-qualita-gallery"
          },
          "productId": "7999207506205",
          "family": "gallery",
          "variantIds": [
            "43728073621789"
          ],
          "available": true,
          "variantId": "43728073621789"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49727497077021"
          ],
          "available": true,
          "variantId": "49727497077021"
        },
        {
          "handle": "keilrahmen-80x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x120-cm-4cm",
            "en": "canvas-frame-80x120-cm-4cm",
            "fr": "chassis-80x120-cm-4cm",
            "it": "telaio-80x120-cm-4cm"
          },
          "productId": "7999396544797",
          "family": "bars",
          "variantIds": [
            "43944870805789"
          ],
          "available": true,
          "variantId": "43944870805789"
        }
      ],
      "80x130": [
        {
          "handle": "bespannter-keilrahmen-80x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-130-cm-qualite-galerie",
            "it": "telaio-telato-80-x-130-cm-qualita-gallery"
          },
          "productId": "7999208325405",
          "family": "gallery",
          "variantIds": [
            "43728075915549"
          ],
          "available": true,
          "variantId": "43728075915549"
        },
        {
          "handle": "keilrahmen-80x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x130-cm-4cm",
            "en": "canvas-frame-80x130-cm-4cm",
            "fr": "chassis-80x130-cm-4cm",
            "it": "telaio-80x130-cm-4cm"
          },
          "productId": "7999397069085",
          "family": "bars",
          "variantIds": [
            "43944871330077"
          ],
          "available": true,
          "variantId": "43944871330077"
        }
      ],
      "80x140": [
        {
          "handle": "schattenfugen-rahmen-set-80x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-80x140-cm-roh",
            "en": "floating-frame-set-80x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-80x140-cm-brut",
            "it": "set-cornice-a-cassetta-80x140-cm-grezzo"
          },
          "productId": "7999088034077",
          "family": "shadow",
          "variantIds": [
            "43727828877597"
          ],
          "available": false,
          "variantId": "43727828877597"
        },
        {
          "handle": "bespannter-keilrahmen-80x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-140-cm-qualite-galerie",
            "it": "telaio-telato-80-x-140-cm-qualita-gallery"
          },
          "productId": "7999209177373",
          "family": "gallery",
          "variantIds": [
            "43728077750557"
          ],
          "available": true,
          "variantId": "43728077750557"
        },
        {
          "handle": "keilrahmen-80x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x140-cm-4cm",
            "en": "canvas-frame-80x140-cm-4cm",
            "fr": "chassis-80x140-cm-4cm",
            "it": "telaio-80x140-cm-4cm"
          },
          "productId": "7999397724445",
          "family": "bars",
          "variantIds": [
            "43944873787677"
          ],
          "available": true,
          "variantId": "43944873787677"
        }
      ],
      "80x150": [
        {
          "handle": "bespannter-keilrahmen-80x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-150-cm-qualite-galerie",
            "it": "telaio-telato-80-x-150-cm-qualita-gallery"
          },
          "productId": "7999209832733",
          "family": "gallery",
          "variantIds": [
            "43728078635293"
          ],
          "available": true,
          "variantId": "43728078635293"
        },
        {
          "handle": "keilrahmen-80x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x150-cm-4cm",
            "en": "canvas-frame-80x150-cm-4cm",
            "fr": "chassis-80x150-cm-4cm",
            "it": "telaio-80x150-cm-4cm"
          },
          "productId": "7999398019357",
          "family": "bars",
          "variantIds": [
            "43944874049821"
          ],
          "available": true,
          "variantId": "43944874049821"
        }
      ],
      "80x160": [
        {
          "handle": "bespannter-keilrahmen-80x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-160-cm-qualite-galerie",
            "it": "telaio-telato-80-x-160-cm-qualita-gallery"
          },
          "productId": "7999210324253",
          "family": "gallery",
          "variantIds": [
            "43728079257885"
          ],
          "available": true,
          "variantId": "43728079257885"
        },
        {
          "handle": "keilrahmen-80x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x160-cm-4cm",
            "en": "canvas-frame-80x160-cm-4cm",
            "fr": "chassis-80x160-cm-4cm",
            "it": "telaio-80x160-cm-4cm"
          },
          "productId": "7999398379805",
          "family": "bars",
          "variantIds": [
            "43944874443037"
          ],
          "available": true,
          "variantId": "43944874443037"
        }
      ],
      "80x170": [
        {
          "handle": "bespannter-keilrahmen-80x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-170-cm-qualite-galerie",
            "it": "telaio-telato-80-x-170-cm-qualita-gallery"
          },
          "productId": "7999210914077",
          "family": "gallery",
          "variantIds": [
            "43728080503069"
          ],
          "available": true,
          "variantId": "43728080503069"
        },
        {
          "handle": "keilrahmen-80x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x170-cm-4cm",
            "en": "canvas-frame-80x170-cm-4cm",
            "fr": "chassis-80x170-cm-4cm",
            "it": "telaio-80x170-cm-4cm"
          },
          "productId": "7999398707485",
          "family": "bars",
          "variantIds": [
            "43944875163933"
          ],
          "available": true,
          "variantId": "43944875163933"
        }
      ],
      "80x180": [
        {
          "handle": "bespannter-keilrahmen-80x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-180-cm-qualite-galerie",
            "it": "telaio-telato-80-x-180-cm-qualita-gallery"
          },
          "productId": "7999211667741",
          "family": "gallery",
          "variantIds": [
            "43728083091741"
          ],
          "available": true,
          "variantId": "43728083091741"
        },
        {
          "handle": "keilrahmen-80x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x180-cm-4cm",
            "en": "canvas-frame-80x180-cm-4cm",
            "fr": "chassis-80x180-cm-4cm",
            "it": "telaio-80x180-cm-4cm"
          },
          "productId": "7999399395613",
          "family": "bars",
          "variantIds": [
            "43944879194397"
          ],
          "available": true,
          "variantId": "43944879194397"
        }
      ],
      "80x195": [
        {
          "handle": "bespannter-keilrahmen-80x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-80x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-80-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-80-x-195-cm-qualite-galerie",
            "it": "telaio-telato-80-x-195-cm-qualita-gallery"
          },
          "productId": "7999212257565",
          "family": "gallery",
          "variantIds": [
            "43728083976477"
          ],
          "available": true,
          "variantId": "43728083976477"
        },
        {
          "handle": "keilrahmen-80x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-80x195-cm-4cm",
            "en": "canvas-frame-80x195-cm-4cm",
            "fr": "chassis-80x195-cm-4cm",
            "it": "telaio-80x195-cm-4cm"
          },
          "productId": "7999400050973",
          "family": "bars",
          "variantIds": [
            "43944881127709"
          ],
          "available": true,
          "variantId": "43944881127709"
        }
      ],
      "90x90": [
        {
          "handle": "schattenfugen-rahmen-set-90x90-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-90x90-cm-roh",
            "en": "floating-frame-set-90x90-cm-unfinished",
            "fr": "kit-de-caisse-americaine-90x90-cm-brut",
            "it": "set-cornice-a-cassetta-90x90-cm-grezzo"
          },
          "productId": "7999088689437",
          "family": "shadow",
          "variantIds": [
            "43727831859485"
          ],
          "available": true,
          "variantId": "43727831859485"
        },
        {
          "handle": "bespannter-keilrahmen-90x90-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x90-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-90-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-90-cm-qualite-galerie",
            "it": "telaio-telato-90-x-90-cm-qualita-gallery"
          },
          "productId": "7999212683549",
          "family": "gallery",
          "variantIds": [
            "43728084599069"
          ],
          "available": true,
          "variantId": "43728084599069"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "51801724616989"
          ],
          "available": false,
          "variantId": "51801724616989"
        },
        {
          "handle": "keilrahmen-90x90-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x90-cm-4cm",
            "en": "canvas-frame-90x90-cm-4cm",
            "fr": "chassis-90x90-cm-4cm",
            "it": "telaio-90x90-cm-4cm"
          },
          "productId": "7999400476957",
          "family": "bars",
          "variantIds": [
            "43944882274589"
          ],
          "available": true,
          "variantId": "43944882274589"
        }
      ],
      "90x100": [
        {
          "handle": "schattenfugen-rahmen-set-90x100-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-90x100-cm-roh",
            "en": "floating-frame-set-90x100-cm-unfinished",
            "fr": "kit-de-caisse-americaine-90x100-cm-brut",
            "it": "set-cornice-a-cassetta-90x100-cm-grezzo"
          },
          "productId": "7999089344797",
          "family": "shadow",
          "variantIds": [
            "43727836381469"
          ],
          "available": true,
          "variantId": "43727836381469"
        },
        {
          "handle": "bespannter-keilrahmen-90x100-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x100-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-100-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-100-cm-qualite-galerie",
            "it": "telaio-telato-90-x-100-cm-qualita-gallery"
          },
          "productId": "7999213207837",
          "family": "gallery",
          "variantIds": [
            "43728086204701"
          ],
          "available": true,
          "variantId": "43728086204701"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49727449202973"
          ],
          "available": true,
          "variantId": "49727449202973"
        },
        {
          "handle": "keilrahmen-90x100-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x100-cm-4cm",
            "en": "canvas-frame-90x100-cm-4cm",
            "fr": "chassis-90x100-cm-4cm",
            "it": "telaio-90x100-cm-4cm"
          },
          "productId": "7999400968477",
          "family": "bars",
          "variantIds": [
            "43944882864413"
          ],
          "available": true,
          "variantId": "43944882864413"
        }
      ],
      "90x110": [
        {
          "handle": "bespannter-keilrahmen-90x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-110-cm-qualite-galerie",
            "it": "telaio-telato-90-x-110-cm-qualita-gallery"
          },
          "productId": "7999214027037",
          "family": "gallery",
          "variantIds": [
            "43728088269085"
          ],
          "available": true,
          "variantId": "43728088269085"
        },
        {
          "handle": "keilrahmen-90x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x110-cm-4cm",
            "en": "canvas-frame-90x110-cm-4cm",
            "fr": "chassis-90x110-cm-4cm",
            "it": "telaio-90x110-cm-4cm"
          },
          "productId": "7999401492765",
          "family": "bars",
          "variantIds": [
            "43944884764957"
          ],
          "available": true,
          "variantId": "43944884764957"
        }
      ],
      "90x120": [
        {
          "handle": "schattenfugen-rahmen-set-90x120-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-90x120-cm-roh",
            "en": "floating-frame-set-90x120-cm-unfinished",
            "fr": "kit-de-caisse-americaine-90x120-cm-brut",
            "it": "set-cornice-a-cassetta-90x120-cm-grezzo"
          },
          "productId": "7999090098461",
          "family": "shadow",
          "variantIds": [
            "43727841296669"
          ],
          "available": true,
          "variantId": "43727841296669"
        },
        {
          "handle": "bespannter-keilrahmen-90x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-120-cm-qualite-galerie",
            "it": "telaio-telato-90-x-120-cm-qualita-gallery"
          },
          "productId": "7999214780701",
          "family": "gallery",
          "variantIds": [
            "43728090399005"
          ],
          "available": true,
          "variantId": "43728090399005"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305599261"
          ],
          "available": true,
          "variantId": "49195305599261"
        },
        {
          "handle": "keilrahmen-90x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x120-cm-4cm",
            "en": "canvas-frame-90x120-cm-4cm",
            "fr": "chassis-90x120-cm-4cm",
            "it": "telaio-90x120-cm-4cm"
          },
          "productId": "7999402082589",
          "family": "bars",
          "variantIds": [
            "43944885747997"
          ],
          "available": true,
          "variantId": "43944885747997"
        }
      ],
      "90x130": [
        {
          "handle": "bespannter-keilrahmen-90x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-130-cm-qualite-galerie",
            "it": "telaio-telato-90-x-130-cm-qualita-gallery"
          },
          "productId": "7999215534365",
          "family": "gallery",
          "variantIds": [
            "43728093446429"
          ],
          "available": true,
          "variantId": "43728093446429"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "50388585251101"
          ],
          "available": true,
          "variantId": "50388585251101"
        },
        {
          "handle": "keilrahmen-90x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x130-cm-4cm",
            "en": "canvas-frame-90x130-cm-4cm",
            "fr": "chassis-90x130-cm-4cm",
            "it": "telaio-90x130-cm-4cm"
          },
          "productId": "7999402475805",
          "family": "bars",
          "variantIds": [
            "43944887058717"
          ],
          "available": true,
          "variantId": "43944887058717"
        }
      ],
      "90x140": [
        {
          "handle": "schattenfugen-rahmen-set-90x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-90x140-cm-roh",
            "en": "floating-frame-set-90x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-90x140-cm-brut",
            "it": "set-cornice-a-cassetta-90x140-cm-grezzo"
          },
          "productId": "7999090786589",
          "family": "shadow",
          "variantIds": [
            "43727842803997"
          ],
          "available": false,
          "variantId": "43727842803997"
        },
        {
          "handle": "bespannter-keilrahmen-90x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-140-cm-qualite-galerie",
            "it": "telaio-telato-90-x-140-cm-qualita-gallery"
          },
          "productId": "7999216189725",
          "family": "gallery",
          "variantIds": [
            "43728094658845"
          ],
          "available": true,
          "variantId": "43728094658845"
        },
        {
          "handle": "keilrahmen-90x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x140-cm-4cm",
            "en": "canvas-frame-90x140-cm-4cm",
            "fr": "chassis-90x140-cm-4cm",
            "it": "telaio-90x140-cm-4cm"
          },
          "productId": "7999402934557",
          "family": "bars",
          "variantIds": [
            "43944887714077"
          ],
          "available": true,
          "variantId": "43944887714077"
        }
      ],
      "90x150": [
        {
          "handle": "bespannter-keilrahmen-90x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-150-cm-qualite-galerie",
            "it": "telaio-telato-90-x-150-cm-qualita-gallery"
          },
          "productId": "7999216943389",
          "family": "gallery",
          "variantIds": [
            "43728100163869"
          ],
          "available": true,
          "variantId": "43728100163869"
        },
        {
          "handle": "keilrahmen-90x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x150-cm-4cm",
            "en": "canvas-frame-90x150-cm-4cm",
            "fr": "chassis-90x150-cm-4cm",
            "it": "telaio-90x150-cm-4cm"
          },
          "productId": "7999403491613",
          "family": "bars",
          "variantIds": [
            "43944888500509"
          ],
          "available": true,
          "variantId": "43944888500509"
        }
      ],
      "90x160": [
        {
          "handle": "bespannter-keilrahmen-90x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-160-cm-qualite-galerie",
            "it": "telaio-telato-90-x-160-cm-qualita-gallery"
          },
          "productId": "7999217467677",
          "family": "gallery",
          "variantIds": [
            "43728100983069"
          ],
          "available": true,
          "variantId": "43728100983069"
        },
        {
          "handle": "keilrahmen-90x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x160-cm-4cm",
            "en": "canvas-frame-90x160-cm-4cm",
            "fr": "chassis-90x160-cm-4cm",
            "it": "telaio-90x160-cm-4cm"
          },
          "productId": "7999403950365",
          "family": "bars",
          "variantIds": [
            "43944888959261"
          ],
          "available": true,
          "variantId": "43944888959261"
        }
      ],
      "90x170": [
        {
          "handle": "bespannter-keilrahmen-90x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-170-cm-qualite-galerie",
            "it": "telaio-telato-90-x-170-cm-qualita-gallery"
          },
          "productId": "7999218155805",
          "family": "gallery",
          "variantIds": [
            "43728101736733"
          ],
          "available": true,
          "variantId": "43728101736733"
        },
        {
          "handle": "keilrahmen-90x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x170-cm-4cm",
            "en": "canvas-frame-90x170-cm-4cm",
            "fr": "chassis-90x170-cm-4cm",
            "it": "telaio-90x170-cm-4cm"
          },
          "productId": "7999404376349",
          "family": "bars",
          "variantIds": [
            "43944889483549"
          ],
          "available": true,
          "variantId": "43944889483549"
        }
      ],
      "90x180": [
        {
          "handle": "bespannter-keilrahmen-90x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-180-cm-qualite-galerie",
            "it": "telaio-telato-90-x-180-cm-qualita-gallery"
          },
          "productId": "7999218712861",
          "family": "gallery",
          "variantIds": [
            "43728102359325"
          ],
          "available": true,
          "variantId": "43728102359325"
        },
        {
          "handle": "keilrahmen-90x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x180-cm-4cm",
            "en": "canvas-frame-90x180-cm-4cm",
            "fr": "chassis-90x180-cm-4cm",
            "it": "telaio-90x180-cm-4cm"
          },
          "productId": "7999404966173",
          "family": "bars",
          "variantIds": [
            "43944890302749"
          ],
          "available": true,
          "variantId": "43944890302749"
        }
      ],
      "90x195": [
        {
          "handle": "bespannter-keilrahmen-90x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-90x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-90-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-90-x-195-cm-qualite-galerie",
            "it": "telaio-telato-90-x-195-cm-qualita-gallery"
          },
          "productId": "7999219532061",
          "family": "gallery",
          "variantIds": [
            "43728103735581"
          ],
          "available": true,
          "variantId": "43728103735581"
        },
        {
          "handle": "keilrahmen-90x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-90x195-cm-4cm",
            "en": "canvas-frame-90x195-cm-4cm",
            "fr": "chassis-90x195-cm-4cm",
            "it": "telaio-90x195-cm-4cm"
          },
          "productId": "7999405621533",
          "family": "bars",
          "variantIds": [
            "43944891154717"
          ],
          "available": true,
          "variantId": "43944891154717"
        }
      ],
      "100x100": [
        {
          "handle": "schattenfugen-rahmen-set-100x100-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-100x100-cm-roh",
            "en": "floating-frame-set-100x100-cm-unfinished",
            "fr": "kit-de-caisse-americaine-100x100-cm-brut",
            "it": "set-cornice-a-cassetta-100x100-cm-grezzo"
          },
          "productId": "7999091278109",
          "family": "shadow",
          "variantIds": [
            "43727844507933"
          ],
          "available": true,
          "variantId": "43727844507933"
        },
        {
          "handle": "bespannter-keilrahmen-100x100-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-100x100-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-100-x-100-cm-gallery-quality",
            "fr": "chassis-entoile-100-x-100-cm-qualite-galerie",
            "it": "telaio-telato-100-x-100-cm-qualita-gallery"
          },
          "productId": "7999220187421",
          "family": "gallery",
          "variantIds": [
            "43728104554781"
          ],
          "available": true,
          "variantId": "43728104554781"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305664797"
          ],
          "available": false,
          "variantId": "49195305664797"
        },
        {
          "handle": "keilrahmen-100x100-cm-4cm",
          "handles": {
            "de": "keilrahmen-100x100-cm-4cm",
            "en": "canvas-frame-100x100-cm-4cm",
            "fr": "chassis-100x100-cm-4cm",
            "it": "telaio-100x100-cm-4cm"
          },
          "productId": "7999406113053",
          "family": "bars",
          "variantIds": [
            "43944891744541"
          ],
          "available": true,
          "variantId": "43944891744541"
        }
      ],
      "100x110": [
        {
          "handle": "bespannter-keilrahmen-100x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-100x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-100-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-100-x-110-cm-qualite-galerie",
            "it": "telaio-telato-100-x-110-cm-qualita-gallery"
          },
          "productId": "7999220810013",
          "family": "gallery",
          "variantIds": [
            "43728105439517"
          ],
          "available": true,
          "variantId": "43728105439517"
        },
        {
          "handle": "keilrahmen-100x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-100x110-cm-4cm",
            "en": "canvas-frame-100x110-cm-4cm",
            "fr": "chassis-100x110-cm-4cm",
            "it": "telaio-100x110-cm-4cm"
          },
          "productId": "7999406637341",
          "family": "bars",
          "variantIds": [
            "43944892563741"
          ],
          "available": true,
          "variantId": "43944892563741"
        }
      ],
      "100x120": [
        {
          "handle": "schattenfugen-rahmen-set-100x120-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-100x120-cm-roh",
            "en": "floating-frame-set-100x120-cm-unfinished",
            "fr": "kit-de-caisse-americaine-100x120-cm-brut",
            "it": "set-cornice-a-cassetta-100x120-cm-grezzo"
          },
          "productId": "7999091900701",
          "family": "shadow",
          "variantIds": [
            "43727846801693"
          ],
          "available": true,
          "variantId": "43727846801693"
        },
        {
          "handle": "bespannter-keilrahmen-100x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-100x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-100-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-100-x-120-cm-qualite-galerie",
            "it": "telaio-telato-100-x-120-cm-qualita-gallery"
          },
          "productId": "7999221072157",
          "family": "gallery",
          "variantIds": [
            "43728108159261"
          ],
          "available": true,
          "variantId": "43728108159261"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49195305730333"
          ],
          "available": true,
          "variantId": "49195305730333"
        },
        {
          "handle": "keilrahmen-100x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-100x120-cm-4cm",
            "en": "canvas-frame-100x120-cm-4cm",
            "fr": "chassis-100x120-cm-4cm",
            "it": "telaio-100x120-cm-4cm"
          },
          "productId": "7999407128861",
          "family": "bars",
          "variantIds": [
            "43944893055261"
          ],
          "available": true,
          "variantId": "43944893055261"
        }
      ],
      "100x130": [
        {
          "handle": "bespannter-keilrahmen-100x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-100x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-100-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-100-x-130-cm-qualite-galerie",
            "it": "telaio-telato-100-x-130-cm-qualita-gallery"
          },
          "productId": "7999221170461",
          "family": "gallery",
          "variantIds": [
            "43728108388637"
          ],
          "available": true,
          "variantId": "43728108388637"
        },
        {
          "handle": "keilrahmen-100x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-100x130-cm-4cm",
            "en": "canvas-frame-100x130-cm-4cm",
            "fr": "chassis-100x130-cm-4cm",
            "it": "telaio-100x130-cm-4cm"
          },
          "productId": "7999407718685",
          "family": "bars",
          "variantIds": [
            "43944894234909"
          ],
          "available": true,
          "variantId": "43944894234909"
        }
      ],
      "100x140": [
        {
          "handle": "schattenfugen-rahmen-set-100x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-100x140-cm-roh",
            "en": "floating-frame-set-100x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-100x140-cm-brut",
            "it": "set-cornice-a-cassetta-100x140-cm-grezzo"
          },
          "productId": "7999092523293",
          "family": "shadow",
          "variantIds": [
            "43727849095453"
          ],
          "available": false,
          "variantId": "43727849095453"
        },
        {
          "handle": "bespannter-keilrahmen-100x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-100x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-100-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-100-x-140-cm-qualite-galerie",
            "it": "telaio-telato-100-x-140-cm-qualita-gallery"
          },
          "productId": "7999221268765",
          "family": "gallery",
          "variantIds": [
            "43728108880157"
          ],
          "available": true,
          "variantId": "43728108880157"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "49424623763741",
            "49195305828637"
          ],
          "available": true
        },
        {
          "handle": "keilrahmen-100x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-100x140-cm-4cm",
            "en": "canvas-frame-100x140-cm-4cm",
            "fr": "chassis-100x140-cm-4cm",
            "it": "telaio-100x140-cm-4cm"
          },
          "productId": "7999408242973",
          "family": "bars",
          "variantIds": [
            "43944894890269"
          ],
          "available": true,
          "variantId": "43944894890269"
        }
      ],
      "100x150": [
        {
          "handle": "bespannter-keilrahmen-100x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-100x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-100-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-100-x-150-cm-qualite-galerie",
            "it": "telaio-telato-100-x-150-cm-qualita-gallery"
          },
          "productId": "7999221530909",
          "family": "gallery",
          "variantIds": [
            "43728109273373"
          ],
          "available": true,
          "variantId": "43728109273373"
        },
        {
          "handle": "keilrahmen-100x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-100x150-cm-4cm",
            "en": "canvas-frame-100x150-cm-4cm",
            "fr": "chassis-100x150-cm-4cm",
            "it": "telaio-100x150-cm-4cm"
          },
          "productId": "7999408963869",
          "family": "bars",
          "variantIds": [
            "43944899969309"
          ],
          "available": true,
          "variantId": "43944899969309"
        }
      ],
      "100x160": [
        {
          "handle": "bespannter-keilrahmen-100x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-100x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-100-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-100-x-160-cm-qualite-galerie",
            "it": "telaio-telato-100-x-160-cm-qualita-gallery"
          },
          "productId": "7999222087965",
          "family": "gallery",
          "variantIds": [
            "43728109928733"
          ],
          "available": true,
          "variantId": "43728109928733"
        },
        {
          "handle": "keilrahmen-100x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-100x160-cm-4cm",
            "en": "canvas-frame-100x160-cm-4cm",
            "fr": "chassis-100x160-cm-4cm",
            "it": "telaio-100x160-cm-4cm"
          },
          "productId": "7999409422621",
          "family": "bars",
          "variantIds": [
            "43944900559133"
          ],
          "available": true,
          "variantId": "43944900559133"
        }
      ],
      "100x170": [
        {
          "handle": "bespannter-keilrahmen-100x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-100x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-100-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-100-x-170-cm-qualite-galerie",
            "it": "telaio-telato-100-x-170-cm-qualita-gallery"
          },
          "productId": "7999222710557",
          "family": "gallery",
          "variantIds": [
            "43728110813469"
          ],
          "available": true,
          "variantId": "43728110813469"
        },
        {
          "handle": "keilrahmen-100x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-100x170-cm-4cm",
            "en": "canvas-frame-100x170-cm-4cm",
            "fr": "chassis-100x170-cm-4cm",
            "it": "telaio-100x170-cm-4cm"
          },
          "productId": "7999409848605",
          "family": "bars",
          "variantIds": [
            "43944901083421"
          ],
          "available": true,
          "variantId": "43944901083421"
        }
      ],
      "100x180": [
        {
          "handle": "bespannter-keilrahmen-100x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-100x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-100-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-100-x-180-cm-qualite-galerie",
            "it": "telaio-telato-100-x-180-cm-qualita-gallery"
          },
          "productId": "7999223202077",
          "family": "gallery",
          "variantIds": [
            "43728111436061"
          ],
          "available": true,
          "variantId": "43728111436061"
        },
        {
          "handle": "keilrahmen-100x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-100x180-cm-4cm",
            "en": "canvas-frame-100x180-cm-4cm",
            "fr": "chassis-100x180-cm-4cm",
            "it": "telaio-100x180-cm-4cm"
          },
          "productId": "7999410405661",
          "family": "bars",
          "variantIds": [
            "43944901640477"
          ],
          "available": true,
          "variantId": "43944901640477"
        }
      ],
      "100x195": [
        {
          "handle": "bespannter-keilrahmen-100x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-100x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-100-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-100-x-195-cm-qualite-galerie",
            "it": "telaio-telato-100-x-195-cm-qualita-gallery"
          },
          "productId": "7999223660829",
          "family": "gallery",
          "variantIds": [
            "43728111960349"
          ],
          "available": true,
          "variantId": "43728111960349"
        },
        {
          "handle": "keilrahmen-100x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-100x195-cm-4cm",
            "en": "canvas-frame-100x195-cm-4cm",
            "fr": "chassis-100x195-cm-4cm",
            "it": "telaio-100x195-cm-4cm"
          },
          "productId": "7999410864413",
          "family": "bars",
          "variantIds": [
            "43944902328605"
          ],
          "available": true,
          "variantId": "43944902328605"
        }
      ],
      "110x110": [
        {
          "handle": "bespannter-keilrahmen-110x110-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-110x110-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-110-x-110-cm-gallery-quality",
            "fr": "chassis-entoile-110-x-110-cm-qualite-galerie",
            "it": "telaio-telato-110-x-110-cm-qualita-gallery"
          },
          "productId": "7999224217885",
          "family": "gallery",
          "variantIds": [
            "43728112648477"
          ],
          "available": true,
          "variantId": "43728112648477"
        },
        {
          "handle": "keilrahmen-110x110-cm-4cm",
          "handles": {
            "de": "keilrahmen-110x110-cm-4cm",
            "en": "canvas-frame-110x110-cm-4cm",
            "fr": "chassis-110x110-cm-4cm",
            "it": "telaio-110x110-cm-4cm"
          },
          "productId": "7999411323165",
          "family": "bars",
          "variantIds": [
            "43944902787357"
          ],
          "available": true,
          "variantId": "43944902787357"
        }
      ],
      "110x120": [
        {
          "handle": "bespannter-keilrahmen-110x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-110x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-110-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-110-x-120-cm-qualite-galerie",
            "it": "telaio-telato-110-x-120-cm-qualita-gallery"
          },
          "productId": "7999224643869",
          "family": "gallery",
          "variantIds": [
            "43728113205533"
          ],
          "available": true,
          "variantId": "43728113205533"
        },
        {
          "handle": "keilrahmen-110x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-110x120-cm-4cm",
            "en": "canvas-frame-110x120-cm-4cm",
            "fr": "chassis-110x120-cm-4cm",
            "it": "telaio-110x120-cm-4cm"
          },
          "productId": "7999411912989",
          "family": "bars",
          "variantIds": [
            "43944903934237"
          ],
          "available": true,
          "variantId": "43944903934237"
        }
      ],
      "110x130": [
        {
          "handle": "bespannter-keilrahmen-110x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-110x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-110-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-110-x-130-cm-qualite-galerie",
            "it": "telaio-telato-110-x-130-cm-qualita-gallery"
          },
          "productId": "7999225069853",
          "family": "gallery",
          "variantIds": [
            "43728113762589"
          ],
          "available": true,
          "variantId": "43728113762589"
        },
        {
          "handle": "keilrahmen-110x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-110x130-cm-4cm",
            "en": "canvas-frame-110x130-cm-4cm",
            "fr": "chassis-110x130-cm-4cm",
            "it": "telaio-110x130-cm-4cm"
          },
          "productId": "7999412306205",
          "family": "bars",
          "variantIds": [
            "43944904327453"
          ],
          "available": true,
          "variantId": "43944904327453"
        }
      ],
      "110x140": [
        {
          "handle": "bespannter-keilrahmen-110x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-110x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-110-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-110-x-140-cm-qualite-galerie",
            "it": "telaio-telato-110-x-140-cm-qualita-gallery"
          },
          "productId": "7999225495837",
          "family": "gallery",
          "variantIds": [
            "43728114319645"
          ],
          "available": true,
          "variantId": "43728114319645"
        },
        {
          "handle": "keilrahmen-110x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-110x140-cm-4cm",
            "en": "canvas-frame-110x140-cm-4cm",
            "fr": "chassis-110x140-cm-4cm",
            "it": "telaio-110x140-cm-4cm"
          },
          "productId": "7999412764957",
          "family": "bars",
          "variantIds": [
            "43944905015581"
          ],
          "available": true,
          "variantId": "43944905015581"
        }
      ],
      "110x150": [
        {
          "handle": "bespannter-keilrahmen-110x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-110x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-110-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-110-x-150-cm-qualite-galerie",
            "it": "telaio-telato-110-x-150-cm-qualita-gallery"
          },
          "productId": "7999226020125",
          "family": "gallery",
          "variantIds": [
            "43728115892509"
          ],
          "available": true,
          "variantId": "43728115892509"
        },
        {
          "handle": "keilrahmen-110x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-110x150-cm-4cm",
            "en": "canvas-frame-110x150-cm-4cm",
            "fr": "chassis-110x150-cm-4cm",
            "it": "telaio-110x150-cm-4cm"
          },
          "productId": "7999413223709",
          "family": "bars",
          "variantIds": [
            "43944905474333"
          ],
          "available": true,
          "variantId": "43944905474333"
        }
      ],
      "110x160": [
        {
          "handle": "bespannter-keilrahmen-110x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-110x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-110-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-110-x-160-cm-qualite-galerie",
            "it": "telaio-telato-110-x-160-cm-qualita-gallery"
          },
          "productId": "7999226577181",
          "family": "gallery",
          "variantIds": [
            "43728116646173"
          ],
          "available": true,
          "variantId": "43728116646173"
        },
        {
          "handle": "keilrahmen-110x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-110x160-cm-4cm",
            "en": "canvas-frame-110x160-cm-4cm",
            "fr": "chassis-110x160-cm-4cm",
            "it": "telaio-110x160-cm-4cm"
          },
          "productId": "7999413879069",
          "family": "bars",
          "variantIds": [
            "43944906490141"
          ],
          "available": true,
          "variantId": "43944906490141"
        }
      ],
      "110x170": [
        {
          "handle": "bespannter-keilrahmen-110x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-110x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-110-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-110-x-170-cm-qualite-galerie",
            "it": "telaio-telato-110-x-170-cm-qualita-gallery"
          },
          "productId": "7999227134237",
          "family": "gallery",
          "variantIds": [
            "43728119267613"
          ],
          "available": true,
          "variantId": "43728119267613"
        },
        {
          "handle": "keilrahmen-110x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-110x170-cm-4cm",
            "en": "canvas-frame-110x170-cm-4cm",
            "fr": "chassis-110x170-cm-4cm",
            "it": "telaio-110x170-cm-4cm"
          },
          "productId": "7999414337821",
          "family": "bars",
          "variantIds": [
            "43944906948893"
          ],
          "available": true,
          "variantId": "43944906948893"
        }
      ],
      "110x180": [
        {
          "handle": "bespannter-keilrahmen-110x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-110x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-110-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-110-x-180-cm-qualite-galerie",
            "it": "telaio-telato-110-x-180-cm-qualita-gallery"
          },
          "productId": "7999227592989",
          "family": "gallery",
          "variantIds": [
            "43728120447261"
          ],
          "available": true,
          "variantId": "43728120447261"
        },
        {
          "handle": "keilrahmen-110x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-110x180-cm-4cm",
            "en": "canvas-frame-110x180-cm-4cm",
            "fr": "chassis-110x180-cm-4cm",
            "it": "telaio-110x180-cm-4cm"
          },
          "productId": "7999414796573",
          "family": "bars",
          "variantIds": [
            "43944907637021"
          ],
          "available": true,
          "variantId": "43944907637021"
        }
      ],
      "110x195": [
        {
          "handle": "bespannter-keilrahmen-110x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-110x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-110-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-110-x-195-cm-qualite-galerie",
            "it": "telaio-telato-110-x-195-cm-qualita-gallery"
          },
          "productId": "7999228182813",
          "family": "gallery",
          "variantIds": [
            "43728122806557"
          ],
          "available": true,
          "variantId": "43728122806557"
        },
        {
          "handle": "keilrahmen-110x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-110x195-cm-4cm",
            "en": "canvas-frame-110x195-cm-4cm",
            "fr": "chassis-110x195-cm-4cm",
            "it": "telaio-110x195-cm-4cm"
          },
          "productId": "7999415288093",
          "family": "bars",
          "variantIds": [
            "43944908390685"
          ],
          "available": true,
          "variantId": "43944908390685"
        }
      ],
      "120x120": [
        {
          "handle": "schattenfugen-rahmen-set-120x120-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-120x120-cm-roh",
            "en": "floating-frame-set-120x120-cm-unfinished",
            "fr": "kit-de-caisse-americaine-120x120-cm-brut",
            "it": "set-cornice-a-cassetta-120x120-cm-grezzo"
          },
          "productId": "7999093408029",
          "family": "shadow",
          "variantIds": [
            "43727852044573"
          ],
          "available": true,
          "variantId": "43727852044573"
        },
        {
          "handle": "bespannter-keilrahmen-120x120-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-120x120-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-120-x-120-cm-gallery-quality",
            "fr": "chassis-entoile-120-x-120-cm-qualite-galerie",
            "it": "telaio-telato-120-x-120-cm-qualita-gallery"
          },
          "productId": "7999228838173",
          "family": "gallery",
          "variantIds": [
            "43728123592989"
          ],
          "available": true,
          "variantId": "43728123592989"
        },
        {
          "handle": "bespannte-keilrahmen",
          "handles": {
            "de": "bespannte-keilrahmen",
            "en": "stretched-canvases",
            "fr": "chassis-entoiles",
            "it": "tele-per-pittura"
          },
          "productId": "9582306165021",
          "family": "studio",
          "variantIds": [
            "50079645597981"
          ],
          "available": true,
          "variantId": "50079645597981"
        },
        {
          "handle": "keilrahmen-120x120-cm-4cm",
          "handles": {
            "de": "keilrahmen-120x120-cm-4cm",
            "en": "canvas-frame-120x120-cm-4cm",
            "fr": "chassis-120x120-cm-4cm",
            "it": "telaio-120x120-cm-4cm"
          },
          "productId": "7999415845149",
          "family": "bars",
          "variantIds": [
            "43944908914973"
          ],
          "available": true,
          "variantId": "43944908914973"
        }
      ],
      "120x130": [
        {
          "handle": "bespannter-keilrahmen-120x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-120x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-120-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-120-x-130-cm-qualite-galerie",
            "it": "telaio-telato-120-x-130-cm-qualita-gallery"
          },
          "productId": "7999229198621",
          "family": "gallery",
          "variantIds": [
            "43728124018973"
          ],
          "available": true,
          "variantId": "43728124018973"
        },
        {
          "handle": "keilrahmen-120x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-120x130-cm-4cm",
            "en": "canvas-frame-120x130-cm-4cm",
            "fr": "chassis-120x130-cm-4cm",
            "it": "telaio-120x130-cm-4cm"
          },
          "productId": "7999416467741",
          "family": "bars",
          "variantIds": [
            "43944909865245"
          ],
          "available": true,
          "variantId": "43944909865245"
        }
      ],
      "120x140": [
        {
          "handle": "schattenfugen-rahmen-set-120x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-120x140-cm-roh",
            "en": "floating-frame-set-120x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-120x140-cm-brut",
            "it": "set-cornice-a-cassetta-120x140-cm-grezzo"
          },
          "productId": "7999094096157",
          "family": "shadow",
          "variantIds": [
            "43727853617437"
          ],
          "available": false,
          "variantId": "43727853617437"
        },
        {
          "handle": "bespannter-keilrahmen-120x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-120x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-120-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-120-x-140-cm-qualite-galerie",
            "it": "telaio-telato-120-x-140-cm-qualita-gallery"
          },
          "productId": "7999229788445",
          "family": "gallery",
          "variantIds": [
            "43728125853981"
          ],
          "available": true,
          "variantId": "43728125853981"
        },
        {
          "handle": "keilrahmen-120x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-120x140-cm-4cm",
            "en": "canvas-frame-120x140-cm-4cm",
            "fr": "chassis-120x140-cm-4cm",
            "it": "telaio-120x140-cm-4cm"
          },
          "productId": "7999417057565",
          "family": "bars",
          "variantIds": [
            "43944910520605"
          ],
          "available": true,
          "variantId": "43944910520605"
        }
      ],
      "120x150": [
        {
          "handle": "bespannter-keilrahmen-120x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-120x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-120-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-120-x-150-cm-qualite-galerie",
            "it": "telaio-telato-120-x-150-cm-qualita-gallery"
          },
          "productId": "7999230411037",
          "family": "gallery",
          "variantIds": [
            "43728126574877"
          ],
          "available": true,
          "variantId": "43728126574877"
        },
        {
          "handle": "keilrahmen-120x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-120x150-cm-4cm",
            "en": "canvas-frame-120x150-cm-4cm",
            "fr": "chassis-120x150-cm-4cm",
            "it": "telaio-120x150-cm-4cm"
          },
          "productId": "7999417614621",
          "family": "bars",
          "variantIds": [
            "43944911077661"
          ],
          "available": true,
          "variantId": "43944911077661"
        }
      ],
      "120x160": [
        {
          "handle": "bespannter-keilrahmen-120x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-120x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-120-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-120-x-160-cm-qualite-galerie",
            "it": "telaio-telato-120-x-160-cm-qualita-gallery"
          },
          "productId": "7999231459613",
          "family": "gallery",
          "variantIds": [
            "43728128180509"
          ],
          "available": true,
          "variantId": "43728128180509"
        },
        {
          "handle": "keilrahmen-120x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-120x160-cm-4cm",
            "en": "canvas-frame-120x160-cm-4cm",
            "fr": "chassis-120x160-cm-4cm",
            "it": "telaio-120x160-cm-4cm"
          },
          "productId": "7999418237213",
          "family": "bars",
          "variantIds": [
            "43944912060701"
          ],
          "available": true,
          "variantId": "43944912060701"
        }
      ],
      "120x170": [
        {
          "handle": "bespannter-keilrahmen-120x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-120x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-120-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-120-x-170-cm-qualite-galerie",
            "it": "telaio-telato-120-x-170-cm-qualita-gallery"
          },
          "productId": "7999232475421",
          "family": "gallery",
          "variantIds": [
            "43728129753373"
          ],
          "available": true,
          "variantId": "43728129753373"
        },
        {
          "handle": "keilrahmen-120x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-120x170-cm-4cm",
            "en": "canvas-frame-120x170-cm-4cm",
            "fr": "chassis-120x170-cm-4cm",
            "it": "telaio-120x170-cm-4cm"
          },
          "productId": "7999418663197",
          "family": "bars",
          "variantIds": [
            "43944912519453"
          ],
          "available": true,
          "variantId": "43944912519453"
        }
      ],
      "120x180": [
        {
          "handle": "bespannter-keilrahmen-120x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-120x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-120-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-120-x-180-cm-qualite-galerie",
            "it": "telaio-telato-120-x-180-cm-qualita-gallery"
          },
          "productId": "7999233491229",
          "family": "gallery",
          "variantIds": [
            "43728131293469"
          ],
          "available": true,
          "variantId": "43728131293469"
        },
        {
          "handle": "keilrahmen-120x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-120x180-cm-4cm",
            "en": "canvas-frame-120x180-cm-4cm",
            "fr": "chassis-120x180-cm-4cm",
            "it": "telaio-120x180-cm-4cm"
          },
          "productId": "7999419253021",
          "family": "bars",
          "variantIds": [
            "43944913502493"
          ],
          "available": true,
          "variantId": "43944913502493"
        }
      ],
      "120x195": [
        {
          "handle": "bespannter-keilrahmen-120x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-120x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-120-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-120-x-195-cm-qualite-galerie",
            "it": "telaio-telato-120-x-195-cm-qualita-gallery"
          },
          "productId": "7999234441501",
          "family": "gallery",
          "variantIds": [
            "43728134111517"
          ],
          "available": true,
          "variantId": "43728134111517"
        },
        {
          "handle": "keilrahmen-120x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-120x195-cm-4cm",
            "en": "canvas-frame-120x195-cm-4cm",
            "fr": "chassis-120x195-cm-4cm",
            "it": "telaio-120x195-cm-4cm"
          },
          "productId": "7999419777309",
          "family": "bars",
          "variantIds": [
            "43944914026781"
          ],
          "available": true,
          "variantId": "43944914026781"
        }
      ],
      "130x130": [
        {
          "handle": "bespannter-keilrahmen-130x130-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-130x130-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-130-x-130-cm-gallery-quality",
            "fr": "chassis-entoile-130-x-130-cm-qualite-galerie",
            "it": "telaio-telato-130-x-130-cm-qualita-gallery"
          },
          "productId": "7999235424541",
          "family": "gallery",
          "variantIds": [
            "43728135258397"
          ],
          "available": true,
          "variantId": "43728135258397"
        },
        {
          "handle": "keilrahmen-130x130-cm-4cm",
          "handles": {
            "de": "keilrahmen-130x130-cm-4cm",
            "en": "canvas-frame-130x130-cm-4cm",
            "fr": "chassis-130x130-cm-4cm",
            "it": "telaio-130x130-cm-4cm"
          },
          "productId": "7999420563741",
          "family": "bars",
          "variantIds": [
            "43944914911517"
          ],
          "available": true,
          "variantId": "43944914911517"
        }
      ],
      "130x140": [
        {
          "handle": "bespannter-keilrahmen-130x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-130x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-130-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-130-x-140-cm-qualite-galerie",
            "it": "telaio-telato-130-x-140-cm-qualita-gallery"
          },
          "productId": "7999236210973",
          "family": "gallery",
          "variantIds": [
            "43728139747613"
          ],
          "available": true,
          "variantId": "43728139747613"
        },
        {
          "handle": "keilrahmen-130x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-130x140-cm-4cm",
            "en": "canvas-frame-130x140-cm-4cm",
            "fr": "chassis-130x140-cm-4cm",
            "it": "telaio-130x140-cm-4cm"
          },
          "productId": "7999421120797",
          "family": "bars",
          "variantIds": [
            "43944915501341"
          ],
          "available": true,
          "variantId": "43944915501341"
        }
      ],
      "130x150": [
        {
          "handle": "bespannter-keilrahmen-130x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-130x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-130-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-130-x-150-cm-qualite-galerie",
            "it": "telaio-telato-130-x-150-cm-qualita-gallery"
          },
          "productId": "7999237161245",
          "family": "gallery",
          "variantIds": [
            "43728141549853"
          ],
          "available": true,
          "variantId": "43728141549853"
        },
        {
          "handle": "keilrahmen-130x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-130x150-cm-4cm",
            "en": "canvas-frame-130x150-cm-4cm",
            "fr": "chassis-130x150-cm-4cm",
            "it": "telaio-130x150-cm-4cm"
          },
          "productId": "7999421612317",
          "family": "bars",
          "variantIds": [
            "43944917467421"
          ],
          "available": true,
          "variantId": "43944917467421"
        }
      ],
      "130x160": [
        {
          "handle": "bespannter-keilrahmen-130x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-130x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-130-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-130-x-160-cm-qualite-galerie",
            "it": "telaio-telato-130-x-160-cm-qualita-gallery"
          },
          "productId": "7999238209821",
          "family": "gallery",
          "variantIds": [
            "43728147218717"
          ],
          "available": true,
          "variantId": "43728147218717"
        },
        {
          "handle": "keilrahmen-130x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-130x160-cm-4cm",
            "en": "canvas-frame-130x160-cm-4cm",
            "fr": "chassis-130x160-cm-4cm",
            "it": "telaio-130x160-cm-4cm"
          },
          "productId": "7999422103837",
          "family": "bars",
          "variantIds": [
            "43944917991709"
          ],
          "available": true,
          "variantId": "43944917991709"
        }
      ],
      "130x170": [
        {
          "handle": "bespannter-keilrahmen-130x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-130x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-130-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-130-x-170-cm-qualite-galerie",
            "it": "telaio-telato-130-x-170-cm-qualita-gallery"
          },
          "productId": "7999239455005",
          "family": "gallery",
          "variantIds": [
            "43728149250333"
          ],
          "available": true,
          "variantId": "43728149250333"
        },
        {
          "handle": "keilrahmen-130x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-130x170-cm-4cm",
            "en": "canvas-frame-130x170-cm-4cm",
            "fr": "chassis-130x170-cm-4cm",
            "it": "telaio-130x170-cm-4cm"
          },
          "productId": "7999422759197",
          "family": "bars",
          "variantIds": [
            "43944918876445"
          ],
          "available": true,
          "variantId": "43944918876445"
        }
      ],
      "130x180": [
        {
          "handle": "bespannter-keilrahmen-130x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-130x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-130-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-130-x-180-cm-qualite-galerie",
            "it": "telaio-telato-130-x-180-cm-qualita-gallery"
          },
          "productId": "7999240208669",
          "family": "gallery",
          "variantIds": [
            "43728150003997"
          ],
          "available": true,
          "variantId": "43728150003997"
        },
        {
          "handle": "keilrahmen-130x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-130x180-cm-4cm",
            "en": "canvas-frame-130x180-cm-4cm",
            "fr": "chassis-130x180-cm-4cm",
            "it": "telaio-130x180-cm-4cm"
          },
          "productId": "7999423217949",
          "family": "bars",
          "variantIds": [
            "43944919335197"
          ],
          "available": true,
          "variantId": "43944919335197"
        }
      ],
      "130x195": [
        {
          "handle": "bespannter-keilrahmen-130x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-130x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-130-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-130-x-195-cm-qualite-galerie",
            "it": "telaio-telato-130-x-195-cm-qualita-gallery"
          },
          "productId": "7999241257245",
          "family": "gallery",
          "variantIds": [
            "43728151347485"
          ],
          "available": true,
          "variantId": "43728151347485"
        },
        {
          "handle": "keilrahmen-130x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-130x195-cm-4cm",
            "en": "canvas-frame-130x195-cm-4cm",
            "fr": "chassis-130x195-cm-4cm",
            "it": "telaio-130x195-cm-4cm"
          },
          "productId": "7999423676701",
          "family": "bars",
          "variantIds": [
            "43944920383773"
          ],
          "available": true,
          "variantId": "43944920383773"
        }
      ],
      "140x140": [
        {
          "handle": "schattenfugen-rahmen-set-140x140-cm-roh",
          "handles": {
            "de": "schattenfugen-rahmen-set-140x140-cm-roh",
            "en": "floating-frame-set-140x140-cm-unfinished",
            "fr": "kit-de-caisse-americaine-140x140-cm-brut",
            "it": "set-cornice-a-cassetta-140x140-cm-grezzo"
          },
          "productId": "7999094882589",
          "family": "shadow",
          "variantIds": [
            "43727855747357"
          ],
          "available": false,
          "variantId": "43727855747357"
        },
        {
          "handle": "bespannter-keilrahmen-140x140-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-140x140-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-140-x-140-cm-gallery-quality",
            "fr": "chassis-entoile-140-x-140-cm-qualite-galerie",
            "it": "telaio-telato-140-x-140-cm-qualita-gallery"
          },
          "productId": "7999242305821",
          "family": "gallery",
          "variantIds": [
            "43728153772317"
          ],
          "available": true,
          "variantId": "43728153772317"
        },
        {
          "handle": "keilrahmen-140x140-cm-4cm",
          "handles": {
            "de": "keilrahmen-140x140-cm-4cm",
            "en": "canvas-frame-140x140-cm-4cm",
            "fr": "chassis-140x140-cm-4cm",
            "it": "telaio-140x140-cm-4cm"
          },
          "productId": "7999424233757",
          "family": "bars",
          "variantIds": [
            "43944920973597"
          ],
          "available": true,
          "variantId": "43944920973597"
        }
      ],
      "140x150": [
        {
          "handle": "bespannter-keilrahmen-140x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-140x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-140-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-140-x-150-cm-qualite-galerie",
            "it": "telaio-telato-140-x-150-cm-qualita-gallery"
          },
          "productId": "7999243223325",
          "family": "gallery",
          "variantIds": [
            "43728155214109"
          ],
          "available": true,
          "variantId": "43728155214109"
        },
        {
          "handle": "keilrahmen-140x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-140x150-cm-4cm",
            "en": "canvas-frame-140x150-cm-4cm",
            "fr": "chassis-140x150-cm-4cm",
            "it": "telaio-140x150-cm-4cm"
          },
          "productId": "7999424659741",
          "family": "bars",
          "variantIds": [
            "43944921399581"
          ],
          "available": true,
          "variantId": "43944921399581"
        }
      ],
      "140x160": [
        {
          "handle": "bespannter-keilrahmen-140x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-140x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-140-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-140-x-160-cm-qualite-galerie",
            "it": "telaio-telato-140-x-160-cm-qualita-gallery"
          },
          "productId": "7999243976989",
          "family": "gallery",
          "variantIds": [
            "43728155967773"
          ],
          "available": true,
          "variantId": "43728155967773"
        },
        {
          "handle": "keilrahmen-140x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-140x160-cm-4cm",
            "en": "canvas-frame-140x160-cm-4cm",
            "fr": "chassis-140x160-cm-4cm",
            "it": "telaio-140x160-cm-4cm"
          },
          "productId": "7999425085725",
          "family": "bars",
          "variantIds": [
            "43944921923869"
          ],
          "available": true,
          "variantId": "43944921923869"
        }
      ],
      "140x170": [
        {
          "handle": "bespannter-keilrahmen-140x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-140x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-140-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-140-x-170-cm-qualite-galerie",
            "it": "telaio-telato-140-x-170-cm-qualita-gallery"
          },
          "productId": "7999244828957",
          "family": "gallery",
          "variantIds": [
            "43728156950813"
          ],
          "available": true,
          "variantId": "43728156950813"
        },
        {
          "handle": "keilrahmen-140x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-140x170-cm-4cm",
            "en": "canvas-frame-140x170-cm-4cm",
            "fr": "chassis-140x170-cm-4cm",
            "it": "telaio-140x170-cm-4cm"
          },
          "productId": "7999425478941",
          "family": "bars",
          "variantIds": [
            "43944922972445"
          ],
          "available": true,
          "variantId": "43944922972445"
        }
      ],
      "140x180": [
        {
          "handle": "bespannter-keilrahmen-140x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-140x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-140-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-140-x-180-cm-qualite-galerie",
            "it": "telaio-telato-140-x-180-cm-qualita-gallery"
          },
          "productId": "7999245648157",
          "family": "gallery",
          "variantIds": [
            "43728157999389"
          ],
          "available": true,
          "variantId": "43728157999389"
        },
        {
          "handle": "keilrahmen-140x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-140x180-cm-4cm",
            "en": "canvas-frame-140x180-cm-4cm",
            "fr": "chassis-140x180-cm-4cm",
            "it": "telaio-140x180-cm-4cm"
          },
          "productId": "7999425872157",
          "family": "bars",
          "variantIds": [
            "43944923365661"
          ],
          "available": true,
          "variantId": "43944923365661"
        }
      ],
      "140x195": [
        {
          "handle": "bespannter-keilrahmen-140x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-140x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-140-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-140-x-195-cm-qualite-galerie",
            "it": "telaio-telato-140-x-195-cm-qualita-gallery"
          },
          "productId": "7999246631197",
          "family": "gallery",
          "variantIds": [
            "43728159113501"
          ],
          "available": true,
          "variantId": "43728159113501"
        },
        {
          "handle": "keilrahmen-140x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-140x195-cm-4cm",
            "en": "canvas-frame-140x195-cm-4cm",
            "fr": "chassis-140x195-cm-4cm",
            "it": "telaio-140x195-cm-4cm"
          },
          "productId": "7999426396445",
          "family": "bars",
          "variantIds": [
            "43944923889949"
          ],
          "available": true,
          "variantId": "43944923889949"
        }
      ],
      "150x150": [
        {
          "handle": "bespannter-keilrahmen-150x150-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-150x150-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-150-x-150-cm-gallery-quality",
            "fr": "chassis-entoile-150-x-150-cm-qualite-galerie",
            "it": "telaio-telato-150-x-150-cm-qualita-gallery"
          },
          "productId": "7999247384861",
          "family": "gallery",
          "variantIds": [
            "43728160260381"
          ],
          "available": true,
          "variantId": "43728160260381"
        },
        {
          "handle": "keilrahmen-150x150-cm-4cm",
          "handles": {
            "de": "keilrahmen-150x150-cm-4cm",
            "en": "canvas-frame-150x150-cm-4cm",
            "fr": "chassis-150x150-cm-4cm",
            "it": "telaio-150x150-cm-4cm"
          },
          "productId": "7999426953501",
          "family": "bars",
          "variantIds": [
            "43944925167901"
          ],
          "available": true,
          "variantId": "43944925167901"
        }
      ],
      "150x160": [
        {
          "handle": "bespannter-keilrahmen-150x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-150x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-150-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-150-x-160-cm-qualite-galerie",
            "it": "telaio-telato-150-x-160-cm-qualita-gallery"
          },
          "productId": "7999248171293",
          "family": "gallery",
          "variantIds": [
            "43728162685213"
          ],
          "available": true,
          "variantId": "43728162685213"
        },
        {
          "handle": "keilrahmen-150x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-150x160-cm-4cm",
            "en": "canvas-frame-150x160-cm-4cm",
            "fr": "chassis-150x160-cm-4cm",
            "it": "telaio-150x160-cm-4cm"
          },
          "productId": "7999427412253",
          "family": "bars",
          "variantIds": [
            "43944925626653"
          ],
          "available": true,
          "variantId": "43944925626653"
        }
      ],
      "150x170": [
        {
          "handle": "bespannter-keilrahmen-150x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-150x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-150-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-150-x-170-cm-qualite-galerie",
            "it": "telaio-telato-150-x-170-cm-qualita-gallery"
          },
          "productId": "7999249121565",
          "family": "gallery",
          "variantIds": [
            "43728164421917"
          ],
          "available": true,
          "variantId": "43728164421917"
        },
        {
          "handle": "keilrahmen-150x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-150x170-cm-4cm",
            "en": "canvas-frame-150x170-cm-4cm",
            "fr": "chassis-150x170-cm-4cm",
            "it": "telaio-150x170-cm-4cm"
          },
          "productId": "7999427903773",
          "family": "bars",
          "variantIds": [
            "43944926150941"
          ],
          "available": true,
          "variantId": "43944926150941"
        }
      ],
      "150x180": [
        {
          "handle": "bespannter-keilrahmen-150x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-150x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-150-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-150-x-180-cm-qualite-galerie",
            "it": "telaio-telato-150-x-180-cm-qualita-gallery"
          },
          "productId": "7999250006301",
          "family": "gallery",
          "variantIds": [
            "43728165732637"
          ],
          "available": true,
          "variantId": "43728165732637"
        },
        {
          "handle": "keilrahmen-150x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-150x180-cm-4cm",
            "en": "canvas-frame-150x180-cm-4cm",
            "fr": "chassis-150x180-cm-4cm",
            "it": "telaio-150x180-cm-4cm"
          },
          "productId": "7999428428061",
          "family": "bars",
          "variantIds": [
            "43944926675229"
          ],
          "available": true,
          "variantId": "43944926675229"
        }
      ],
      "150x195": [
        {
          "handle": "bespannter-keilrahmen-150x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-150x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-150-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-150-x-195-cm-qualite-galerie",
            "it": "telaio-telato-150-x-195-cm-qualita-gallery"
          },
          "productId": "7999251546397",
          "family": "gallery",
          "variantIds": [
            "43728176677149"
          ],
          "available": true,
          "variantId": "43728176677149"
        },
        {
          "handle": "keilrahmen-150x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-150x195-cm-4cm",
            "en": "canvas-frame-150x195-cm-4cm",
            "fr": "chassis-150x195-cm-4cm",
            "it": "telaio-150x195-cm-4cm"
          },
          "productId": "7999429116189",
          "family": "bars",
          "variantIds": [
            "43944928313629"
          ],
          "available": true,
          "variantId": "43944928313629"
        }
      ],
      "160x160": [
        {
          "handle": "bespannter-keilrahmen-160x160-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-160x160-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-160-x-160-cm-gallery-quality",
            "fr": "chassis-entoile-160-x-160-cm-qualite-galerie",
            "it": "telaio-telato-160-x-160-cm-qualita-gallery"
          },
          "productId": "7999252594973",
          "family": "gallery",
          "variantIds": [
            "43728179921181"
          ],
          "available": true,
          "variantId": "43728179921181"
        },
        {
          "handle": "keilrahmen-160x160-cm-4cm",
          "handles": {
            "de": "keilrahmen-160x160-cm-4cm",
            "en": "canvas-frame-160x160-cm-4cm",
            "fr": "chassis-160x160-cm-4cm",
            "it": "telaio-160x160-cm-4cm"
          },
          "productId": "7999429574941",
          "family": "bars",
          "variantIds": [
            "43944928772381"
          ],
          "available": true,
          "variantId": "43944928772381"
        }
      ],
      "160x170": [
        {
          "handle": "bespannter-keilrahmen-160x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-160x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-160-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-160-x-170-cm-qualite-galerie",
            "it": "telaio-telato-160-x-170-cm-qualita-gallery"
          },
          "productId": "7999253479709",
          "family": "gallery",
          "variantIds": [
            "43728181264669"
          ],
          "available": true,
          "variantId": "43728181264669"
        },
        {
          "handle": "keilrahmen-160x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-160x170-cm-4cm",
            "en": "canvas-frame-160x170-cm-4cm",
            "fr": "chassis-160x170-cm-4cm",
            "it": "telaio-160x170-cm-4cm"
          },
          "productId": "7999430000925",
          "family": "bars",
          "variantIds": [
            "43944929198365"
          ],
          "available": true,
          "variantId": "43944929198365"
        }
      ],
      "160x180": [
        {
          "handle": "bespannter-keilrahmen-160x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-160x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-160-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-160-x-180-cm-qualite-galerie",
            "it": "telaio-telato-160-x-180-cm-qualita-gallery"
          },
          "productId": "7999254331677",
          "family": "gallery",
          "variantIds": [
            "43728183066909"
          ],
          "available": true,
          "variantId": "43728183066909"
        },
        {
          "handle": "keilrahmen-160x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-160x180-cm-4cm",
            "en": "canvas-frame-160x180-cm-4cm",
            "fr": "chassis-160x180-cm-4cm",
            "it": "telaio-160x180-cm-4cm"
          },
          "productId": "7999430590749",
          "family": "bars",
          "variantIds": [
            "43944932245789"
          ],
          "available": true,
          "variantId": "43944932245789"
        }
      ],
      "160x195": [
        {
          "handle": "bespannter-keilrahmen-160x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-160x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-160-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-160-x-195-cm-qualite-galerie",
            "it": "telaio-telato-160-x-195-cm-qualita-gallery"
          },
          "productId": "7999255478557",
          "family": "gallery",
          "variantIds": [
            "43728198664477"
          ],
          "available": true,
          "variantId": "43728198664477"
        },
        {
          "handle": "keilrahmen-160x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-160x195-cm-4cm",
            "en": "canvas-frame-160x195-cm-4cm",
            "fr": "chassis-160x195-cm-4cm",
            "it": "telaio-160x195-cm-4cm"
          },
          "productId": "7999431082269",
          "family": "bars",
          "variantIds": [
            "43944933523741"
          ],
          "available": true,
          "variantId": "43944933523741"
        }
      ],
      "170x170": [
        {
          "handle": "bespannter-keilrahmen-170x170-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-170x170-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-170-x-170-cm-gallery-quality",
            "fr": "chassis-entoile-170-x-170-cm-qualite-galerie",
            "it": "telaio-telato-170-x-170-cm-qualita-gallery"
          },
          "productId": "7999256232221",
          "family": "gallery",
          "variantIds": [
            "43728201384221"
          ],
          "available": true,
          "variantId": "43728201384221"
        },
        {
          "handle": "keilrahmen-170x170-cm-4cm",
          "handles": {
            "de": "keilrahmen-170x170-cm-4cm",
            "en": "canvas-frame-170x170-cm-4cm",
            "fr": "chassis-170x170-cm-4cm",
            "it": "telaio-170x170-cm-4cm"
          },
          "productId": "7999431639325",
          "family": "bars",
          "variantIds": [
            "43944934899997"
          ],
          "available": true,
          "variantId": "43944934899997"
        }
      ],
      "170x180": [
        {
          "handle": "bespannter-keilrahmen-170x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-170x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-170-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-170-x-180-cm-qualite-galerie",
            "it": "telaio-telato-170-x-180-cm-qualita-gallery"
          },
          "productId": "7999257215261",
          "family": "gallery",
          "variantIds": [
            "43728202400029"
          ],
          "available": true,
          "variantId": "43728202400029"
        },
        {
          "handle": "keilrahmen-170x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-170x180-cm-4cm",
            "en": "canvas-frame-170x180-cm-4cm",
            "fr": "chassis-170x180-cm-4cm",
            "it": "telaio-170x180-cm-4cm"
          },
          "productId": "7999432163613",
          "family": "bars",
          "variantIds": [
            "43944935391517"
          ],
          "available": true,
          "variantId": "43944935391517"
        }
      ],
      "170x195": [
        {
          "handle": "bespannter-keilrahmen-170x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-170x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-170-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-170-x-195-cm-qualite-galerie",
            "it": "telaio-telato-170-x-195-cm-qualita-gallery"
          },
          "productId": "7999258853661",
          "family": "gallery",
          "variantIds": [
            "43728207020317"
          ],
          "available": true,
          "variantId": "43728207020317"
        },
        {
          "handle": "keilrahmen-170x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-170x195-cm-4cm",
            "en": "canvas-frame-170x195-cm-4cm",
            "fr": "chassis-170x195-cm-4cm",
            "it": "telaio-170x195-cm-4cm"
          },
          "productId": "7999432556829",
          "family": "bars",
          "variantIds": [
            "43944935784733"
          ],
          "available": true,
          "variantId": "43944935784733"
        }
      ],
      "180x180": [
        {
          "handle": "bespannter-keilrahmen-180x180-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-180x180-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-180-x-180-cm-gallery-quality",
            "fr": "chassis-entoile-180-x-180-cm-qualite-galerie",
            "it": "telaio-telato-180-x-180-cm-qualita-gallery"
          },
          "productId": "7999259935005",
          "family": "gallery",
          "variantIds": [
            "43728208265501"
          ],
          "available": true,
          "variantId": "43728208265501"
        },
        {
          "handle": "keilrahmen-180x180-cm-4cm",
          "handles": {
            "de": "keilrahmen-180x180-cm-4cm",
            "en": "canvas-frame-180x180-cm-4cm",
            "fr": "chassis-180x180-cm-4cm",
            "it": "telaio-180x180-cm-4cm"
          },
          "productId": "7999433179421",
          "family": "bars",
          "variantIds": [
            "43944937357597"
          ],
          "available": true,
          "variantId": "43944937357597"
        }
      ],
      "180x195": [
        {
          "handle": "bespannter-keilrahmen-180x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-180x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-180-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-180-x-195-cm-qualite-galerie",
            "it": "telaio-telato-180-x-195-cm-qualita-gallery"
          },
          "productId": "7999261245725",
          "family": "gallery",
          "variantIds": [
            "43728209838365"
          ],
          "available": true,
          "variantId": "43728209838365"
        },
        {
          "handle": "keilrahmen-180x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-180x195-cm-4cm",
            "en": "canvas-frame-180x195-cm-4cm",
            "fr": "chassis-180x195-cm-4cm",
            "it": "telaio-180x195-cm-4cm"
          },
          "productId": "7999433834781",
          "family": "bars",
          "variantIds": [
            "43944938570013"
          ],
          "available": true,
          "variantId": "43944938570013"
        }
      ],
      "195x195": [
        {
          "handle": "bespannter-keilrahmen-195x195-cm-galerie-qualitat",
          "handles": {
            "de": "bespannter-keilrahmen-195x195-cm-galerie-qualitat",
            "en": "stretched-canvas-frame-195-x-195-cm-gallery-quality",
            "fr": "chassis-entoile-195-x-195-cm-qualite-galerie",
            "it": "telaio-telato-195-x-195-cm-qualita-gallery"
          },
          "productId": "7999262261533",
          "family": "gallery",
          "variantIds": [
            "43728211018013"
          ],
          "available": true,
          "variantId": "43728211018013"
        },
        {
          "handle": "keilrahmen-195x195-cm-4cm",
          "handles": {
            "de": "keilrahmen-195x195-cm-4cm",
            "en": "canvas-frame-195x195-cm-4cm",
            "fr": "chassis-195x195-cm-4cm",
            "it": "telaio-195x195-cm-4cm"
          },
          "productId": "7999434359069",
          "family": "bars",
          "variantIds": [
            "43944939094301"
          ],
          "available": true,
          "variantId": "43944939094301"
        }
      ]
    },
    "rounds": {
      "80": [
        {
          "handle": "keilrahmen-bespannt-rund",
          "handles": {
            "de": "keilrahmen-bespannt-rund",
            "en": "canvas-frame-stretched-round",
            "fr": "chassis-entoile-rond",
            "it": "telaio-telato-tondo"
          },
          "productId": "10015394398493",
          "family": "round",
          "variantIds": [
            "50551054139677"
          ],
          "available": true,
          "variantId": "50551054139677"
        }
      ],
      "90": [
        {
          "handle": "keilrahmen-bespannt-rund",
          "handles": {
            "de": "keilrahmen-bespannt-rund",
            "en": "canvas-frame-stretched-round",
            "fr": "chassis-entoile-rond",
            "it": "telaio-telato-tondo"
          },
          "productId": "10015394398493",
          "family": "round",
          "variantIds": [
            "50551054172445"
          ],
          "available": true,
          "variantId": "50551054172445"
        }
      ],
      "100": [
        {
          "handle": "keilrahmen-bespannt-rund",
          "handles": {
            "de": "keilrahmen-bespannt-rund",
            "en": "canvas-frame-stretched-round",
            "fr": "chassis-entoile-rond",
            "it": "telaio-telato-tondo"
          },
          "productId": "10015394398493",
          "family": "round",
          "variantIds": [
            "50551054205213"
          ],
          "available": true,
          "variantId": "50551054205213"
        }
      ],
      "110": [
        {
          "handle": "keilrahmen-bespannt-rund",
          "handles": {
            "de": "keilrahmen-bespannt-rund",
            "en": "canvas-frame-stretched-round",
            "fr": "chassis-entoile-rond",
            "it": "telaio-telato-tondo"
          },
          "productId": "10015394398493",
          "family": "round",
          "variantIds": [
            "50551054237981"
          ],
          "available": true,
          "variantId": "50551054237981"
        }
      ],
      "120": [
        {
          "handle": "keilrahmen-bespannt-rund",
          "handles": {
            "de": "keilrahmen-bespannt-rund",
            "en": "canvas-frame-stretched-round",
            "fr": "chassis-entoile-rond",
            "it": "telaio-telato-tondo"
          },
          "productId": "10015394398493",
          "family": "round",
          "variantIds": [
            "50551054270749"
          ],
          "available": true,
          "variantId": "50551054270749"
        }
      ],
      "130": [
        {
          "handle": "keilrahmen-bespannt-rund",
          "handles": {
            "de": "keilrahmen-bespannt-rund",
            "en": "canvas-frame-stretched-round",
            "fr": "chassis-entoile-rond",
            "it": "telaio-telato-tondo"
          },
          "productId": "10015394398493",
          "family": "round",
          "variantIds": [
            "50551054303517"
          ],
          "available": true,
          "variantId": "50551054303517"
        }
      ],
      "140": [
        {
          "handle": "keilrahmen-bespannt-rund",
          "handles": {
            "de": "keilrahmen-bespannt-rund",
            "en": "canvas-frame-stretched-round",
            "fr": "chassis-entoile-rond",
            "it": "telaio-telato-tondo"
          },
          "productId": "10015394398493",
          "family": "round",
          "variantIds": [
            "50551054336285"
          ],
          "available": true,
          "variantId": "50551054336285"
        }
      ],
      "150": [
        {
          "handle": "keilrahmen-bespannt-rund",
          "handles": {
            "de": "keilrahmen-bespannt-rund",
            "en": "canvas-frame-stretched-round",
            "fr": "chassis-entoile-rond",
            "it": "telaio-telato-tondo"
          },
          "productId": "10015394398493",
          "family": "round",
          "variantIds": [
            "50551054369053"
          ],
          "available": true,
          "variantId": "50551054369053"
        }
      ],
      "160": [
        {
          "handle": "keilrahmen-bespannt-rund",
          "handles": {
            "de": "keilrahmen-bespannt-rund",
            "en": "canvas-frame-stretched-round",
            "fr": "chassis-entoile-rond",
            "it": "telaio-telato-tondo"
          },
          "productId": "10015394398493",
          "family": "round",
          "variantIds": [
            "50551054401821"
          ],
          "available": true,
          "variantId": "50551054401821"
        }
      ],
      "170": [
        {
          "handle": "keilrahmen-bespannt-rund",
          "handles": {
            "de": "keilrahmen-bespannt-rund",
            "en": "canvas-frame-stretched-round",
            "fr": "chassis-entoile-rond",
            "it": "telaio-telato-tondo"
          },
          "productId": "10015394398493",
          "family": "round",
          "variantIds": [
            "50551054434589"
          ],
          "available": true,
          "variantId": "50551054434589"
        }
      ],
      "180": [
        {
          "handle": "keilrahmen-bespannt-rund",
          "handles": {
            "de": "keilrahmen-bespannt-rund",
            "en": "canvas-frame-stretched-round",
            "fr": "chassis-entoile-rond",
            "it": "telaio-telato-tondo"
          },
          "productId": "10015394398493",
          "family": "round",
          "variantIds": [
            "50551054467357"
          ],
          "available": true,
          "variantId": "50551054467357"
        }
      ]
    }
  }
};
})(window);
